export const deLangDashboard = {
  headerSearch: {
    placeholder: 'Produkte suchen',
    cancel: 'Abbrechen',
    empty: 'Keine Produkte gefunden',
    noShop: 'Noch keine Produkte zum Suchen',
  },
  common: {
    you: 'Du',
    post: 'Beitrag',
    article: 'Artikel',
    create: 'Erstellen',
    message: 'Nachricht',
    popular: 'Beliebt',
    emptyIntegrations: 'Du musst zuerst Integrationen hinzufügen',
    categories: 'Kategorien',
    edit: 'Bearbeiten',
    share: 'Teilen',
    plan: 'Plan',
    sort: 'Sortieren',
    addArticle: 'Artikel hinzufügen',
    articles: 'Artikel',
    users: 'Nutzer',
    scans: 'Scans',
    clicks: 'Klicks',
    copy: 'Kopieren',
    customize: 'Anpassen',
    link: 'Link',
    save: 'Speichern',
    uploadFile: 'Datei hochladen',
    customImage: 'Eigenes Bild',
    customImageTooltip: 'Eigenes Bild hochladen',
    size: 'Größe',
    sizeTooltip: 'Schieberegler ziehen, um Größe festzulegen',
    auto: 'Auto',
    rectangle: 'Rechteck',
    custom: 'Benutzerdefiniert',
    clean: 'Leeren',
    cleaning: 'Wird geleert',
    download: 'Herunterladen',
    downloading: 'Wird heruntergeladen',
    preview: 'VORSCHAU',
    cover: 'Titelbild',
    coverTooltip: 'Titelbild hochladen',
    title: 'Titel',
    new: 'Neu',
    pro: 'Pro',
    free: 'Kostenlos',
    limit: 'Limit',
    websites: 'Webseiten',
    site: 'Seite',
    apiKey: 'API-Schlüssel',
    name: 'Name',
    passwordChange: 'Passwort ändern',
    draft: 'Entwurf',
    page: 'Seite',
    areYouSure: 'Bist du sicher?',
    drop: 'Ablegen',
    video: 'Video',
    image: 'Bild',
    chooseFile: 'Datei auswählen',
    nothingFound: 'Nichts gefunden',
    enterCorrectLink: 'Gültigen Link eingeben',
    off: 'Aus',
    disconnect: 'TRENNEN',
    connect: 'VERBINDEN',
    copied: 'Kopiert',
    saved: 'Gespeichert',
    lostConnection: 'Verbindung verloren',
    addedCategory: 'Kategorie hinzugefügt',
    none: 'Keine',
    left: 'Links',
    right: 'Rechts',
    solid: 'Durchgezogen',
    double: 'Doppelt',
    welcome: 'Willkommen',
    category: 'Kategorie',
    product: 'Produkt',
    website: 'Website',
    items: 'Elemente',
    square: 'Eckig',
    round: 'Rund',
    border: 'Rahmen',
    shadow: 'Schatten',
    subtle: 'Dezent',
    soft: 'Weich',
    hard: 'Hart',
    block: 'Block',
    primary: 'Primär',
    additional: 'Zusätzlich',
    normal: 'Normal',
    bold: 'Fett',
    uploadVideo: 'Video hochladen',
    compact: 'Kompakt',
    card: 'Karte',
    top: 'Oben',
    center: 'Mitte',
    bottom: 'Unten',
    button: 'Schaltfläche',
    addNewItem: 'Neues Element hinzufügen',
    price: 'Preis',
    priceCaption: 'Preis deines Produkts hinzufügen',
    oldPrice: 'Alter Preis',
    oldPriceCaption: 'Alter Preis wird durchgestrichen',
    areYouSureDeleteItem: 'Möchtest du dieses Element wirklich entfernen?',
    add: 'Hinzufügen',
    active: 'Aktiv',
    isActive: 'ist aktiv',
    isDisabled: 'ist deaktiviert',
    uploadImage: 'Bild hochladen',
    design: 'Design',
    addAccount: 'Konto hinzufügen',
    hey: 'Hey',
    activeBackground: 'Aktiver Hintergrund',
    activeText: 'Aktiver Text',
    connectDomain: 'Domain verbinden',
    shortLink: 'Kurzlink',
    appearanceSaved: 'Erscheinungsbild gespeichert!',
    blockAdded: 'Block hinzugefügt!',
    comingSoon: 'Demnächst verfügbar',
    easyMoney: 'Einfaches Geld',
    content: 'Inhalt',
    audience: 'Zielgruppe',
    view: 'Ansehen',
    delete: 'Löschen',
    file: 'Datei',
    type: 'Typ',
    from: 'Von',
    to: 'Bis',
    fullName: 'Vollständiger Name',
    lastTimeUsed: 'Zuletzt verwendet',
    noMediaFiles: 'Noch keine Mediendateien...',
    withdraw: 'Auszahlen',
    congrats: 'Glückwunsch!',
    makeMoneyOnline: 'Online Geld verdienen!',
    thin: 'Dünn',
    blockEmptyTitle: 'Noch nichts hier',
    blockEmptyText: 'Dieser Block hat noch keine Elemente. Füge eines hinzu, um es auf deiner Seite zu sehen.',
    noItemsTitle: 'Du hast noch keine Elemente',
    noItemsText: 'Füge dein erstes Element hinzu, um diesen Block zu füllen.',
  },
  sort: {
    title: 'Sortieren',
    search: 'Suchen',
    default: 'Standardsortierung',
    dateNew: 'Datum: Neueste zuerst',
    dateOld: 'Datum: Älteste zuerst',
    priceLow: 'Preis: Aufsteigend',
    priceHigh: 'Preis: Absteigend',
    nameA: 'Name: A bis Z',
    nameZ: 'Name: Z bis A',
    popular: 'Beliebteste',
  },
  emailMenu: {
    broadcasts: 'Newsletter',
    automations: 'Automatisierungen',
    templates: 'Vorlagen',
    settings: 'Einstellungen',
    noEmails: 'Noch keine E-Mails',
    newBroadcast: 'Neue Newsletter',
  },
  aiContent: {
    title: 'Erstelle deine erste KI-Inhalte!',
    text: 'Plane und veröffentliche Inhalte auf allen sozialen Netzwerken gleichzeitig!',
    create: 'KI-Inhalte erstellen',
  },
  pageDesign: {
    page: 'Seitendesign',
    image: 'Bild',
  },
  toolsMenu: {
    title: 'Tools',
    account: 'Konto',
    instantPages: 'Instant Pages',
    instantPagesText: 'Schnell ladende eigenständige Seiten',
    agents: 'Agents',
    agentsText: 'KI-Assistenten, die dein Profil verwalten',
    socialPlanner: 'Social Planner',
    socialPlannerText: 'Content-Planung und Inspiration',
    emailMarketing: 'E-Mail-Marketing',
    emailMarketingText: 'Erweitere deine Kontaktliste',
    smartReply: 'Instagram Reply',
    smartReplyText: 'Automatisierte Kommentare & Nachrichten senden',
    linkShortener: 'Kurzlinks',
    linkShortenerText: 'Lange URLs kürzen',
    posts: 'Beiträge',
    postsText: 'Beiträge erstellen und verwalten',
    blog: 'Blog',
    blogText: 'Blogartikel erstellen und verwalten',
  },
  insideMenu: {
    planner: 'Planer',
    aiContent: 'KI-Inhalte',
    aiPosts: 'KI-Beiträge',
    postIdeas: 'Beitragsideen',
    contentPlanner: 'Content-Planer',
    aiImages: 'KI-Bilder',
    brandProjects: 'Brand Identity',
    aiVideo: 'KI-Video',
    integrations: 'Integrationen',
    products: 'Produkte',
    orders: 'Bestellungen',
    payments: 'Zahlungen',
    links: 'Links',
    qrCodes: 'QR-Codes',
    adBuilder: 'Anzeigen-Builder',
  },
  orders: {
    title: 'Bestellungen',
    empty: 'Du hast noch keine Bestellungen',
    all: 'Alle Bestellungen',
    shop: 'Shop',
    digital: 'Digitale Produkte',
    appointments: 'Termine',
    services: 'Services',
    donations: 'Spenden',
  },
  discounts: {
    title: 'Rabatte',
    newDiscount: '+ Neuer Rabatt',
    code: 'Code',
    titleCol: 'Titel',
    type: 'Typ',
    value: 'Wert',
    status: 'Status',
    used: 'Verwendet',
    actions: 'Aktionen',
    statusAll: 'Alle Status',
    statusActive: 'Aktiv',
    statusExpired: 'Abgelaufen',
    statusScheduled: 'Geplant',
    statusInactive: 'Inaktiv',
    searchPlaceholder: 'Nach Code oder Titel suchen...',
    clearFilters: 'Filter zurücksetzen',
    emptyTitle: 'Noch keine Rabatte',
    emptySubtitle: 'Erstelle deinen ersten Promo-Code, um Rabatte auf deine Produkte anzubieten',
    createDiscount: 'Rabatt erstellen',
    createTitle: 'Rabatt erstellen',
    editTitle: 'Rabatt bearbeiten',
    fieldTitle: 'Titel',
    fieldTitlePlaceholder: 'z. B. Frühlingsangebot',
    fieldCode: 'Code',
    fieldCodePlaceholder: 'z. B. SAVE20',
    generate: 'Generieren',
    sectionDiscount: 'Rabatt',
    fieldType: 'Typ',
    typePercentage: 'Prozent',
    typeFixed: 'Fester Betrag',
    typeFreeShipping: 'Kostenloser Versand',
    fieldValue: 'Wert',
    sectionConditions: 'Bedingungen (optional)',
    appliesTo: 'Gilt für',
    appliesToAll: 'Alle Produkte',
    appliesToShop: 'Shop',
    appliesToDigital: 'Digital',
    appliesToCourses: 'Kurse',
    appliesToServices: 'Services',
    appliesToEvents: 'Events',
    minOrderAmount: 'Mindestbestellwert ($)',
    maxDiscountAmount: 'Maximaler Rabattbetrag ($) — 0 = kein Limit',
    minItemCount: 'Min. Artikel pro Bestellung — 0 = keine Anforderung',
    specificProducts: 'Bestimmte Produkte — leer = alle',
    specificProductsPlaceholder: 'Produkte suchen...',
    noProductsFound: 'Keine Produkte gefunden',
    sectionLimits: 'Limits',
    usageLimit: 'Gesamtnutzungslimit — 0 = unbegrenzt',
    usageLimitPerUser: 'Limit pro Kunde — 0 = unbegrenzt',
    sectionSchedule: 'Zeitplan',
    startDate: 'Startdatum — leer = startet sofort',
    endDate: 'Enddatum — leer = kein Ablauf',
    active: 'Aktiv',
    cancel: 'Abbrechen',
    save: 'Rabatt speichern',
    createdSuccess: 'Rabatt erstellt',
    updatedSuccess: 'Rabatt aktualisiert',
    deletedSuccess: 'Rabatt gelöscht',
    loadError: 'Rabatte konnten nicht geladen werden',
    saveError: 'Rabatt konnte nicht gespeichert werden',
    deleteError: 'Rabatt konnte nicht gelöscht werden',
    fieldTrigger: 'Wie es angewendet wird',
    triggerCode: 'Rabattcode',
    triggerAutomatic: 'Automatisch (ohne Code)',
    triggerAutomaticHint:
      'Wird beim Checkout automatisch angewendet, wenn die Bedingungen erfüllt sind – kein Code nötig. Lege unten einen Mindestbestellwert für einen Wertrabatt fest.',
    automaticBadge: 'Automatisch',
  },
  donation: {
    chooseSmiles: 'Smileys auswählen',
    item: 'Artikel',
    itemTitle: 'Titel des Spendenartikels',
    price: 'Preis',
    thanksMessagePlaceholder: 'Vielen Dank',
    thanksMessage: 'Dankesnachricht',
    thanksMessageCaption: 'Dankesnachricht wird deinen Fans nach der Spende angezeigt',
    addDonation: 'Spende hinzufügen',
    addAmount: '+ Betrag hinzufügen',
    buttonTitle: 'Buttontitel',
    buttonTitleCaption: 'Titel des Spendenbuttons',
    acceptDonations: 'Spenden akzeptieren',
    donationsType: 'Spenden',
    tips: 'Trinkgelder',
    type: 'Typ',
    addAnotherAmount: '+ Weiteren Betrag hinzufügen',
  },
  blog: {
    empty: 'Du hast noch keinen Blog',
  },
  apps: {
    empty: 'Du hast noch keine Apps',
  },
  payments: {
    title: 'Zahlungen',
    text: 'Du hast noch keine Transaktionen',
    single: 'Einmalzahlungen',
    subscriptions: 'Abonnements',
    wallet: 'Wallet',
    connectPromo: 'Verbinde dein Stripe- oder PayPal-Konto mit deiner UniLink-Seite und erhalte alle Zahlungen in deinem Wallet.',
    connectSystem: 'Zahlungssystem verbinden',
    manageCards: 'Karten verwalten',
    addNewCard: 'Neue Karte hinzufügen',
    editCard: 'Karteninformationen bearbeiten',
    addCard: 'Karteninformationen hinzufügen',
    cardHolder: 'Name des Karteninhabers',
    cardHolderNecessary: 'Dies ist erforderlich',
    withdrawalSuccess: 'Deine Auszahlung wurde erfolgreich übermittelt!',
    withdrawalError: 'Etwas ist schiefgelaufen, versuche es später erneut.',
    change: 'Ändern',
  },
  store: {
    emptyTitle: 'Du hast noch keine Produkte',
    emptyText: 'Beginne mit dem Hinzufügen deines ersten Produkts',
    emptyButton: 'Produkt hinzufügen',
    createFirstProduct: 'Erstelle dein erstes Produkt',
    startAdding:
      'Beginne damit, deine Lieblingsprodukte, digitalen Güter oder Dienstleistungen hinzuzufügen. Ein Bereich, in dem du alles verkaufen und bewerben kannst, was du anbietest.',
    activate: 'Shop aktivieren',
    empty: 'Du hast noch keine Produkte',
    products: 'Produkte',
    addProducts: 'Produkte hinzufügen',
    whatDoYouWant: 'Was möchtest du verkaufen?',
    externalProduct: 'Externe Produkt-URL',
    createOwnProduct: 'Eigenes Produkt erstellen',
    shop: 'Shop',
    shopText: 'Verkaufe physische und digitale Produkte',
    digital: 'Digitale Produkte',
    digitalText: 'Verkaufe einen digitalen Download',
    course: 'Kurs oder Tutorial',
    courseText: 'Kurs oder Tutorial zur Website hinzufügen',
    service: 'Dienstleistungen',
    serviceText: 'Dienstleistungen für deine Kunden hinzufügen',
    appointment: 'Termine',
    appointmentText: 'Lass Besucher Zeit in deinem Kalender buchen',
    event: 'Events oder Tickets',
    eventText: 'Erstelle ein Event und lade dein Publikum ein',
    tips: 'Trinkgeld',
    tipsText: 'Hinterlasse ein Trinkgeld für deine Lieblings-Creator',
    donation: 'Spenden',
    donationText: 'Spende leisten',
    membership: 'Mitgliedschaft',
    membershipText: 'Mitgliedschaft zur Website hinzufügen',
    links: 'Externer Link',
    linksText: 'Externen Link zu beliebigen Websites hinzufügen',
    coupon: 'Gutschein',
    couponText: 'Gutschein für deine Website hinzufügen',
    singleProduct: 'Einzelprodukt',
    singleProductText: 'Verkaufe ein einzelnes Produkt mit einem einfachen Checkout',
    booking: 'Buchung',
    bookingText: 'Lass Besucher deine Räume oder Immobilien buchen',
    rental: 'Vermietung',
    rentalText: 'Liste Mietartikel mit Verfügbarkeit und Preisen auf',
    add: 'Hinzufügen',
    manageStore: 'Shop verwalten',
    displayLast: 'Letztes Produkt anzeigen',
  },
  products: {
    info: 'Info',
    uploadCover: 'Lade ein Titelbild hoch und gib dann einen Titel und eine Beschreibung an',
    thumbnail: 'Vorschaubild',
    thumbnailError: 'Bitte füge ein Vorschaubild hinzu',
    title: 'Titel',
    titleTooltip: 'Gib den Namen deines Produkts ein',
    shortDescription: 'Kurzbeschreibung',
    shortDescriptionTooltip: 'Gib eine Kurzbeschreibung deines Produkts ein',
    description: 'Beschreibung',
    descriptionTooltip: 'Gib eine Beschreibung deines Produkts ein',
    descriptionTooltipExtra: 'Optionale Beschreibung der Produktmerkmale, Typen, Farben, Größen usw.',
    price: 'Preis',
    priceTooltip: 'Gib den Preis deines Produkts ein',
    oldPrice: 'Alter Preis',
    oldPriceTooltip: 'Der alte Preis wird durchgestrichen',
    category: 'Kategorie',
    categoryTooltip: 'Wähle die Kategorie deines Produkts',
    image: 'Bild',
    imageTooltip: 'Lade ein Bild für dein Produkt hoch',
    groups: 'Gruppen',
    rate: 'Bewertung',
    rateTooltip: 'Gib die Bewertung deines Produkts ein',
    buttonTitle: 'Button-Titel',
    buttonTitleTooltip: 'Gib den Titel deines Produkt-Buttons ein',
    limitQuantity: 'Menge begrenzen',
    itemsLeft: 'Verbleibende Artikel',
    itemsLeftTooltip: 'Artikel deines Produkts',
    trackStock: 'Bestand verfolgen',
    stockQuantity: 'Lagerbestand',
    stockQuantityTooltip: 'Aktuell verfügbare Einheiten. Wird mit jeder bezahlten Bestellung automatisch reduziert; bei 0 kann das Produkt nicht mehr gekauft werden.',
    lowStockThreshold: 'Warnung bei niedrigem Bestand',
    lowStockThresholdTooltip: 'Benachrichtigung erhalten, wenn der Bestand diesen Wert oder weniger erreicht.',
    maxOrderQuantity: 'Maximale Bestellmenge',
    maxOrderQuantityTooltip: 'Maximale Anzahl an Einheiten pro Bestellung. Leer lassen für keine Begrenzung.',
    minOrderQuantity: 'Mindestbestellmenge',
    minOrderQuantityTooltip: 'Mindestanzahl an Einheiten pro Bestellung. Leer lassen für keine Begrenzung.',
    attachments: 'Anhänge',
    addAttachments: 'Füge deinen Produkten Anhänge hinzu',
    addNewAttachment: 'Neues Element hinzufügen',
    file: 'Datei',
    uploadFile: 'Datei hochladen',
    uploadCoverTitle: 'Titelbild hochladen',
    optionalDescription: 'Optionale Beschreibung der Produktmerkmale, Typen, Farben, Größen usw.',
    customReviews: 'Eigene Bewertungen',
    addCustomReviews: 'Füge deinen Produkten Bewertungen hinzu',
    name: 'Name',
    nameTooltip: 'Gib den Namen deines Kunden ein',
    comment: 'Kommentar',
    commentTooltip: 'Gib den Kommentar deines Kunden ein',
    rateTooltipCustomer: 'Bewertung des Kunden',
    imageTooltipCustomer: 'Bild deines Kunden hochladen',
    displayPriceOnPreview: 'Preis in Vorschau anzeigen',
    displayDetailsOnPreview: 'Details in Vorschau anzeigen',
    postOnSocials: 'In sozialen Netzwerken posten',
    sendAnEmail: 'E-Mail senden',
    highlights: 'Highlights',
    listProductSetup: 'Produkt einstellen und Shop-Block einrichten',
    whereToSell: 'Wo möchtest du dieses Produkt verkaufen?',
    youHaveProducts: 'Du hast {count} Produkte',
    shareThisProduct: 'Dieses Produkt teilen',
    shareAProduct: 'Produkt teilen',
    monetizeWays: 'Verschiedene Wege, mit Unilink Geld zu verdienen',
    addProductToProfile: '{title} zu deinem Profil hinzufügen',
    productPage: 'Produktseite',
    setUpPayments: 'Zahlungen einrichten',
    connectPaymentMethods: 'Verbinde deine Zahlungsmethoden, um auf Unilink Geld zu verdienen',
    addPaymentMethod: '{type}-Zahlungsmethode hinzufügen, um Zahlungen von Followern zu erhalten',
    withdrawAttempt: 'Dies ist ein Versuch, eine Forderung einzuziehen, und alle Informationen werden zu diesem Zweck verwendet.',
    withdrawSuccess: 'Deine Auszahlung wurde erfolgreich übermittelt!',
    yourVisitorsPay: 'Deine Besucher zahlen zuerst und werden dann zu {method} weitergeleitet',
    emailAddress: 'E-Mail-Adresse',
    calendlyLink: 'Calendly-Link',
    features: 'Vorteile',
    featuresTooltip: 'Vorteils-Checkliste, die im Showcase-Kartenlayout angezeigt wird',
    featurePlaceholder: 'Vorteil',
    addFeature: 'Vorteil hinzufügen',
    pendingReviews: {
      title: 'Ausstehende Bewertungen',
      subtitle: 'Käuferbewertungen freigeben oder ausblenden, bevor sie öffentlich erscheinen',
      empty: 'Keine Bewertungen zur Moderation.',
      approve: 'Freigeben',
      hide: 'Ausblenden',
    },
  },
  posts: {
    posts: 'Beiträge',
    title: 'Erstelle deinen ersten Beitrag',
    description: 'In Beiträgen erstellst du Chat-Automatisierungen einfach und visuell. Probiere ein paar Automatisierungen aus, die wir basierend auf deinen Zielen empfehlen',
    activate: 'Beiträge aktivieren',
    managePosts: 'Beiträge verwalten',
    postsTab: 'Beiträge-Tab',
    displayLast: 'Letzte Beiträge anzeigen',
    tabNavigation: 'Tab-Navigationseinstellungen',
    createFirstPost: 'Erstelle deinen ersten Social-Media-Beitrag!',
    autoPostsText: 'Plane und veröffentliche Inhalte auf allen sozialen Netzwerken gleichzeitig!',
    createPost: 'Beitrag erstellen',
  },
  messages: {
    title: 'Nachrichten',
    empty: 'Keine Nachrichten',
    addText: 'Füge dem Header-Block eine Nachrichten-Schaltfläche hinzu, damit Nutzer dir einfach eine Nachricht senden können.',
    addButton: 'Nachrichten-Schaltfläche hinzufügen',
  },
  smartReply: {
    title: 'Instagram Reply',
    clicks: 'Klicks',
    createTitle: 'Erstelle deine erste Instagram Reply!',
    text: 'Nutze automatische Instagram-DMs, um Links automatisch mit deinem Publikum zu teilen!',
    createButton: 'Auto-DM erstellen',
    subtitleComment: 'Automatische DM mit Link als Antwort auf einen Kommentar',
    subtitleDm: 'Automatische DM als Antwort auf eine Nachricht oder Story',
    ready: 'bereit',
    edit: 'Bearbeiten',
    stepContentTitle: 'IG-Inhalt',
    stepContentSub: 'Wähle einen Beitrag oder Reel',
    storiesAndDmsSub: 'Auto-DM, wenn jemand auf eine Story antwortet oder dir schreibt',
    stepTriggerTitle: 'Auslöser',
    stepTriggerSub: 'Schlüsselwörter in Kommentaren',
    stepTriggerSubDm: 'Schlüsselwörter in Nachrichten',
    stepDmTitle: 'DM',
    stepDmSub: 'Die automatisch gesendete Nachricht',
    dmSummary: 'Nachricht festgelegt',
    activatesNow: 'Die Autoantwort wird sofort aktiviert',
    saveAutomation: 'Autoantwort speichern',
    savedToast: 'Autoantwort erstellt',
    linkLabel: 'Wähle das Linkziel',
    selectDestination: 'Wähle einen Link, ein Produkt oder einen Artikel',
    change: 'Ändern',
    choose: 'Auswählen',
    remove: 'Entfernen',
    optional: 'optional',
    buttonText: 'Button-Text',
    addLink: 'Link hinzufügen',
    attachLink: 'Link anhängen',
    noLinks: 'Noch keine Links – füge zuerst einen Link in deiner Link in Bio hinzu.',
    tabLinks: 'Links',
    tabProducts: 'Produkte',
    noProducts: 'Noch keine Produkte – erstelle zuerst ein Produkt in deinem Shop.',
    tabArticles: 'Artikel',
    noArticles: 'Noch keine Artikel – erstelle zuerst einen Artikel.',
    choosePost: 'Wähle einen Beitrag oder Reel',
    searchPosts: 'Deine Beiträge durchsuchen',
    loadingPosts: 'Deine Beiträge werden geladen…',
    done: 'Fertig',
    oneSelected: '1 Beitrag ausgewählt',
    postSelected: 'Beitrag ausgewählt',
    noPosts: 'Noch keine Beiträge – veröffentliche einen Beitrag oder Reel auf Instagram.',
    postsError: 'Beiträge konnten nicht geladen werden. Bitte versuche es erneut.',
    reauthTitle: 'Einige DMs werden möglicherweise nicht zugestellt.',
    reauthText: 'Instagram erfordert eine erneute Autorisierung des Kontos.',
    reconnect: 'Erneut verbinden',
    statActive: 'Aktive Automatisierungen',
    statDmSent: 'Gesendete DMs · 30 T',
    statClicks: 'Link-Klicks',
    activeReplies: 'Aktive Autoantworten',
    filterAll: 'Alle',
    filterActive: 'Aktiv',
    filterOff: 'Aus',
  },
  businessCards: {
    title: 'Visitenkarten',
    emptyTitle: 'Erstelle deine digitale Visitenkarte',
    emptySubtitle: 'Füge deine Kontaktdaten hinzu, damit jeder sie mit einem Tippen auf seinem Telefon speichern kann – und teile sie dann per QR-Code oder .vcf-Datei.',
    createButton: 'Visitenkarte erstellen',
    sectionButton: 'Schaltfläche „Kontakt speichern“',
    sectionButtonSubtitle: 'Wie die Schaltfläche „Kontakt speichern“ aussieht und wo sie in deinem Profil erscheint.',
    showButton: 'In meinem Profil anzeigen',
    showButtonSubtitle: 'Zeige die Schaltfläche „Kontakt speichern“ auf deiner öffentlichen Seite an.',
    placement: 'Platzierung der Schaltfläche',
    placementSubtitle: 'Wähle aus, wo die Schaltfläche erscheint.',
    showInHeader: 'Im Kopfbereich anzeigen',
    placementHeader: 'Profilkopf',
    placementHeaderHint: 'Erscheint direkt unter Name und Avatar.',
    placementContact: 'Kontaktbereich',
    placementContactHint: 'Wird im Kontakte-Pop-up angezeigt.',
    placementBottom: 'Schwebende Schaltfläche',
    placementBottomHint: 'Bleibt beim Scrollen am unteren Seitenrand.',
    none: 'Keine',
    buttonLabel: 'Beschriftung der Schaltfläche',
    buttonLabelSubtitle: 'Text, der auf der Schaltfläche angezeigt wird.',
    saveContact: 'Kontakt speichern',
    sectionDetails: 'Kontaktdaten',
    sectionDetailsSubtitle: 'Diese Angaben werden auf der Kontaktkarte gespeichert.',
    delete: 'Visitenkarte löschen',
    previewHint: 'So sieht deine Karte für Besucher aus.',
    share: 'Teilen & QR',
    shareSubtitle: 'Scanne den Code oder teile den Link, um dein Profil zu öffnen.',
    download: '.vcf herunterladen',
    copyLink: 'Link kopieren',
    copied: 'Link kopiert!',
    digitalCard: 'Digitale Karte',
    physicalCard: 'Physische Karte',
    cardStyle: 'Kartenstil',
    cardStyleSubtitle: 'Lege deinen Anzeigenamen fest, wähle eine Hintergrundfarbe und füge deine Karte zu einer Wallet hinzu.',
    displayName: 'Anzeigename',
    backgroundColour: 'Hintergrundfarbe',
    addAppleWallet: 'Zu Apple Wallet hinzufügen',
    addGoogleWallet: 'Zu Google Wallet hinzufügen',
    nameLabel: 'Name',
    urlLabel: 'URL',
    walletScanTitle: 'QR-Code scannen, um in deiner Wallet zu speichern',
    walletScanSubtitle: 'Sie wird in der digitalen Wallet deines Telefons gespeichert.',
    walletUseLink: 'Oder verwende stattdessen diesen Link',
    walletComingSoonTitle: 'Fast geschafft',
    walletComingSoon: 'Wallet-Pässe sind bald verfügbar.',
    done: 'Fertig',
    physicalTitle: 'Eine physische Karte bestellen',
    physicalSubtitle: 'NFC-Visitenkarten sind bald verfügbar.',
    leadCapture: 'Kontakte sammeln',
    leadCaptureSubtitle: 'Lass Personen, die deine Karte erhalten, ihre Daten zurücksenden – direkt in deine Zielgruppe.',
    leadCaptureToggle: '„Deine Daten teilen“ aktivieren',
    leadCaptureToggleHint: 'Zeigt ein Kontaktformular auf deiner öffentlichen Karte.',
    leadTag: 'Neue Leads taggen',
    leadTagSubtitle: 'Jeder erfasste Kontakt wird hiermit getaggt (z. B. Event- oder Kampagnenname).',
    leadTagPlaceholder: 'z. B. Konferenz 2026',
    renewLink: 'Link erneuern',
    renewing: 'Wird erneuert…',
    renewConfirm: 'Karten-Link erneuern? Dein aktueller QR-Code und geteilte Links funktionieren dann nicht mehr.',
    linkRenewed: 'Karten-Link erneuert',
    scans: '{count} Scans',
  },
  shortLinks: {
    title: 'Kurzlinks',
    addLink: 'Link hinzufügen',
    name: 'Name',
    slug: 'Slug',
    slugTooltip: 'Du kannst den Slug ändern, indem du auf die Bearbeiten-Schaltfläche klickst',
    destinationUrl: 'Ziel-URL',
    metadata: 'Metadaten',
    utmTags: 'UTM-Tags',
    customizeMetadata: 'Metadaten des Links anpassen',
    metaTitle: 'Titel',
    metaDescription: 'Beschreibung',
    favicon: 'Favicon',
    imagePreview: 'Bildvorschau',
    addUtm: 'UTM-Tags zum Link hinzufügen (optional)',
    utmCampaign: 'UTM Campaign',
    utmMedium: 'UTM Medium',
    utmSource: 'UTM Source',
    utmTerm: 'UTM Term',
    utmContent: 'UTM Content',
    utmId: 'UTM Id',
    utmPlacement: 'UTM Placement',
    utmCreative: 'UTM Creative',
    pasteLink: 'Fügen Sie hier Ihren langen Link ein',
    shorten: 'Link kürzen',
    edit: 'Elementdetails bearbeiten',
  },
  audience: {
    title: 'Zielgruppe',
    total: 'Gesamt',
    totalMembers: 'Zielgruppenmitglieder gesamt',
    totalContacts: 'Kontakte gesamt',
    forms: 'Formulare',
    subscribers: 'Abonnenten',
    customers: 'Kunden',
    noAudienceMembers: 'Keine Kontakte',
    emptyAudienceMembers: 'Fügen Sie neue Kontakte hinzu, indem Sie auf die Schaltfläche klicken',
    addAudienceMember: 'Kontakt hinzufügen',
    noSubscribers: 'Keine Abonnenten',
    emptySubscribers: 'Fügen Sie neue Abonnenten hinzu, indem Sie Blöcke zu Ihrem Link in Bio hinzufügen',
    addDataCollect: 'Datenerfassungsblock hinzufügen',
    noResponses: 'Keine Antworten',
    emptyResponses: 'Fügen Sie neue Antworten hinzu, indem Sie Blöcke zu Ihrem Link in Bio hinzufügen',
    addFormBlock: 'Formularblock hinzufügen',
    noCustomers: 'Keine Kunden',
    emptyCustomers: 'Fügen Sie neue Kunden hinzu, indem Sie ein Produkt zu Ihrem Link in Bio hinzufügen',
    addProduct: 'Produkt hinzufügen',
    addContactModal: {
      title: 'Neuen Kontakt hinzufügen',
      name: 'Name',
      nameTooltip: 'Geben Sie den Namen für Ihren Kontakt ein',
      email: 'E-Mail',
      emailTooltip: 'Geben Sie die E-Mail-Adresse für Ihren Kontakt ein',
      phone: 'Telefon',
      phoneTooltip: 'Geben Sie die Telefonnummer für Ihren Kontakt ein',
      telegram: 'Telegram',
      telegramTooltip: 'Geben Sie den Telegram-Benutzernamen oder die URL für Ihren Kontakt ein',
      whatsapp: 'WhatsApp',
      whatsappTooltip: 'Geben Sie die WhatsApp-Nummer für Ihren Kontakt ein',
      instagram: 'Instagram',
      instagramTooltip: 'Geben Sie den Instagram-Benutzernamen oder die URL für Ihren Kontakt ein',
      messenger: 'Messenger',
      messengerTooltip: 'Geben Sie den Messenger-Benutzernamen oder die URL für Ihren Kontakt ein',
      viber: 'Viber',
      viberTooltip: 'Geben Sie die Viber-Nummer für Ihren Kontakt ein',
      address: 'Adresse',
      addressTooltip: 'Geben Sie die Adresse für Ihren Kontakt ein',
      add: 'Hinzufügen',
    },
    search: {
      search: 'Suche',
      error: 'Ungültiges Zeichen im Suchfeld eingegeben',
      notFound: 'Keine Ergebnisse gefunden',
    },
  },
  auth: {
    logIn: 'Anmelden',
    logInWith: 'Anmelden mit',
    signIn: 'Anmelden',
    signInWith: 'Registrieren mit',
    email: 'E-Mail',
    password: 'Passwort',
    notHaveAccount: 'Noch kein Konto?',
    createAccount: 'Neues Konto erstellen',
    createYourAccount: 'Konto erstellen',
    signUp: 'Registrieren',
    haveAccount: 'Wenn Sie bereits ein Konto haben',
    or: 'oder',
    reset: 'Zurücksetzen',
    resetPassword: 'Passwort zurücksetzen',
    resetTitle: 'Der Wiederherstellungslink wurde an Ihre E-Mail gesendet',
    goToHome: 'Zur Startseite',
    byClicking: 'Durch Klicken auf',
    youAreAgree: 'stimmen Sie den',
    terms: 'Nutzungsbedingungen',
    andConfirm: 'und unserer',
    usagePolicy: 'Nutzungsrichtlinie',
    signInGoogle: 'Mit Google anmelden',
    forgotPassword: 'Passwort vergessen?',
  },
  menu: {
    moreApps: 'Weitere Apps',
    account: 'Konto',
    more: 'Mehr',
    storyWidget: 'Stories einbetten',
    integrations: 'Integrationen',
    socialAccounts: 'Soziale Konten',
    aiContent: 'KI-Inhalte',
    aiPosts: 'KI-Beiträge',
    postIdeas: 'Beitragsideen',
    contentPlanner: 'Content-Planer',
    aiImages: 'KI-Bilder',
    aiVideo: 'KI-Video',
    planner: 'Planer',
    customers: 'Kunden',
    subscribers: 'Abonnenten',
    forms: 'Formulare',
    allAudience: 'Gesamtes Publikum',
    payments: 'Zahlungen',
    orders: 'Bestellungen',
    products: 'Produkte',
    events: 'Veranstaltungen',
    appointments: 'Termine',
    discounts: 'Rabatte',
    affiliates: 'Affiliates',
    instantPages: 'Instant Pages',
    openInNewTab: 'In neuem Tab öffnen',
    linkInBio: 'Link in Bio',
    linkInBioApps: 'Link in Bio',
    website: 'Website',
    store: 'Shop',
    audience: 'Publikum',
    emailMarketing: 'E-Mail-Marketing',
    postPlaner: 'Beitragsplaner',
    posts: 'Beiträge',
    agents: 'Agenten',
    community: 'Community',
    profileHealth: 'Profil-Status',
    socialPlanner: 'Social-Planer',
    shortLinks: 'Kurzlinks',
    businessCards: 'Visitenkarten',
    views: 'Aufrufe',
    clicks: 'Klicks',
    allWebsites: 'Alle Websites',
    createNewAccount: 'Neues Konto erstellen',
    createNewWebsite: 'Neues Profil erstellen',
    tools: 'Tools',
    borderGenerator: 'Rahmen-Generator',
    yourPlan: 'Ihr Tarif:',
    upgrade: 'Upgrade',
    accountSettings: 'Kontoeinstellungen',
    manageWebsites: 'Profile verwalten',
    updates: 'Updates',
    autoUpdate: 'Automatische Updates',
    logOut: 'Abmelden',
    myPages: 'Meine Seiten',
    design: 'Design',
    heading: 'Überschrift',
    analytics: 'Analysen',
    settings: 'Einstellungen',
    open: 'Öffnen',
    language: 'Sprache',
    siteLanguage: 'Öffentliche Website-Sprache',
    dashboardLanguage: 'Dashboard-Sprache',
    movePage: 'Seite verschieben',
    editBlock: 'Block bearbeiten',
    renameBlock: 'Block umbenennen',
    rename: 'Umbenennen',
    deleteBlock: 'Block löschen',
    archiveBlock: 'Block archivieren',
    archive: 'Archivieren',
    scheduleBlock: 'Block planen',
    copyBlock: 'Block kopieren',
    dublicateBlock: 'Block duplizieren',
    content: 'Inhalt',
    preview: 'Vorschau',
    copy: 'Kopieren',
    moveBlock: 'Block verschieben',
    move: 'Verschieben',
    edit: 'Bearbeiten',
    delete: 'Löschen',
    schedule: 'Planen',
    dublicate: 'Duplizieren',
    smartReply: 'Instagram Reply',
    marketing: 'Marketing',
    selectBlocks: 'Blöcke auswählen',
    selectAll: 'Alle auswählen',
    cancelSelection: 'Abbrechen',
    blocksSelected: 'ausgewählt',
    moveToPage: 'Auf Seite verschieben',
    newPage: 'Neue Seite',
    openPage: 'Seite öffnen',
    pageSettings: 'Seiteneinstellungen',
    deletePage: 'Seite löschen',
    appInBio: 'App in Bio',
    blog: 'Blog',
    publish: 'Veröffentlichen',
    creatorHub: 'Creator Hub',
    qrCodes: 'QR-Codes',
    apps: 'Apps',
    automations: 'Automatisierungen',
    messages: 'Posteingang',
    form: 'Formulare einbetten',
    embedTools: 'Tools einbetten',
    adBuilder: 'Anzeigen-Builder',
    emailSignatures: 'E-Mail-Signaturen',
    virtualBackgrounds: 'Virtuelle Hintergründe',
    adsCampaigns: 'Anzeigenmanager',
    thumbnail: 'Vorschaubild',
    buildFromReference: 'Aus Vorlage erstellen',
  },
  modal: {
    addInstagram: 'Instagram hinzufügen',
    addYourInstagram: 'Füge dein Instagram-Konto hinzu',
    cropYourAvatar: 'Avatar zuschneiden',
    removeSite: 'Möchtest du die Seite wirklich entfernen?',
    areYouSure: 'Möchtest du wirklich',
    areYouSureDelete: 'Möchtest du diesen Abschnitt wirklich löschen?',
    areYouSureArchive: 'Möchtest du diesen Block wirklich archivieren?',
    areYouSurePermanentDelete: 'Möchtest du diesen Block wirklich endgültig löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
    remove: 'entfernen',
    site: 'Seite',
    removeAccountText: 'dein Konto entfernen',
    moveBlock: 'Block auf eine andere Seite verschieben',
    moveBlockText: 'Dadurch wird der Block ans Ende einer anderen Seite verschoben. Anschließend kannst du den Block auf der neuen Seite neu anordnen',
    profileTitle: 'Profilbild ändern',
    profileText: 'Wähle ein Bild oder GIF von deinem Gerät.',
    profileAvatar: 'Profil-Avatar',
    addProfilePicture: 'Profilbild hinzufügen',
    storiesTitle: 'Stories',
    storiesText: 'Teile deine alltäglichen Momente.',
    thoughtsTitle: 'Gedanken',
    thoughtsText: 'Teile deine Gedanken.',
    accountPageDescription: 'Dies ist deine Kontoseite, auf der du das Aussehen deiner Seite anpassen, verschiedene Funktionsblöcke hinzufügen und vieles mehr machen kannst.',
  },
  modalSubscribe: {
    plan: 'Plan',
    usdMonth: 'USD/Monat',
    sites: 'Seiten',
    sitesMuch: 'Seiten',
    notification: 'Benachrichtigungen',
    noNotification: 'Noch keine Benachrichtigungen',
    inCategory: 'Es gibt noch keine Einträge in der',
    categoryYet: 'Kategorie.',
    externalPixels: 'Externe Pixel',
    parameters: 'Parameter',
    analyticsReports: 'Analysen & Berichte',
    noUniLinkLogo: 'Kein UniLink-Logo',
    inProfile: 'im Profil',
    verifiedBadge: 'Verifiziert-Abzeichen',
    your: 'Deine',
    customDomain: 'eigene Domain',
    emailMarketing: 'E-Mail-Marketing',
    liveSupport: 'Live-Support',
    dataSecured: 'Die Daten sind gemäß dem PCI DSS-Standard gesichert',
    thankYou: 'Vielen Dank für dein Interesse. Wir werden uns bald bei dir melden.',
    socialMediaScheduler: 'Social-Media-Planer',
    featureRequest: 'Funktionsanfrage',
    markAllRead: 'Alle als gelesen markieren',
    currentPlan: 'Aktueller Plan',
    features: 'Funktionen',
  },
  buttons: {
    upgrade: 'Plan upgraden',
    buyProPlan: 'Pro-Plan kaufen',
    continue: 'Weiter',
    skip: 'Überspringen',
    cancel: 'Abbrechen',
    confirm: 'Bestätigen',
    back: 'Zurück',
    save: 'Speichern',
    add: 'Hinzufügen',
    added: 'Hinzugefügt',
    done: 'Fertig',
    ok: 'OK',
    edit: 'Bearbeiten',
    delete: 'Löschen',
    remove: 'Entfernen',
    setAsDefault: 'Als Standard festlegen',
    subscribeNow: 'Jetzt abonnieren',
    yes: 'Ja',
    preview: 'Vorschau',
    generate: 'Generieren',
    changePassword: 'Passwort ändern',
    deleteAccount: 'Konto löschen',
    removeAccount: 'Konto entfernen',
    deleteProfile: 'Profil löschen',
    addBlock: 'Block hinzufügen',
    copyLink: 'Link kopieren',
    active: 'Aktiv',
    update: 'Aktualisieren',
    updatePro: 'Plan upgraden',
    prev: 'Zurück',
    next: 'Weiter',
    uploadImage: 'Bild hochladen',
    uploadVideo: 'Video hochladen',
    loadMore: 'Mehr laden',
    uploadProductImage: 'Produktbild hochladen',
    claim: 'Beanspruchen',
    removeSite: 'Seite entfernen',
    move: 'Verschieben',
    addButton: 'Schaltfläche hinzufügen',
    actionButton: 'Aktionsschaltfläche',
    directMessage: 'Direktnachricht',
    subscribe: 'Abonnieren',
    button: 'Schaltfläche',
    generateWithAI: 'Mit AI generieren',
    cta: 'CTA',
    cart: 'Warenkorb',
    direct: 'Direkt',
    follow: 'Folgen',
    addNewItem: 'Neues Element hinzufügen',
  },
  support: {
    liveSupport: 'Live-Support',
    response: 'Wir antworten in der Regel innerhalb von 1 Minute während der Arbeitszeiten (8:00 - 22:00 Uhr) GMT+3',
    founder: 'Denys Bilozor',
    ceo: 'Gründer und CEO von UniLink',
  },
  wizard: {
    createNewProfile: 'Neues Profil erstellen',
    createProfile: 'Profil erstellen',
    continue: 'Weiter',
    tellUs: 'Erzähl uns von dir',
    addSocialLinks: 'Füge alle sozialen Netzwerke hinzu, und wir zeigen sie in deiner Datenbank an',
    addMoreLinks: 'Weitere Links hinzufügen',
    addLink: 'Link hinzufügen',
    selectCategory: 'Wähle eine Kategorie, die dich am besten beschreibt:',
    chooseTemplate: 'Vorlage auswählen',
    skip: 'Überspringen',
    step: 'Schritt',
    of: 'von',
    yourName: 'Dein Name',
    search: 'Suchen',
    blog: 'Blog',
    creator: 'Creator',
    music: 'Musik',
    events: 'Events',
    esoteric: 'Esoterik',
    fashion: 'Mode',
    influencer: 'Influencer',
    food: 'Essen',
    smallBusiness: 'Kleinunternehmen',
    marketing: 'Marketing',
    education: 'Bildung',
    socialMedia: 'Social Media',
    coaching: 'Coaching',
    ecommerce: 'E-Commerce',
    healthAndFitness: 'Gesundheit und Fitness',
    beautyWellness: 'Beauty & Wellness',
  },
  billing: {
    back: 'Zurück',
    findPlan: 'Finde den passenden Plan',
    changeAnytime: 'Du kannst jederzeit wechseln.',
    subtitle: 'Jederzeit upgraden, downgraden oder kündigen.',
    currentPlan: 'Aktueller Tarif',
    mostPopular: 'Am beliebtesten',
    upgradeTo: 'Upgrade auf {plan}',
    includes: 'Enthält:',
    everythingIn: 'Alles aus {plan}, plus:',
    secure: 'Zahlungen werden gemäß dem PCI-DSS-Standard gesichert.',
  },
  field: {
    fullName: 'Vollständiger Name',
    username: 'Benutzername',
    addValue: 'Wert hinzufügen',
    newValue: 'Neuer Wert',
    placeholderDefault: 'Text, Zahlen, Symbole usw.',
    addInstagramUsername: 'Instagram-Benutzernamen hinzufügen',
    nameDefault: 'Jhon',
    enterYourLink: 'Link eingeben',
    searchImage: 'Bild suchen',
    pasteLink: 'Link einfügen',
    pasteLinkTip: 'Link zu einer beliebigen Webseite hinzufügen',
    searchGIFs: 'GIFs suchen',
    searchIcons: 'Symbole suchen',
    searchVideo: 'Video suchen',
    search: 'Suchen',
    insertURL: 'URL einfügen',
    writeYourDescription: 'Beschreibung schreiben',
    headerCTAbutton: 'Header, CTA-Button',
    enterTitle: 'Titel eingeben',
    enterDescription: 'Beschreibung eingeben',
    enterURL: 'Kanonische URL eingeben',
  },
  tooltip: {
    addImage: 'Bild hinzufügen',
    labelModalTitle: 'Label-Einstellungen',
    addLabel: '+ Label hinzufügen',
    label: 'Label',
    labelCaption: 'Label eingeben',
    labelText: 'Label-Text',
    labelTextCaption: 'Label-Text eingeben',
    labelTextPlaceholder: 'Label',
    labelUrl: 'Label-URL',
    labelUrlCaption: 'Label-URL eingeben',
    labelUrlPlaceholder: 'https://example.com',
    noLabel: 'Kein Label',
    colorFrom: 'Farbe von',
    colorTo: 'Farbe bis',
    highlight: 'Hervorheben',
    firstName: 'Vorname',
    firstNameCaption: 'Vornamen eingeben',
    lastName: 'Nachname',
    lastNameCaption: 'Nachnamen eingeben',
    jobTitle: 'Position',
    jobTitleCaption: 'Position eingeben',
    organization: 'Unternehmen',
    organizationCaption: 'Unternehmen eingeben',
    email: 'E-Mail',
    emailCaption: 'E-Mail eingeben',
    workPhone: 'Geschäftliches Telefon',
    workPhoneCaption: 'Geschäftliches Telefon eingeben',
    mobilePhone: 'Mobiltelefon',
    mobilePhoneCaption: 'Mobiltelefon eingeben',
    website: 'Website',
    websiteCaption: 'Website eingeben',
    information: 'Informationen',
    informationCaption: 'Informationen eingeben',
    streetAddress: 'Straße',
    streetAddressCaption: 'Straße eingeben',
    city: 'Stadt',
    cityCaption: 'Stadt eingeben',
    state: 'Bundesland',
    stateCaption: 'Bundesland eingeben',
    postalCode: 'Postleitzahl',
    postalCodeCaption: 'Postleitzahl eingeben',
    country: 'Land',
    countryCaption: 'Land eingeben',
    titleColor: 'Titelfarbe',
    titleColorCaption: 'Du kannst die Titelfarbe ändern',
    fontFamily: 'Schriftart',
    fontFamilyCaption: 'Du kannst die Schriftart ändern',
    fontSize: 'Schriftgröße',
    fontSizeLabel: 'Schriftgröße der Beschriftung',
    fontSizeCaption: 'Du kannst die Schriftgröße ändern',
    fontSelect: 'Schrift',
    fontSelectCaption: 'Schrift auswählen',
    imageMargin: 'Bildabstand',
    profilePicture: 'Profilbild',
    profilePictureCaption: 'Profilbild ändern',
    pictureSize: 'Bildgröße',
    pictureSizeCaption: 'Du kannst die Bildgröße ändern',
    title: 'Titel',
    titleCaption: 'Titel eingeben',
    blockCaption: 'Titel deines Blocks eingeben',
    titlePageCaption: 'Titel deiner Seite eingeben',
    templates: 'Vorlagen',
    templatesCaption: 'Wähle eine Vorlage für deine Seite',
    background: 'Hintergrund',
    backgroundColor: 'Hintergrundfarbe',
    textBackground: 'Texthintergrund',
    textBackgroundCaption: 'Hintergrundfarbe des Textes wählen',
    textColor: 'Textfarbe',
    textColorCaption: 'Textfarbe wählen',
    gradientBackground: 'Verlaufshintergrund',
    gradientColor: 'Verlaufsfarbe',
    BackgroundType: 'Typ',
    backgroundSource: 'Hintergrundquelle',
    backgroundSourceCaption: 'Hintergrundquelle wählen',
    backgroundStyle: 'Hintergrundstil',
    backgroundStyleCaption: 'Hintergrundstil wählen',
    backgroundStylesNormal: 'Normal',
    backgroundStylesGlass: 'Glas',
    backgroundStylesOutline: 'Umriss',
    backgroundTypeCaption: 'Hintergrundtyp wählen',
    color: 'Farbe',
    colorTooltip: 'Du kannst die Farbe ändern',
    backgroundOpacityTooltip: 'Schieberegler ziehen, um die Hintergrunddeckkraft einzustellen',
    backgroundBlur: 'Hintergrundunschärfe',
    backgroundBlurCaption: 'Schieberegler ziehen, um den Hintergrund zu verwischen',
    backgroundBrightness: 'Hintergrundhelligkeit',
    backgroundBrightnessCaption: 'Schieberegler ziehen, um die Hintergrundhelligkeit zu ändern',
    backgroundContrast: 'Hintergrundkontrast',
    backgroundContrastCaption: 'Schieberegler ziehen, um den Hintergrundkontrast zu ändern',
    color1: 'Farbe 1',
    color2: 'Farbe 2',
    colorCaption: 'Farbe deiner Seite eingeben',
    gradient: 'Verlauf',
    image: 'Bild',
    photo: 'Foto',
    gif: 'GIF',
    animation: 'Animation',
    video: 'Video',
    hexColor: 'Hex-Farbe',
    direction: 'Richtung',
    gradientDirection: 'Verlaufsrichtung',
    directionCaption: 'Schieberegler ziehen, um die Richtung des Verlaufs einzustellen',
    offset: 'Versatz',
    gradientOffset: 'Verlaufsversatz',
    offsetCaption: 'Schieberegler ziehen, um den Versatz eines Verlaufs einzustellen',
    backgroundDarkness: 'Hintergrunddunkelheit',
    backgroundDarknessCaption: 'Schieberegler ziehen, um ein Hintergrundbild abzudunkeln',
    uploadVideo: 'Video hochladen',
    uploadFile: 'Datei hochladen',
    uploadVideoCaption: 'Video als Seitenhintergrund',
    linkToVideo: 'Link zum Video',
    linkToVideoCaption: 'Link zum Video hinzufügen',
    videoWithSound: 'Video mit Ton',
    videoWithSoundCaption: 'Video mit Ton abspielen',
    fonts: 'Schriftarten',
    fontWeight: 'Schriftstärke',
    fontWeightCaption: 'Klicken, um dein Schicksal zu wählen',
    preloader: 'Preloader',
    preview: 'Vorschau',
    hideLogo: 'UniLink-Logo ausblenden',
    cover: 'Cover',
    coverCaption: 'Cover ändern',
    coverCaptionHeader: 'Bild oder Video zum Header-Cover hinzufügen',
    pageNavigation: 'Seitennavigation',
    websiteNavigation: 'Tab-Navigation',
    backgroundOpacity: 'Hintergrund-Deckkraft',
    backgroundOpacityCaption: 'Schieberegler ziehen, um die Deckkraft des Button-Hintergrunds einzustellen',
    borderRadius: 'Eckenradius',
    borderRadiusCaption: 'Schieberegler ziehen, um den Eckenradius einzustellen',
    heightTabs: 'Tab-Höhe',
    heightTabsCaption: 'Schieberegler ziehen, um die Höhe der Tabs einzustellen',
    backgroundShadow: 'Hintergrundschatten',
    backgroundShape: 'Hintergrundform',
    backgroundBorder: 'Hintergrundrahmen',
    opacity: 'Deckkraft',
    opacityCaption: 'Schieberegler ziehen, um die Deckkraft einzustellen',
    shape: 'Form',
    shapeCaption: 'Form festlegen',
    text: 'Text',
    textCaption: 'Text eingeben',
    textSize: 'Textgröße',
    textSizeCaption: 'Schieberegler ziehen, um die Textgröße einzustellen',
    additionalText: 'Zusätzlicher Text',
    username: 'Benutzername',
    currency: 'Währung',
    language: 'Sprache',
    timeZone: 'Zeitzone',
    websiteNiche: 'Website-Nische',
    websiteNicheCaption: 'Gib deine Website-Nische ein',
    renameCaption: 'Blocktitel umbenennen',
    description: 'Beschreibung',
    descriptionCaption: 'Beschreibung eingeben',
    actionButton: 'Aktions-Button',
    actionButtonCaption: 'Der Call-to-Action-Button motiviert Besucher zum Handeln',
    animationDirection: 'Animationsrichtung',
    animationDirectionCaption: 'Animationsrichtung wählen',
    buttonTitle: 'Button-Titel',
    buttonTitleCaption: 'Button-Titel eingeben',
    buttonUrl: 'Button-URL',
    buttonUrlCaption: 'URL wird in einem neuen Fenster geöffnet',
    imageSize: 'Bildgröße',
    imageSizeCaption: 'Schieberegler ziehen, um die Bildgröße einzustellen',
    view: 'Ansicht',
    viewCaption: 'Ansicht wählen',
    margin: 'Außenabstand',
    marginCaption: 'Schieberegler ziehen, um oben und unten Außenabstand zum Element hinzuzufügen',
    separateTopBottom: 'Oben / Unten',
    padding: 'Innenabstand',
    paddingCaption: 'Schieberegler ziehen, um oben und unten Innenabstand zum Element hinzuzufügen',
    fullWidth: 'Volle Breite',
    lineHeight: 'Zeilenhöhe',
    lineHeightCaption: 'Du kannst die Zeilenhöhe ändern',
    button: 'Schaltfläche',
    titleSize: 'Titelgröße',
    titleSizeCaption: 'Du kannst die Titelgröße ändern',
    titleLineHeight: 'Titel-Zeilenhöhe',
    titleLineHeightCaption: 'Passe die Zeilenhöhe deines Titels an, um mehr Designmöglichkeiten für den Text zu erhalten',
    layout: 'Layout',
    layoutCaption: 'Erstelle das gewünschte Header-Layout',
    layoutAlign: 'Layout-Ausrichtung',
    alignText: 'Text ausrichten',
    align: 'Ausrichten',
    alignCaption: 'Ausrichtung wählen',
    position: 'Position',
    positionCaption: 'Position wählen',
    width: 'Breite',
    widthCaption: 'Wähle die Breite deines Banners',
    nameHeader: 'Name',
    nameCaption: 'Gib den Namen deines Kontos ein',
    shortBio: 'Kurzbeschreibung',
    shortBioCaption: 'Gib eine Kurzbeschreibung deines Kontos ein',
    externalLink: 'Externer Link',
    externalLinkCaption: 'Gib den externen Link zu deinem Konto ein',
    location: 'Standort',
    locationCaption: 'Gib deinen Standort ein',
    locationMap: 'Standortkarte',
    locationMapCaption: 'Gib die URL deines Standorts ein',
    rightIcon: 'Rechtes Symbol',
    rightIconCaption: 'Dieses Symbol erscheint auf der rechten Seite der Schaltfläche',
    buttons: 'Schaltflächen',
    buttonsCaption: 'Aktions-Schaltflächen hinzufügen',
    nameLogo: 'Namens-Logo',
    nameLogoCaption: 'Lade ein Logo für deinen Namen hoch',
    buttonText: 'Schaltflächentext',
    buttonTextCaption: 'Gib den Namen deiner Schaltfläche ein',
    buttonColor: 'Schaltflächenfarbe',
    buttonColorCaption: 'Wähle Farben für die Schaltfläche',
    buttonColorCTACaption: 'Wähle die Hintergrundfarbe für die CTA-Schaltfläche',
    cartColor: 'Warenkorbfarbe',
    cartColorCaption: 'Wähle die Hintergrundfarbe für den Warenkorb',
    ctaButton: 'CTA-Schaltfläche',
    ctaButtonCaption: 'Dieses Symbol erscheint auf der rechten Seite der Schaltfläche',
    style: 'Stil',
    socialIconsStyleCaption: 'Du kannst den Stil deiner Social-Media-Symbole wählen',
    socialIconsShape: 'Form der Social-Media-Symbole',
    socialIconsShapeCaption: 'Du kannst die Form der Social-Media-Symbole wählen',
    headerTextColorCaption: 'Du kannst die Textfarbe des Headers wählen',
    pictureShape: 'Bildform',
    pictureShapeCaption: 'Du kannst die Form des Profilbilds wählen',
    socialLinks: 'Social-Media-Links',
    socialLinksCaption: 'Füge Social-Media-Schaltflächen hinzu, um dich mit nur einem Klick mit deinen Kunden zu verbinden',
    URL: 'URL',
    URLCaption: 'URL-Adresse eingeben',
    heading: 'Überschrift',
    headingTitle: 'Überschrift',
    headingTitleCaption: 'Überschrift eingeben',
    headingDescription: 'Überschriftsbeschreibung',
    headingDescriptionCaption: 'Überschriftsbeschreibung eingeben',
    headingImage: 'Überschriftsbild',
    headingImageCaption: 'Bild für Ihre Überschrift hochladen',
    headingPosition: 'Position der Überschrift',
    headingInsideBlock: 'Innerhalb des Blocks',
    headingOutsideBlock: 'Außerhalb des Blocks',
    headingDivider: 'Überschriftstrenner',
    canonicalURL: 'Kanonische URL',
    seo: 'SEO',
    seoCaption: 'Passen Sie Ihr Produkt mit Meta-SEO-Tags an',
    themes: 'Themes',
    brandColors: 'Brand Kit',
    applyBrandColors: 'Auf Profil anwenden',
    syncBlocks: 'Alle Blöcke synchronisieren',
    brandColorsApplied: 'Markenfarben angewendet',
    generatedPalette: 'Generierte Palette',
    applying: 'Wird angewendet...',
    syncing: 'Wird synchronisiert...',
    backgroundType: 'Hintergrundtyp',
    palettes: 'Paletten',
    previewTitle: 'Titel',
    previewTitleCaption: 'Vorschautitel eingeben',
    previewDescription: 'Beschreibung',
    previewDescriptionCaption: 'Vorschaubeschreibung eingeben',
    previewButton: 'Schaltflächentext',
    previewButtonCaption: 'Text der Vorschauschaltfläche eingeben',
    previewLabel: 'Beschriftungstext',
    previewLabelCaption: 'Beschriftungstext für Vorschau eingeben',
    previewThumbnail: 'Vorschaubild',
    previewThumbnailCaption: 'Vorschaubild hochladen',
    myTemplates: 'Meine Vorlagen',
    myTemplatesEmpty: 'Noch keine Vorlagen. Speichere dein aktuelles Seitendesign, um es später wiederzuverwenden.',
    saveAsTemplate: 'Als Vorlage speichern',
    saveCurrentAsTemplate: 'Aktuelle als Vorlage speichern',
    templateSaved: 'Vorlage gespeichert',
    templateApplied: 'Vorlage angewendet',
    buildFromReference: 'Aus Referenz erstellen',
    templateAppliedCount: 'Vorlage angewendet — {n} Blöcke hinzugefügt',
    searchTemplates: 'Vorlagen suchen…',
    favorites: 'Favoriten',
    previewLive: 'Live-Vorschau',
    previewingTemplate: 'Vorschau',
    exitPreview: 'Beenden',
    templateKind: 'Was einbeziehen',
    publish: 'Veröffentlichen',
    unpublish: 'Veröffentlichung aufheben',
    templatePublished: 'Vorlage veröffentlicht',
    templateUnpublished: 'Veröffentlichung der Vorlage aufgehoben',
    discoverTemplates: 'Community entdecken',
    discoverSubtitle: 'Kostenlose Vorlagen, die von anderen Creatorn auf UniLink veröffentlicht wurden.',
    discoverEmpty: 'Noch keine öffentlichen Vorlagen — sei der Erste, der eine veröffentlicht.',
    pricing: 'Preise',
    fontRoles: {
      heading: 'Überschrift',
      subtitle: 'Untertitel',
      body: 'Global',
    },
  },
  table: {
    clicks: 'Klicks',
    signups: 'Anmeldungen',
    views: 'Impressionen',
    orderNumber: 'Bestellnummer',
    amount: 'Betrag',
    credits: 'Guthaben',
    invoice: 'Rechnung',
    email: 'E-Mail',
    card: 'Karte',
    currency: 'Währung',
    name: 'Name',
    contact: 'Kontakt',
    optIn: 'Opt-in',
    notes: 'Notizen',
    address: 'Adresse',
    date: 'Datum',
    action: 'Aktion',
    custom: 'Benutzerdefiniert',
    status: 'Status',
    tags: 'Tags',
    view: 'Anzeigen',
    remove: 'Entfernen',
    sendEmail: 'E-Mail senden',
    details: 'Details',
    purchases: 'Käufe',
    order: 'Bestellung',
    money: 'Geld',
    type: 'Typ',
    orderCode: 'Bestellcode',
  },
  settings: {
    title: 'Einstellungen',
    settings: 'Einstellungen',
    accountSettings: 'Kontoeinstellungen',
    email: 'E-Mail',
    subscription: 'Abonnement',
    billingHistory: 'Rechnungsverlauf',
    dueTo: 'Fällig am',
    subscriptionDueTo: 'Abonnement fällig am',
    cancelSubscription: 'Abonnement kündigen',
    cancelSubscriptionConfirm: 'Möchten Sie Ihr Abonnement wirklich kündigen?',
    subscriptionCancelled: 'Ihr Abonnement wurde gekündigt. Ihr Tarif bleibt bis zum Ende des Abrechnungszeitraums aktiv.',
    subscriptionCancelError: 'Abonnement konnte nicht gekündigt werden. Bitte kontaktieren Sie den Support.',
    deleteFirst: 'Löschen Sie dauerhaft Ihr',
    deleteSecond: 'und alle zugehörigen Daten. Diese Aktion kann nicht rückgängig gemacht werden.',
    account: {
      title: 'Konto',
      usernameNotAvailable: 'Benutzername ist nicht verfügbar',
      setupCustomDomain: 'Eigene Domain einrichten',
      subtitle: 'Konto-E-Mail, Abrechnung, Passwort und API-Schlüssel',
    },
    profile: {
      title: 'Profil',
      usernameNotAvailable: 'Benutzername ist nicht verfügbar',
      setupCustomDomain: 'Eigene Domain einrichten',
      subtitle: 'Benutzername, Sprache, Währung, Zeitzone verwalten',
      category: 'Kategorie',
      categoryCaption: 'Geben Sie die Kategorie Ihres Profils ein',
      usernameDesc: 'Dein öffentliches Handle',
      currencyDesc: 'Für Einnahmen & Auszahlungen verwendet',
      languageDesc: 'Sprache, die deinen Besuchern angezeigt wird',
      timeZoneDesc: 'Für Planung & Analysen',
      categoryDesc: 'Beschreibt dein Profil am besten',
      privateProfile: 'Privates Profil',
      privateProfileDesc: 'Nur genehmigte Follower können dein Profil ansehen',
    },
    aiassistant: {
      title: 'KI-Assistent',
      subtitle: 'Passen Sie Ihren KI-Assistenten für bessere, persönlichere Antworten an',
      titleText: 'Helfen Sie der KI zu verstehen, wer Sie sind, für relevantere Antworten',
      customAiTitle: 'Benutzerdefinierte Anweisungen',
      customAiPlaceholder: 'Fügen Sie spezifische Anweisungen für die KI hinzu...',
      customAiDescription: 'Diese Anweisungen werden auf jede Konversation mit der KI angewendet',
      nicknameTitle: 'Wie soll die KI Sie nennen?',
      nicknamePlaceholder: 'Spitzname',
      titleBio: 'Bio/ Beschreibung',
      bioPlaceholder: 'Erzählen Sie uns ein wenig über sich...',
      occupation: 'Was machen Sie?',
      occupationPlaceholder: 'z. B. Ingenieurstudent an der University of Waterloo',
      aboutYouTitle: 'Über Sie',
      aboutYouTooltip: 'Erzählen Sie Ihrem KI-Assistenten etwas über sich',
      locationTitle: 'Standort',
      locationPlaceholder: 'z. B. Kiew, Ukraine',
      categoryTitle: 'Kategorie',
    },
    notifications: {
      title: 'Benachrichtigungen',
      subtitle: 'Richten Sie Benachrichtigungen über neue Besucher-E-Mails und Bestellungen ein',
      text: 'Verbinden Sie Messenger, um Benachrichtigungen über neue Kunden-E-Mails und Bestellungen zu erhalten',
      setUpWebhooks: 'Webhooks im Bereich Webhooks einrichten',
      save: 'Speichern',
      connect: 'VERBINDEN',
      disconnect: 'TRENNEN',
      webhook: 'Webhook',
      emailSubmit: 'Datenerfassung übermittelt',
      formSubmit: 'Formular übermittelt',
      showSubmit: 'Shop übermittelt',
      digitalSubmit: 'Digital übermittelt',
      appointmentSubmit: 'Termin übermittelt',
      requestSubmit: 'Service übermittelt',
      donationSubmit: 'Spende übermittelt',
      email: 'E-Mail',
      settings: 'Einstellungen',
      cartSubmit: 'Warenkorb-Absendung',
      linkClick: 'Link-Klick',
      contactClick: 'Kontakt-Klick',
      all: 'Alle',
      updates: 'Updates',
      messages: 'Nachrichten',
      opportunities: 'Möglichkeiten',
      insights: 'Einblicke',
      activity: 'Aktivität',
      system: 'System',
      news: 'Neuigkeiten',
      more: 'Mehr anzeigen',
      less: 'Weniger anzeigen',
      connectedAccounts: 'Verbundene Konten',
      addEmailAccount: 'E-Mail-Konto hinzufügen',
    },
    paymentSystem: {
      title: 'Zahlungssystem',
      subtitle: 'Auszahlungen über Stripe oder PayPal einrichten',
      text: 'Bearbeitungsgebühren anzeigen',
      connected: 'Verbunden',
      active: 'Zahlungen auf der Website akzeptieren',
      pending: 'Ausstehend',
      disconnect: 'Trennen',
      connect: 'Verbinden',
      add: 'Hinzufügen',
      ofYourAccount: 'deines Kontos',
      save: 'Speichern',
    },
    shop: {
      title: 'Shop',
      subtitle: 'Kategorie und Eigenschaft festlegen',
      label: {
        title: 'Labels',
        subtitle: 'Labels zu Produktkarten hinzufügen',
        addValue: 'Wert hinzufügen',
        save: 'Speichern',
        value: 'Wert',
        enterTitle: 'Titel eingeben',
        maximum: 'Maximale Anzahl an Werten ist 5',
        add: 'Hinzufügen',
        edit: 'Bearbeiten',
        labels: 'Labels',
      },
      category: {
        title: 'Kategorien',
        subtitle: 'Kategorie zu deinen Produkten hinzufügen',
        addCategory: 'Kategorie hinzufügen',
        save: 'Speichern',
        maximum: 'Maximale Anzahl ist',
        editTitle: 'Kategorie',
        name: 'Name',
        namePlaceholder: 'Kategorie eingeben',
        visibility: 'Sichtbarkeit',
        visible: 'Sichtbar',
        hidden: 'Verborgen',
        description: 'Beschreibung',
        descriptionHint: 'Die Beschreibung muss kürzer als 100 Zeichen sein',
        descriptionPlaceholder: 'Kurze Beschreibung hinzufügen',
        cover: 'Cover',
        view: 'Ansehen',
        share: 'Teilen',
        linkCopied: 'Link kopiert',
        saveFirst: 'Speichere zuerst die Kategorie',
        moveOut: 'Herausnehmen',
      },
      property: {
        title: 'Eigenschaft',
        subtitle: 'Eigenschaft zu deinen Produkten hinzufügen',
        addProperties: 'Eigenschaften hinzufügen',
        properties: 'Eigenschaften',
        type: 'Typ',
        typeTooltip: 'Typ deiner Eigenschaften',
        titleModal: 'Titel',
        titleModalTooltip: 'Name deiner Eigenschaften',
        enterTitle: 'Titel eingeben',
        value: 'Wert',
        addValue: 'Wert hinzufügen',
        maximum: 'Maximale Anzahl an Werten ist',
        save: 'Speichern',
        cancel: 'Abbrechen',
        remove: 'Entfernen',
        addPropertyToItem: 'Eigenschaft zum Artikel hinzufügen',
        add: 'Hinzufügen',
        edit: 'Bearbeiten',
        propertiesSmall: 'Eigenschaften',
        required: 'Erforderlich',
        requiredTooltip: 'Erforderliche Eigenschaften für den Kauf festlegen',
        selectAll: 'Alle auswählen',
      },
      preorderForm: {
        title: 'Vorbestellungsformular',
        subtitle: 'Felder des Vorbestellungsformulars einrichten',
        fields: 'Felder',
        fieldsTooltip: 'Felder zum Formular hinzufügen',
        required: 'Erforderlich',
        submitButton: 'Titel der Schaltfläche „Senden“',
        redirectUrl: 'Weiterleitungs-URL (optional)',
        resultText: 'Ergebnistext',
        save: 'Speichern',
        name: 'Name',
        emailAddress: 'E-Mail-Adresse',
        phone: 'Telefon',
        address: 'Adresse',
        comment: 'Kommentar',
      },
      shipping: {
        title: 'Versand',
        subtitle: 'Versandfelder einrichten',
        fields: 'Felder',
        fieldsTooltip: 'Felder zum Versandformular hinzufügen',
        required: 'Erforderlich',
        save: 'Speichern',
        name: 'Name',
        emailAddress: 'E-Mail-Adresse',
        phone: 'Telefon',
        address: 'Adresse',
        comment: 'Kommentar',
        addCustomField: 'Benutzerdefiniertes Feld hinzufügen',
        addFormInfo: 'Formularinfo hinzufügen',
        editFormInfo: 'Formularinfo bearbeiten',
        type: 'Typ',
        typeTooltip: 'Typ des benutzerdefinierten Feldes',
        fieldName: 'Feldname',
        fieldNameTooltip: 'Name für benutzerdefiniertes Feld',
        placeholder: 'Platzhalter',
        placeholderTooltip: 'Platzhalter für benutzerdefiniertes Feld',
        delete: 'Löschen',
        update: 'Aktualisieren',
        add: 'Hinzufügen',
      },
      delivery: {
        title: 'Versandmethoden',
        subtitle: 'Konfiguriere Versand, lokale Lieferung und Selbstabholung für deinen Shop.',
        loading: 'Wird geladen…',
        inactive: 'inaktiv',
        confirmDelete: 'Diese Versandmethode löschen?',
        category: {
          shipping: 'Versand',
          localDelivery: 'Lokale Lieferung',
          selfPickup: 'Selbstabholung',
        },
        rateType: {
          free: 'Kostenlos',
          conditionalFree: 'Bedingt kostenlos',
          flatRate: 'Pauschalpreis',
          customRates: 'Individuelle Tarife',
          carrierApi: 'Carrier-API',
        },
        carrier: {
          custom: 'Eigener Versanddienst',
        },
        add: {
          shipping: 'Versand hinzufügen',
          localDelivery: 'Lokale Lieferung hinzufügen',
          selfPickup: 'Selbstabholung hinzufügen',
        },
        actions: {
          edit: 'Bearbeiten',
          delete: 'Löschen',
          save: 'Speichern',
          cancel: 'Abbrechen',
        },
        fields: {
          name: 'Name',
          namePh: 'z. B. Standardversand',
          description: 'Beschreibung',
          isActive: 'Aktiv',
          estimatedDays: 'Voraussichtliche Tage',
          currency: 'Währung',
          countryCodes: 'Ländercodes (CSV)',
          carrier: 'Versanddienst',
          rateType: 'Tariftyp',
          flatPrice: 'Pauschalpreis',
          freeThreshold: 'Kostenlos ab (Zwischensumme)',
          fallbackPrice: 'Ersatzpreis',
          customRates: 'Individuelle Tarifzeilen',
          senderCity: 'Name der Absenderstadt',
          senderCityRef: 'Ref. der Absenderstadt',
          pickupInstructions: 'Abholhinweise',
          pickupCharge: 'Abholgebühr',
          askPickupDateTime: 'Abholdatum/-zeit beim Checkout abfragen',
        },
        rateRow: {
          subtotal: 'Nach Zwischensumme',
          weight: 'Nach Gewicht (g)',
          min: 'Min',
          max: 'Max',
          price: 'Preis',
          add: 'Zeile hinzufügen',
        },
      },
      legal: {
        title: 'Rechtliche Dokumente',
        subtitle: 'AGB, Datenschutz, Rückgaberichtlinie — den Kunden beim Checkout angezeigt.',
        loading: 'Wird geladen…',
        empty: 'Noch keine rechtlichen Dokumente.',
        inactive: 'inaktiv',
        required: 'erforderlich',
        confirmDelete: 'Dieses Dokument löschen?',
        addNew: '+ Dokument hinzufügen',
        types: {
          terms: 'Nutzungsbedingungen',
          privacy: 'Datenschutzerklärung',
          returns: 'Rückgabe-/Erstattungsrichtlinie',
          shipping: 'Versandrichtlinie',
          cookies: 'Cookie-Richtlinie',
          custom: 'Benutzerdefiniert',
        },
        fields: {
          title: 'Titel',
          titlePh: 'z. B. Nutzungsbedingungen',
          type: 'Dokumenttyp',
          content: 'Inhalt',
          contentPh: 'Schreibe hier deinen Rechtstext…',
          isActive: 'Aktiv',
          requireAcceptance: 'Zustimmung beim Checkout verlangen',
        },
        actions: {
          edit: 'Bearbeiten',
          delete: 'Löschen',
          save: 'Speichern',
          cancel: 'Abbrechen',
        },
      },
      checkoutGroup: 'Checkout',
      serviceCharge: {
        title: 'Servicegebühr',
        subtitle: 'Füge jeder Bestellung eine Servicegebühr oder ein Trinkgeld hinzu.',
        label: 'Beschreibung',
        labelPh: 'z. B. Servicegebühr 5 % und Liefer-Trinkgeld 3 $',
        rate: 'Satz',
        rateHint: 'Prozent der Bestell-Zwischensumme.',
        amount: 'Betrag',
        amountHint: 'Fester Betrag, der obendrauf hinzukommt.',
      },
      tip: {
        title: 'Trinkgelder',
        subtitle: 'Lass Kunden beim Checkout ein Trinkgeld zu ihrer Bestellung hinzufügen.',
        enable: 'Trinkgelder aktivieren',
        presets: 'Trinkgeld-Vorgaben (%)',
        noPresets: 'Noch keine Vorgaben — füge unten eine hinzu.',
        presetPh: 'z. B. 10',
        addPreset: '+ Vorgabe hinzufügen',
        presetsHint: 'Werden beim Checkout als Schnellwahl-Buttons angezeigt. Bis zu 6.',
        remove: 'Entfernen',
        allowCustom: 'Eigenen Betrag zulassen',
        label: 'Aufforderungstext',
        labelPh: 'z. B. Trinkgeld für guten Service hinzufügen',
        save: 'Speichern',
        saving: 'Wird gespeichert…',
      },
      orderNumber: {
        title: 'Bestellnummer',
        subtitle: 'Passe an, wie Bestellnummern aussehen.',
        next: 'Nächste Bestellnummer',
        prefix: 'Präfix',
        suffix: 'Suffix',
        showInMessage: 'In Rechnung und Bestellnachricht anzeigen',
        reset: 'Bestellnummer zurücksetzen',
      },
      orderMessage: {
        title: 'Bestellnachricht',
        subtitle: 'Passe die Bestellbestätigung an, die an Kunden gesendet wird.',
        footer: 'Nachrichten-Fußzeile',
        footerPh: 'z. B. Danke für deine Bestellung! Folge uns @deinemarke',
        footerHint: 'Wird an jede Bestellbestätigung angehängt.',
        plain: 'Einfache Nachricht',
        plainHint: 'Entferne jegliche Formatierung aus der Bestellnachricht.',
      },
      invoice: {
        title: 'Rechnung',
        subtitle: 'Gebrandete Rechnung, die bezahlten Bestellungen beigefügt wird.',
        upgrade: 'Upgrade',
        showLogo: 'Logo anzeigen',
        header: 'Kopfzeile',
        footer: 'Fußzeile',
        companyName: 'Firmenname',
        companyEmail: 'Firmen-E-Mail',
        companyPhone: 'Firmentelefon',
        companyAddress: 'Firmenadresse',
        companyAddressPh: 'Adresse eingeben',
      },
    },
    seo: {
      title: 'SEO',
      subtitle: 'Passe deine Seite mit Meta-SEO-Tags an',
      titleText: 'Titel',
      titlePlaceholder: 'Seitentitel eingeben',
      description: 'Beschreibung',
      descriptionPlaceholder: 'Seitenbeschreibung eingeben',
      favicon: 'Favicon',
      uploadFavicon: 'Favicon hochladen',
      imagePreview: 'Bildvorschau',
      useCustom: 'Eigenes Bild verwenden',
      save: 'Speichern',
      visualise: 'Visualisiere, wie deine Website-Vorschau bei Google aussehen wird',
      inMessengers: 'In Messengern',
      inSocial: 'In sozialen Medien',
      searchEngine: 'Suchmaschine',
      googleIndexable: 'Bei Google indexierbar',
      sitemap: {
        title: 'Sitemap',
        entryHint: 'Lege fest, welche Seiten und Produkte Suchmaschinen indexieren dürfen.',
        setupLink: 'anpassen',
        mainEntry: 'Website indexieren',
        subtitle: 'Wähle, welche Seiten Suchmaschinen indexieren sollen. Deaktivierte Seiten erhalten ein noindex-Tag und werden aus deiner Sitemap entfernt.',
        mainPage: 'Haupt-Profilseite',
        pagesSection: 'Seiten',
        pagesHint: 'Aktiviere die Indexierung für jede zusätzliche Seite deiner Website.',
        noPages: 'Noch keine zusätzlichen Seiten.',
        productsSection: 'Produkte',
        productsHint: 'Aktiviere die Indexierung für einzelne Produktseiten.',
        noProducts: 'Noch keine Produkte.',
        postsSection: 'Beiträge',
        postsHint: 'Aktiviere die Indexierung für einzelne Beiträge.',
        noPosts: 'Noch keine Beiträge.',
        blogSection: 'Blog-Artikel',
        blogHint: 'Aktiviere die Indexierung für einzelne Blog-Artikel.',
        noArticles: 'Noch keine Blog-Artikel.',
        loadMore: 'Mehr laden',
        loading: 'Wird geladen…',
      },
    },
    analytics: {
      title: 'Analytics',
      subtitle: 'Integriere Facebook Pixel, Google Analytics und UTM-Parameter',
      facebookTooltip: 'Facebook verbinden, um Analysen anzuzeigen',
      googleAnalyticsTooltip: 'Mit Google Analytics kannst du den ROI deiner Werbung messen und alle deine Links verfolgen.',
      googleTagManagerTooltip: 'Mit Google Tag Manager kannst du Tags konfigurieren und sofort auf deiner Website bereitstellen',
      tikTokPixelTooltip: 'Das TikTok Pixel ist ein leistungsstarkes Messtool, das die Auswirkungen deiner TikTok-Anzeigen auf deine Website verfolgt',
      pinterestTag: 'Pinterest Tag',
      pinterestTagTooltip:
        'Der Pinterest Tag ist ein Code-Snippet, das du deiner Website hinzufügst und mit dem Pinterest die Besucher deiner Website sowie deren Aktionen nach dem Sehen deiner Pinterest-Anzeige verfolgen kann.',
      tag: 'Tag',
      headerTagTooltip: 'Tag einfügen, der im Head-Bereich deiner Website erscheint',
      bodyTagTooltip: 'Tag einfügen, der im Body-Bereich deiner Website erscheint',
      utmParameters: 'UTM-Parameter',
      utmParametersTooltip: 'Erfasse Kampagnendaten mit benutzerdefinierten URLs. Füge URLs Parameter hinzu, um die Kampagnen zu identifizieren, die Traffic generieren.',
      makeAnalytics: 'Lasse Google Analytics UniLink-Traffic als Social anzeigen',
      the: 'Der',
      campaign: 'Kampagnen',
      parameter: '-Parameter wird dynamisch aus dem Titel jedes Beitrags oder Links gesetzt',
      save: 'Speichern',
    },
    customDomain: {
      title: 'Eigene Domain',
      subtitle: 'Personalisiere deine Seite mit einer eigenen Domain',
      titleTooltip: 'Eigene Domain hinzufügen',
      save: 'Speichern',
      connect: 'Verbinden',
      connecting: 'Verbinde...',
      instructions: 'Anleitung',
      submit: 'Absenden',
      submitting: 'Wird gesendet...',
      enterDomain: 'Domain eingeben',
      domainPlaceholder: 'deine-domain.de',
      steps: {
        submitting: 'Anfrage wird gesendet',
        validation: 'Domain-Validierung',
        certificate: 'Zertifikatsbereitstellung',
        complete: 'Abgeschlossen',
      },
      txtRecord: {
        title: 'TXT-Eintrag',
        description: 'Füge folgenden TXT-Eintrag zu deinen DNS-Einstellungen hinzu:',
        verifyButton: 'TXT-Eintrag überprüfen',
        verifying: 'Überprüfe...',
        verified: 'TXT-Eintrag verifiziert',
      },
      cnameRecord: {
        title: 'CNAME-Eintrag',
        description: 'Füge folgenden CNAME-Eintrag zu deinen DNS-Einstellungen hinzu:',
        verifyButton: 'CNAME-Eintrag überprüfen',
        verifying: 'Überprüfe...',
        verified: 'CNAME-Eintrag verifiziert',
      },
      dnsTable: {
        type: 'Typ',
        host: 'Host',
        value: 'Wert',
        ttl: 'TTL',
        copy: 'Kopieren',
        copied: 'Kopiert!',
      },
      provisioning: {
        title: 'SSL-Zertifikat wird bereitgestellt...',
        description: 'Dies kann einige Minuten dauern. Bitte warten.',
        timeout: 'Die Zertifikatsbereitstellung dauert länger als erwartet. Bitte schaue später noch einmal vorbei.',
      },
      complete: {
        title: 'HTTPS wurde erfolgreich für deine Domain aktiviert.',
        connected: 'Verbunden',
      },
      failed: {
        title: 'Domain-Verbindung fehlgeschlagen',
        tryAgain: 'Erneut versuchen',
      },
      rootDomainWarning: 'Root-Domains erfordern, dass dein DNS-Anbieter CNAME-Flattening unterstützt (z. B. Cloudflare, Route53).',
      deleteConfirm: {
        title: 'Domain trennen',
        message: 'Möchtest du diese Domain wirklich trennen? Deine Website ist über diese Domain nicht mehr erreichbar.',
        confirm: 'Trennen',
        cancel: 'Abbrechen',
      },
    },
    webhooks: {
      title: 'Webhooks',
      subtitle: 'Echtzeit-Ereignisbenachrichtigungen an externe Dienste senden',
      webhook: 'Webhook',
      webhookTooltip: 'Webhook hinzufügen',
      send: 'Ereignisse an Drittanbieter-Website senden',
      webhookUrl: 'Webhook-URL (POST-Anfrage)',
      error: 'Gültigen Link eingeben',
      save: 'Änderungen speichern',
      enableWebhooks: 'Webhooks aktivieren',
      enableDescription: 'POST-Anfragen bei ausgewählten Ereignissen',
      endpointUrl: 'Endpunkt-URL',
      endpointTooltip: 'Die URL, die POST-Anfragen empfängt, wenn ausgewählte Ereignisse auftreten',
      endpointPlaceholder: 'https://example.com/api/webhook',
      events: 'Ereignisse',
      selectAll: 'Alle auswählen',
      deselectAll: 'Auswahl aufheben',
      filterPlaceholder: 'Ereignisse filtern...',
      all: 'Alle',
      none: 'Keine',
      active: 'Aktiv',
      inactive: 'Inaktiv',
      categories: {
        submissions: 'Einsendungen',
        engagement: 'Engagement',
      },
      eventLabels: {
        SubmitHeaderSubscribe: 'Header-Abonnement',
        SubmitHeaderMessage: 'Header-Nachricht',
        SubmitDataCollect: 'Datenerfassung',
        SubmitForm: 'Formular abgesendet',
        SubmitShop: 'Shop-Bestellung',
        SubmitShopPreorder: 'Shop-Vorbestellung',
        SubmitDigital: 'Digitales Produkt',
        SubmitAppointment: 'Termin',
        SubmitService: 'Service-Bestellung',
        SubmitEvent: 'Event-Registrierung',
        SubmitCourse: 'Kurs-Anmeldung',
        SubmitDonation: 'Spende',
        SubmitMembership: 'Mitgliedschaft',
        SubmitBlog: 'Blog-Kauf',
        SubmitCoupon: 'Gutschein verwendet',
        SubmitTip: 'Trinkgeld',
        SubmitLink: 'Link-Kauf',
        SubmitProductMessage: 'Produktfrage',
        SubmitPodcast: 'Podcast-Kauf',
        SubmitBooking: 'Buchung',
        SubmitRental: 'Vermietung',
        SubmitSingleProduct: 'Einzelprodukt',
        SubmitDiscount: 'Rabatt-Bestellung',
        SubmitListing: 'Eintragsanfrage',
        SubmitUnlock: 'Inhalt freigeschaltet',
        SubmitChatAi: 'KI-Chat-Nachricht',
        ClickLink: 'Link-Klick',
        ClickContact: 'Kontakt-Klick',
        AddToCart: 'In den Warenkorb',
        AddToCartSingleProduct: 'Einzelprodukt in den Warenkorb',
        AddToWishlist: 'Zur Wunschliste hinzufügen',
        InitiateCheckout: 'Checkout starten',
        DownloadFile: 'Datei-Download',
        DownloadMusic: 'Musik-Download',
        CopyCoupon: 'Gutschein kopieren',
        CopyDiscount: 'Rabatt kopieren',
        QR_ScanQrCode: 'QR-Code-Scan',
        VisitPage: 'Seitenbesuch',
      },
    },
    sensitive: {
      title: 'Sensible Inhalte',
      subtitle: 'Warnung vor sensiblen Inhalten anzeigen, bevor deine Website angezeigt wird',
    },
    socialIntegration: {
      title: 'Social-Media-Integrationen',
      subtitle: 'Verwalte deine Instagram- und TikTok-Integrationen',
      connectInstagram: 'Instagram verbinden',
    },
    emailIntegration: {
      title: 'Zielgruppen-Integrationen',
      subtitle: 'Leite die E-Mail-Adressen deiner Besucher an MailChimp, Reply weiter',
      emailCaption: 'Füge eine Integration hinzu, um die E-Mail-Adressen deiner Follower an MailChimp weiterzuleiten',
      mailChimp: 'MailChimp-Integrationen',
      selzy: 'Selzy-Integrationen',
      selzyCaption: 'Füge einen API-Schlüssel hinzu, um die E-Mail-Adressen deiner Follower an Selzy weiterzuleiten',
      sendPulse: 'SendPulse-Integrationen',
      sendPulseCaption: 'Füge einen API-Schlüssel hinzu, um die E-Mail-Adressen deiner Follower an SendPulse weiterzuleiten',
      reply: 'Reply-Integrationen',
      replyCaption: 'Füge einen API-Schlüssel hinzu, um die E-Mail-Adressen deiner Follower weiterzuleiten an',
      integrations: 'Integrationen',
    },
    calendarIntegration: {
      title: 'Kalender-Integrationen',
      subtitle: 'Verbinde deine Kalenderdienste',
      calendly: 'Calendly',
      calendlyDescription: 'Verbinde Calendly, um Termintypen und Verfügbarkeit zu synchronisieren',
      googleCalendar: 'Google Calendar',
      googleCalendarDescription: 'Verbinde Google Calendar, um Ereignisse zu synchronisieren und Google Meet-Links zu erstellen',
      zoom: 'Zoom',
      zoomDescription: 'Verbinde Zoom, um automatisch Meeting-Links zu erstellen',
      googleMeet: 'Google Meet',
      googleMeetDescription: 'Erstelle automatisch Google Meet-Links (erfordert Google Calendar)',
    },
    storage: {
      title: 'Speicher',
      subtitle: 'Bestellungen der Besucher in Google Spreadsheet speichern',
      storageCaption: 'Füge eine Integration hinzu, um alle Kundenbestellungen in Google Spreadsheet zu speichern',
      emailSignup: 'E-Mail-Anmeldung',
      emailSignupsCaption: 'Tabelle zum Speichern der E-Mail-Anmeldung auswählen',
      formSignups: 'Formular-Anmeldung',
      forSignupsCaption: 'Tabelle zum Speichern der Formular-Anmeldung auswählen',
      shopOrders: 'Shop-Bestellungen',
      shopOrderCaption: 'Tabelle zum Speichern der Shop-Bestellungen auswählen',
      disconnect: 'Spreadsheet trennen',
      storageUsage: 'Speichernutzung',
      of: 'von',
      uses: 'Diese App nutzt',
      space: 'deines freien Speicherplatzes',
      view: 'Details anzeigen',
      noItems: 'Keine Einträge vorhanden',
      files: 'Dateien',
      images: 'Bilder',
      videos: 'Videos',
      audio: 'Audio',
      settings: 'Einstellungen',
      free: 'frei',
      needMoreSpace: 'Mehr Speicherplatz nötig?',
      unlockStorage: 'Schalte unbegrenzten Speicher, 4K-Video frei',
      upgradePlan: 'Tarif upgraden',
      addFile: 'Datei hinzufügen',
      uploading: 'Wird hochgeladen...',
      dragDrop: 'oder hierher ziehen und ablegen',
      noFilesYet: 'Noch keine Dateien',
      noImagesYet: 'Noch keine Bilder',
      noVideosYet: 'Noch keine Videos',
      noAudioYet: 'Noch kein Audio',
      filesHint: 'Lade PDFs, Dokumente und andere Downloads hoch, um sie mit den Links deiner Bio-Seite zu verknüpfen.',
      imagesHint: 'Lade Bilder hoch, um sie auf deiner Bio-Seite zu verwenden.',
      videosHint: 'Lade Videos hoch, um sie auf deiner Bio-Seite einzubetten.',
      audioHint: 'Lade Audiotracks hoch, um sie auf deiner Bio-Seite zu teilen.',
    },
    accountLabel: 'Konto',
    profileLabel: 'Profil',
    switchProfile: 'Profil wechseln',
    createNewProfile: 'Neues Profil erstellen',
    active: 'Aktiv',
    currentPlan: 'Aktueller Tarif',
    freePlanHint: 'Upgrade, um Pro-Funktionen freizuschalten und Limits zu entfernen.',
    to: 'bis',
    renews: 'Verlängert sich',
    passwordChangeDesc: 'Ändere dein Kontopasswort',
    apiKeyDesc: 'Verwende diesen Schlüssel zur Authentifizierung von API-Anfragen',
    apiDocumentation: 'API-Dokumentation',
    dashboardLanguageDesc: 'Oberflächensprache für dein Konto',
    manualPayments: {
      title: 'Manuelle / Offline-Zahlungen',
      hint: 'Kunden zahlen offline (Überweisung, bar, QR). Du bestätigst die Bestellung manuell.',
      save: 'Speichern',
      iban: 'IBAN',
      accountHolder: 'Name des Kontoinhabers',
      bankName: 'Name der Bank',
      phone: 'Telefon',
      payeeName: 'Name des Zahlungsempfängers',
      instruction: 'Anweisung',
      instructionHint: 'Formatiere mit **fett** ~durchgestrichen~ _kursiv_',
      requireProof: 'Zahlungsnachweis verlangen',
      requireProofHint: 'Zum Abschluss der Bestellung müssen Kunden einen Screenshot hochladen (Beleg, Überweisungsbestätigung oder einen anderen Zahlungsnachweis).',
      markPaidOnConfirm: 'Als bezahlt markieren bei Kundenbestätigung',
      markPaidOnConfirmHint: 'Aktualisiert den Zahlungsstatus automatisch auf „Bezahlt“, sobald der Kunde seine Zahlung bestätigt.',
      contactBeforePay: 'Kontakt zum Verkäufer vor der Zahlung aktivieren',
      contactBeforePayHint: 'Kunden können die Zahlung überspringen, um dem Verkäufer zu schreiben — das erhöht Anfragen, schafft aber Vertrauen und reduziert Stornierungen.',
    },
    developerApi: {
      title: 'Entwickler-API',
      subtitle: 'Erstelle API-Schlüssel, um über die /api/v2-Endpunkte auf deine Bestellungen, Produkte und Kunden zuzugreifen.',
      keyName: 'Schlüsselname',
      keyNamePh: 'z. B. Lager-Sync',
      scopes: 'Berechtigungen',
      scopeLabels: {
        'orders:read': 'Bestellungen lesen',
        'products:read': 'Produkte lesen',
        'products:write': 'Produktbestand aktualisieren',
        'customers:read': 'Kunden lesen',
      },
      create: 'Schlüssel erstellen',
      creating: 'Wird erstellt…',
      created: 'API-Schlüssel erstellt',
      copyWarning: 'Kopiere diesen Schlüssel jetzt — er wird nicht erneut angezeigt.',
      done: 'Fertig',
      revoke: 'Widerrufen',
      revoked: 'Widerrufen',
      confirmRevoke: 'Diesen API-Schlüssel widerrufen? Apps, die ihn nutzen, funktionieren nicht mehr.',
      empty: 'Noch keine API-Schlüssel.',
    },
    whatsapp: {
      title: 'WhatsApp Business',
      subtitle: 'Verbinde deine WhatsApp-Business-Nummer, um Kundennachrichten zu empfangen und zu beantworten.',
      phoneNumberId: 'Telefonnummern-ID',
      accessToken: 'Zugriffstoken',
      displayPhone: 'Anzeige-Telefonnummer (optional)',
      connect: 'Verbinden',
      connecting: 'Wird verbunden…',
      connected: 'Verbunden',
      disconnect: 'Trennen',
      confirmDisconnect: 'WhatsApp trennen?',
      webhookHelp: 'Trage diese Callback-URL und den Verify-Token in deiner Meta-App → WhatsApp → Konfiguration ein:',
      webhookUrl: 'Callback-URL',
      verifyToken: 'Verify-Token',
      inbox: 'Posteingang',
      noMessages: 'Noch keine Nachrichten.',
      selectThread: 'Wähle eine Konversation.',
      replyPlaceholder: 'Nachricht schreiben…',
      send: 'Senden',
      broadcast: {
        title: 'Broadcast',
        audienceInbox: 'Posteingang-Kontakte',
        audienceCrm: 'CRM-Zielgruppe (Vorlage)',
        message: 'Nachricht',
        inboxHint: 'Freier Text — wird nur an Kontakte innerhalb des 24-Stunden-Kundenservicefensters zugestellt.',
        templateName: 'Vorlagenname',
        templateLang: 'Vorlagensprache',
        crmHint: 'Verwende eine genehmigte WhatsApp-Vorlage — erforderlich, um Kontakte außerhalb des 24-Stunden-Fensters zu erreichen.',
        send: 'Broadcast senden',
        sending: 'Wird gesendet…',
        empty: 'Noch keine Broadcasts.',
        sent: 'gesendet',
        failed: 'fehlgeschlagen',
      },
      autoReply: {
        title: 'Automatische Antworten',
        type: 'Typ',
        typeKeyword: 'Schlüsselwort',
        typeGreeting: 'Begrüßung (erste Nachricht)',
        typeAway: 'Abwesend (außerhalb der Zeiten)',
        keyword: 'Schlüsselwort',
        from: 'Zeit von',
        to: 'Zeit bis',
        reply: 'Antworttext',
        add: 'Regel hinzufügen',
        empty: 'Noch keine automatischen Antwortregeln.',
        delete: 'Löschen',
      },
    },
  },
  productStore: {
    title: 'Shop-Tab in deinem Link-in-Bio anzeigen',
    subtitle: 'Dein Shop ist derzeit ausgeblendet.',
  },
  sections: {
    splashScreen: {
      title: 'Splash Screen',
      subtitle: 'Wird angezeigt, während die Seite lädt',
    },
    promo: {
      title: 'Promo-Leiste',
      subtitle: 'Hervorhebung, mit der du Aktionen anzeigen kannst',
      masterPromoMessage:
        'Die Master-Promo-Leiste ist derzeit aktiviert. Wenn du eine individuelle Promo-Leiste für diese Seite erstellen möchtest, musst du zuerst die Master-Promo-Leiste deaktivieren.',
      titlePlaceholder: 'Willkommen auf meiner Website!',
      switcherIsMasterPromobar: 'Auf allen Seiten anzeigen',
    },
    contact: {
      title: 'Kontakte',
      subtitle: 'Stelle die Möglichkeit bereit, mit dir zu kommunizieren',
      caption: 'Füge Messenger-Buttons hinzu, um eine schnelle Verbindung zwischen dir und deinen Kunden mit nur einem Klick zu ermöglichen',
      tooltip: 'Über Kontakte können Nutzer direkt mit dir kommunizieren. Füge deine Telefonnummer, E-Mail, deinen Messenger oder Standort hinzu',
      addNewContact: 'Neuen Kontakt hinzufügen',
      addContact: 'Kontakt hinzufügen',
      chooseContact: 'Kontakt auswählen',
      enterLink: 'Kontaktlink eingeben',
      showDetails: 'Details anzeigen',
      enterAnyContact: 'Bitte gib einen Kontakt ein',
      enterAnyContactCaption: '(WhatsApp, Telegram, Viber, Messenger)',
    },
    membership: {
      title: 'Mitgliedschaft',
      subtitle: 'Erstelle ein kostenloses oder kostenpflichtiges Abo für deine Inhalte',
      addNewTier: 'Neue Stufe hinzufügen',
      editTier: 'Stufe bearbeiten',
      name: 'Name',
      nameCaption: 'Namen deiner Stufe eingeben',
      price: 'Preis pro Monat',
      priceCaption: 'Preis deiner Stufe eingeben',
      month: 'Monat',
      image: 'Bild',
      imageCaption: 'Bild für deine Stufe hochladen',
    },
    pricing: {
      title: 'Preise',
      subtitle: 'Erstelle ein Menü mit Preisen',
      add: 'Neuen Artikel hinzufügen',
      edit: 'Artikel bearbeiten',
      name: 'Name',
      nameCaption: 'Namen deines Artikels eingeben',
      duration: 'Attribut',
      durationCaption: 'Zeit, Menge oder Dauer deines Artikels eingeben',
      category: 'Kategorie',
      categoryCaption: 'Kategorie deines Artikels eingeben',
      price: 'Preis',
      priceCaption: 'Preis deines Artikels eingeben',
      month: 'Monat',
      image: 'Bild',
      imageCaption: 'Bild für deinen Artikel hochladen',
    },
    subscribe: {
      dataCollectTitle: 'Datenerfassung',
      title: 'Abonnieren',
      subtitle: 'Sammle E-Mails oder Telefonnummern deiner Besucher',
      instructionsMessage: 'Füge ein E-Mail-Anmeldefeld zu deiner Seite hinzu, damit sich deine Besucher einfach anmelden können!',
      instructionsLink: 'Übermittle E-Mails an MailChimp, um Marketingkampagnen durchzuführen.',
      sectionHeaderCaption: 'Abonniere unseren Newsletter',
      collecting: 'Erfassung',
      collectingCaption: 'Wähle deinen Eingabetyp',
      addDataToCollect: 'Zu erfassende Daten hinzufügen',
      email: 'E-Mail',
      enterEmail: 'E-Mail eingeben',
      thanksForEmail: 'Vielen Dank für deine E-Mail',
      phone: 'Telefon',
      telegram: 'Telegram',
      facebook: 'Facebook',
      instagram: 'Instagram',
      twitter: 'X (Twitter)',
      youtube: 'Youtube',
      whatsapp: 'Whatsapp',
      viber: 'Viber',
      messenger: 'Messenger',
      modalTitle: 'Aktualisierte Links hinzufügen',
      placeholder: 'Platzhalter',
      placeholderCaption: 'Platzhaltertext eingeben',
      button: 'Schaltfläche',
      buttonCaption: 'Text, der Besucher zur Eingabe ihrer E-Mail motiviert (10 % Rabatt, jetzt abonnieren, Datei herunterladen usw.)',
      submitButton: 'Senden-Button',
      enterButton: 'Senden-Schaltfläche',
      thanksMessage: 'Dankesnachricht',
      thanksMessageCaption: 'Dankesnachricht für deine Abonnenten',
      resultAction: 'Aktion (nach dem Absenden)',
      resultActionCaption: 'Aktion nach dem Ausfüllen des Formulars',
      sendAnEmail: 'E-Mail senden',
      downloadFile: 'Datei herunterladen',
      redirect: 'Weiterleiten',
      messageBody: 'Nachrichtentext',
      messageBodyCaption: 'Diese Daten werden als Geschenk an die E-Mail-Adresse des Nutzers gesendet (Coupon, Link zum Datei-Download usw.)',
      integration: 'Integration',
      integrationCaption: 'Übermittle die E-Mail-Adressen deiner Besucher an MailChimp, Reply',
      storage: 'Speicher',
      storageCaption: 'Speichere die Bestellungen deiner Besucher in einem Google Spreadsheet',
      maxSize: 'Du kannst maximal 3 Kanäle hinzufügen',
    },
    text: {
      title: 'Text',
      subtitle: 'Schreibe etwas über dich/dein Unternehmen',
      trimBio: '„Mehr anzeigen“-Schaltfläche',
    },
    header: {
      title: 'Header',
      subtitle: 'Vergrößertes Titelbild oder Video auf deiner Seite',
      verifiedBadge: 'Verifiziert-Abzeichen',
      showProfilePic: 'Profilbild anzeigen',
      profilePicRatio: 'Verhältnis',
      profilePicRatioSquare: 'Quadratisch',
      profilePicRatioLandscape: 'Querformat',
      profilePicRatioPortrait: 'Hochformat',
      namePlaceholder: 'Dein Name',
      shortBioPlaceholder: 'Meine Kurzinfo',
      externalLinkPlaceholder: 'URL',
      locationPlaceholder: 'Stadt',
      addSocial: '+ Soziales Netzwerk hinzufügen',
      addCover: '+ Cover hinzufügen',
      addButton: '+ Schaltfläche hinzufügen',
      addText: '+ Text hinzufügen',
      addLabel: '+ Label hinzufügen',
      subtitleName: 'Erscheinungsbild deines Namens anpassen',
      subtitleShortBio: 'Erscheinungsbild deiner Kurzbio anpassen',
      shortBioSize: 'Größe der Kurzbio',
      subtitleShortBioSize: 'Du kannst die Größe der Kurzbio ändern',
      subtitleLocation: 'Lege Stadt/Land fest, um Besucher an einen bestimmten Ort zu leiten',
      headerCoverWarningMessage: 'Dein Browser unterstützt das Video-Tag nicht.',
      headerCoverTitle: 'Cover über dem Header festlegen',
      coverHeight: 'Cover-Höhe',
      subtitleCoverHeight: 'Du kannst die Cover-Höhe ändern',
      coverDarkness: 'Cover-Verdunkelung',
      subtitleCoverDarkness: 'Ziehe den Schieberegler, um das Coverbild abzudunkeln',
      nameSize: 'Namensgröße',
      subtitleNameSize: 'Du kannst die Namensgröße ändern',
      positionText: 'Namensposition',
      subtitlePositionName: 'Ziehe den Schieberegler, um die Namensposition festzulegen',
      positionContent: 'Inhaltsposition',
      subtitlePositionContent: 'Lege die Position für Bio, Link und Ort fest',
      coverText: 'Text auf dem Cover',
      subtitleCoverText: 'Füge Text zu deinem Cover hinzu',
      position: 'Position',
      subtitlePosition: 'Ziehe den Schieberegler, um die Position der Schaltfläche festzulegen',
      buttonCover: 'Schaltfläche auf dem Cover',
      subtitleButtonCover: 'Füge deinem Cover eine Schaltfläche hinzu, indem du eine Aktion wählst',
      subtitleFollow: 'Mit der Folgen-Schaltfläche können Nutzer deinen Neuigkeiten folgen',
      buttonOpacity: 'Ziehe den Schieberegler, um die Deckkraft der Schaltfläche zu ändern',
      subtitleCart: 'Warenkorb-Symbol für ein Einkaufserlebnis',
      subtitleDirect: 'Schnell-Button, um Besucher zu Messengern zu leiten',
      subtitleCTAButton: '(Call-to-Action) Button, der zum Klicken motiviert',
      subtitleSocialLinks: 'Verleihe deinen sozialen Netzwerken einen visuellen Look',
      chooseSocialLink: 'Sozialen Link auswählen',
      alignSocialLink: 'Ausrichtung der sozialen Links',
      enterYourSocialLink: 'Gib deinen sozialen Link ein',
      blockShadow: 'Blockschatten',
      activeButtonPosition: 'Position des aktiven Buttons',
      gradientColor: 'Verlaufsfarbe',
      bottomGradient: 'Unterer Verlauf',
      autoGradient: 'Auto',
      customGradient: 'Benutzerdefiniert',
      transparentGradient: 'Transparent',
      uploadLogo: 'Logo hochladen',
      customBackground: 'Benutzerdefinierter Hintergrund',
      headingLabel: 'Überschrift',
      customizeLabel: 'Passe das Erscheinungsbild deiner Überschrift an',
      labelText: 'Beschriftungstext',
      enterLabelText: 'Gib den Text für die Überschrift ein',
      verticalCropStep: 'vertikales Foto',
      squareCropStep: 'quadratischer Avatar',
      topButtons: 'Obere Buttons',
      bottomButtons: 'Untere Buttons',
      buttonSubtitleLanguage: 'Sprachumschalter',
      buttonSubtitleContact: 'Anrufen / Nachricht',
      buttonSubtitleCart: 'Warenkorb',
      buttonSubtitleCta: 'Handlungsaufforderung',
      buttonSubtitleMessage: 'Nachricht',
      buttonSubtitleSubscribe: 'Abonnieren',
      buttonSubtitleQrcode: 'QR-Code',
      buttonSubtitleSearch: 'Produktsuche',
      buttonDisabledHint: 'Verborgen · deaktiviert',
      gradientPositionLabel: 'Schattenposition',
      gradientPositionPhoto: 'Unter dem Foto',
      gradientPositionHeader: 'Tiefer im Header',
      bottomBadge: 'Untere Tönung',
      addTint: 'Tönung hinzufügen',
      bottomBadgeText: 'Text (optional)',
      bottomBadgePreset: 'Vorlage',
      bottomBadgeShape: 'Form',
      bottomBadgeSize: 'Höhe',
      bottomBadgeAction: 'Aktion',
      bottomBadgeBgColor: 'Hintergrundfarbe',
      bottomBadgeTextColor: 'Textfarbe',
      bottomBadgeGradientFrom: 'Farbverlauf von',
      bottomBadgeGradientTo: 'Farbverlauf bis',
      bottomBadgeGradientAngle: 'Farbverlaufswinkel',
    },
  },
  billingHistory: {
    title: 'Rechnungsverlauf',
    invoices: 'Rechnungen',
    messageText: 'Du hast noch keinen Zahlungsverlauf.',
  },
  migrate: {
    title: 'Hast du LinkTree oder Taplink?',
    text: 'Link einfügen und mit nur einem Klick zu UniLink migrieren!',
    button: 'Migrieren',
  },
  pages: {
    title: 'Seiten',
    addPage: 'Seite hinzufügen',
    addNewPage: 'Neue Seite hinzufügen',
    deleteTitle: 'Möchtest du diese Seite wirklich löschen?',
    managePage: 'Tabs verwalten',
    empty: 'Diese Seite enthält noch keinen Block.',
    dragAndDrop: 'Ziehe deine anderen Tabs per Drag & Drop, um sie neu anzuordnen',
    pageNavigation: 'Einstellungen der Seitennavigation',
    goToDesign: 'Zu den Design-Einstellungen',
    viewArchive: 'Archiv anzeigen',
    archivedBlocks: 'Archivierte Blöcke',
    noArchivedBlocks: 'Halte deine Seite übersichtlich, indem du Blöcke archivierst, die du gerade nicht verwendest.',
    archiveAllUnpublished: 'Alle unveröffentlichten Blöcke archivieren',
    restore: 'Wiederherstellen',
    permanentDelete: 'Endgültig löschen',
  },
  analytics: {
    lifeTimeAnalytics: 'Lifetime-Analytics',
    impressions: 'Impressionen',
    impressionsText: 'Verlauf der Impressionen-Statistik für den gewählten Zeitraum',
    clicks: 'Klicks',
    clicksText: 'Verlauf der "Klick"-Ereignisse für den gewählten Zeitraum',
    signUps: 'Anmeldungen',
    signUpsText: 'Verlauf der "Schließen"-Ereignisse für den gewählten Zeitraum',
    totalInteractions: 'Interaktionen',
    totalInteractionsText: 'Klicks und Formular-Anmeldungen im gewählten Zeitraum',
    engagementRate: 'Engagement-Rate',
    engagementRateText: 'Anteil der Profilaufrufe, die zu einer Interaktion führten',
    visitor: 'Besucherquellen',
    country: 'Land',
    countries: 'Länder',
    linkClicks: 'Link-Klicks',
    content: 'Inhalt',
    views: 'Aufrufe',
    links: 'Links',
    products: 'Produkte',
    blocks: 'Blöcke',
    pages: 'Seiten',
    clicksLower: 'Klicks',
    of: 'von',
    noContentData: 'Noch keine Daten für den gewählten Zeitraum',
  },
  aiInsights: {
    title: 'AI-Insights',
    generate: 'Mein Profil analysieren',
    description: 'Erhalte AI-gestützte Empfehlungen, um die Performance deines Profils zu verbessern.',
    analyzing: 'Profil wird analysiert...',
    refresh: 'Aktualisieren',
    action: 'Aktion',
  },
  post: {
    subscriptionTypePlaceholder: `Verfügbar ab dem 'type'-Abo`,
    postButtonText: 'Beitrag',
    newPostPlaceholder: 'Was beschäftigt dich',
    free: 'Kostenlos',
    pro: 'Pro',
    premium: 'Premium',
    noPost: 'Du hast noch keine Beiträge',
    editPost: 'Beitrag bearbeiten',
  },
  preview: {
    buy: 'Kaufen',
    connect: 'Verbinden',
  },
  activeButton: {
    initialText: 'Website',
    inputPlaceholder: 'Aktionen suchen...',
    existing: 'Vorhanden',
    redirect: 'Weiterleitung',
    scroll: 'Scrollen',
    title: 'Aktiver Button',
    modalTitle: 'Aktion des aktiven Buttons',
    subtitle: 'Button, der den Nutzer zu einer Aktion motiviert',
    next: 'Weiter',
    save: 'Speichern',
    opensALinkFromLinksBlock: 'Öffnet einen Link aus dem Links-Block',
    url: 'URL',
    opensAWebsite: 'Öffnet eine Website',
    openInApp: 'In App öffnen',
    addAction: 'Aktion hinzufügen',
    actionTitle: 'Aktion',
    actionCaption: 'Aktionstyp bearbeiten',
    chooseOption: 'Option auswählen',
    tellPeople: 'Erkläre den Nutzern, wie sie den Aktions-Button verwenden',
    urlRedirect: 'URL-Weiterleitung',
    customUrl: 'Benutzerdefinierte URL',
    customUrlText: 'Öffnet eine Website',
    links: 'Links',
    linksText: 'Öffnet einen Link aus dem Links-Block',
    downloadDocument: 'Dokument herunterladen',
    sendEmail: 'E-Mail senden',
    opensEmailClient: 'Öffnet den E-Mail-Client',
    phoneCall: 'Telefonanruf',
    initiatesPhoneCall: 'Startet einen Telefonanruf',
    navigation: 'Navigation',
    openPage: 'Seite öffnen',
    opensInternalPage: 'Öffnet eine interne Seite',
    openPageText: 'Öffnet eine interne Seite',
    openProduct: 'Produkt öffnen',
    openProductText: 'Öffnet die Produktseite aus dem Store',
    openBlog: 'Blog öffnen',
    opensBlogPageFromStore: 'Öffnet die Blog-Seite aus dem Store',
    openBlock: 'Block öffnen',
    opensContentBlock: 'Öffnet einen Inhaltsblock',
    openItem: 'Element öffnen',
    opensItemPageFromStore: 'Öffnet die Element-Seite aus dem Store',
    showNewModal: 'Neues Modal anzeigen',
    displayContentInModalWindow: 'Inhalt im modalen Fenster anzeigen',
    showProduct: 'Produkt anzeigen',
    displayProductInModalWindow: 'Produkt im modalen Fenster anzeigen',
    showBlog: 'Blog anzeigen',
    scrollToBlock: 'Zum Block scrollen',
    scrollToBlockText: 'Zum angegebenen Seitenblock scrollen',
    scrollToItem: 'Zum Element scrollen',
    action: 'Aktion',
    showBlock: 'Block anzeigen',
    showBlockText: 'Inhaltsblock aus dem Store',
    showItem: 'Element anzeigen',
    showItemText: 'Öffnet die Elementseite aus dem Store',
    linksCaption: 'Links',
    linksTooltip: 'Wähle einen Link aus dem Links-Block',
    pagesCaption: 'Seiten',
    pagesTooltip: 'Wähle eine Seite aus den Seiten',
    productsCaption: 'Produkte',
    productsTooltip: 'Wähle ein Produkt aus der Liste',
    blocksCaption: 'Blöcke',
    blocksTooltip: 'Wähle einen Block aus der Liste',
    itemsCaption: 'Elemente',
    itemsTooltip: 'Wähle ein Element aus der Liste',
    showProductText: 'Produkt in einem modalen Fenster auf der Seite anzeigen',
    more: 'Mehr anzeigen',
    less: 'Weniger anzeigen',
    showNewModalTitle: 'Neue Modaldaten',
    uploadDocumentTitle: 'Zum Hochladen klicken oder per Drag & Drop ziehen',
    uploadProgressTitle: 'Wird hochgeladen...',
    haveNoModal: 'Du hast kein Modal',
    haveModal: 'Du hast ein Modal ausgewählt',
    openNewModalHandler: 'Neues Modal erstellen',
    linkGroupSubTitle: 'Block auswählen',
    linkItemSubTitle: 'Link auswählen',
    urlItemSubTitle: 'Website-URL',
    openInAppItemSubTitle: 'App-URL',
    sendEmailItemSubTitle: 'E-Mail-Adresse',
    phoneCallItemSubTitle: 'Telefonnummer',
    openPageGroupSubTitle: 'Seite auswählen',
    openPageItemSubTitle: 'Seite auswählen',
    openProductGroupSubTitle: 'Produkttyp auswählen',
    openProductItemSubTitle: 'Produkt auswählen',
    openBlogGroupSubTitle: 'Blog-Kanal auswählen',
    openBlogItemSubTitle: 'Blog-Artikel auswählen',
    openBlockGroupSubTitle: 'Seite auswählen',
    openBlockItemSubTitle: 'Block auswählen',
    openItemGroupSubTitle: 'Block auswählen',
    openItemItemSubTitle: 'Element auswählen',
    showProductGroupSubTitle: 'Produkttyp auswählen',
    showProductItemSubTitle: 'Produkt auswählen',
    showBlogGroupSubTitle: 'Blog-Kanal auswählen',
    showBlogItemSubTitle: 'Blog-Artikel auswählen',
    showBlockGroupSubTitle: 'Seite auswählen',
    showBlockItemSubTitle: 'Block auswählen',
    showItemGroupSubTitle: 'Block auswählen',
    showItemItemSubTitle: 'Element auswählen',
    scrollToBlockGroupSubTitle: 'Seite auswählen',
    scrollToBlockItemSubTitle: 'Block auswählen',
    scrollToItemGroupSubTitle: 'Block auswählen',
    scrollToItemItemSubTitle: 'Element auswählen',
    linkGroupPlaceholder: 'Block auswählen ...',
    linkItemPlaceholder: 'Link auswählen ...',
    openPageItemPlaceholder: 'Seite auswählen ...',
    openProductGroupPlaceholder: 'Produkttyp auswählen ...',
    openProductItemPlaceholder: 'Produkt auswählen ...',
    showProductGroupPlaceholder: 'Produktgruppe auswählen ...',
    showProductItemPlaceholder: 'Produkt auswählen ...',
    openBlogGroupPlaceholder: 'Blog-Kanal auswählen ...',
    openBlogItemPlaceholder: 'Blog-Artikel auswählen ...',
    openBlockGroupPlaceholder: 'Seite auswählen ...',
    openBlockItemPlaceholder: 'Block auswählen…',
    openItemGroupPlaceholder: 'Seite und Block auswählen…',
    openItemItemPlaceholder: 'Element auswählen…',
    showBlogGroupPlaceholder: 'Blog-Gruppe auswählen…',
    showBlogItemPlaceholder: 'Blogbeitrag auswählen…',
    showBlockGroupPlaceholder: 'Seite auswählen…',
    showBlockItemPlaceholder: 'Block auswählen…',
    showItemGroupPlaceholder: 'Seite und Block auswählen…',
    showItemItemPlaceholder: 'Element auswählen…',
    scrollToBlockGroupPlaceholder: 'Seite auswählen…',
    scrollToBlockItemPlaceholder: 'Block auswählen…',
    scrollToItemGroupPlaceholder: 'Seite und Block auswählen…',
    scrollToItemItemPlaceholder: 'Element auswählen…',
    linkReadable: 'Link',
    urlReadable: 'URL',
    openInAppReadable: 'In App öffnen',
    downloadDocumentReadable: 'Dokument herunterladen',
    sendEmailReadable: 'E-Mail senden',
    phoneCallReadable: 'Anrufen',
    openPageReadable: 'Seite öffnen',
    openProductReadable: 'Produkt öffnen',
    showNewModalReadable: 'Neues Modal anzeigen',
    showProductReadable: 'Produkt anzeigen',
    openBlogReadable: 'Blog öffnen',
    openBlockReadable: 'Block öffnen',
    openItemReadable: 'Element öffnen',
    showBlogReadable: 'Blog anzeigen',
    showBlockReadable: 'Block anzeigen',
    showItemReadable: 'Element anzeigen',
    scrollToBlockReadable: 'Zu Block scrollen',
    scrollToItemReadable: 'Zu Element scrollen',
  },
  design: {
    tabs: 'Tabs',
    imageView: 'Bildansicht',
    preview: 'Vorschau',
    buttonOpacity: 'Button-Deckkraft',
    buttonBorder: 'Button-Rahmen',
    buttonShadow: 'Button-Schatten',
    itemView: 'Elementansicht',
    itemViewTooltip: 'Elementansicht auswählen',
    itemLayout: 'Element-Layout',
    itemLayoutTooltip: 'Element-Layout auswählen',
    top: 'Oben',
    center: 'Mitte',
    bottom: 'Unten',
    bottomLeft: 'Unten links',
    bottomHorizontal: 'Unten horizontal',
    under: 'Darunter',
    title: 'Titel',
    titleButton: 'Titel & Button',
    displayOptions: 'Anzeigeoptionen',
    displayOptionsTooltip: 'Anzeigeoptionen auswählen',
    landscape: 'Querformat',
    square: 'Quadrat',
    portrait: 'Hochformat',
    desktopMode: 'Desktop-Modus',
    mobile: 'Kompakt',
    desktop: 'Breit',
    responsive: 'Responsiv',
    custom: 'Benutzerdefiniert',
    templates: 'Vorlagen',
    chooseTemplates: 'Wähle deine Vorlagen',
    viewAll: 'Alle anzeigen',
    previousTheme: 'Bitte beachte, dass das vorherige Theme dauerhaft gelöscht wird.',
    useThisTemplate: 'Diese Vorlage verwenden',
    notSupportedVideo: 'Dein Browser unterstützt das Video-Tag nicht.',
    photosBy: 'Fotos von',
    animationBy: 'Animation von',
    searchTheSame: 'Suche denselben Begriff erneut für andere Ergebnisse.',
    addImage: 'Bild hinzufügen',
    addVideo: 'Video hinzufügen',
    orSelectFrom: 'oder wähle aus',
    noImagesYet: 'Noch keine Bilder',
    noVideosYet: 'Noch keine Videos',
    videoBy: 'Video von',
    hamburgerMenu: 'Hamburger-Menü',
    tabsOnTop: 'Tabs oben',
    tabsOnBottom: 'Tabs unten',
    borderType: 'Rahmentyp',
    subTitle: 'Wähle Form, Rahmentyp, Schatten usw.',
    icon: 'Icon',
    iconTooltip: 'Wähle das passende Icon für deinen Button',
    background: 'Hintergrund',
    color: 'Farbe',
    backgroundOpacity: 'Hintergrund-Deckkraft',
    backgroundOpacityTooltip: 'Schieberegler ziehen, um die Hintergrund-Deckkraft einzustellen',
    gradient: 'Verlauf',
    color1: 'Farbe 1',
    color2: 'Farbe 2',
    direction: 'Richtung',
    directionTooltip: 'Schieberegler ziehen, um die Richtung des Verlaufs einzustellen',
    offset: 'Versatz',
    offsetTooltip: 'Schieberegler ziehen, um den Versatz des Verlaufs einzustellen',
    minHeight: 'Mindesthöhe',
    minHeightTooltip: 'Ziehe den Schieberegler, um die Mindesthöhe des Buttons zu ändern',
    align: 'Ausrichten',
    alignTooltip: 'Button-Position ändern',
    insert: 'URL einfügen',
    upload: 'Video hochladen',
    search: 'Video suchen',
    layout: 'Layout',
    layoutTooltip: 'Wähle das gewünschte Layout',
    view: 'Ansicht',
    viewTooltip: 'Wähle die gewünschte Ansicht',
    media: 'Medien',
    mediaTooltip: 'Wähle die gewünschten Medien',
    none: 'Keine',
    small: 'Klein',
    medium: 'Mittel',
    large: 'Groß',
    round: 'Rund',
    feed: 'Feed',
    slider: 'Slider',
    text: 'Text',
    colorTooltip: 'Farben wählen',
    button: 'Button',
    buttonTooltip: 'Button-Farben wählen',
    chooseEmoji: 'Emoji wählen',
    changeEmoji: 'Emoji ändern',
    quantum: 'Quantum',
    emoji: 'Emoji',
    warp: 'Warp',
  },
  components: {
    quickAdd: {
      addLink: 'Link hinzufügen',
      addVideo: 'Video hinzufügen',
      addProduct: 'Produkt hinzufügen',
      addPost: 'Beitrag hinzufügen',
      addArticle: 'Artikel hinzufügen',
      addPhoto: 'Foto hinzufügen',
      addMusic: 'Musik hinzufügen',
      addFiles: 'Dateien hinzufügen',
      addStory: 'Story hinzufügen',
    },
    emoji: {
      search: 'Suchen',
      clear: 'Löschen',
      notfound: 'Kein Emoji gefunden',
      skintext: 'Wähle deinen Standard-Hautton',
      categories: {
        search: 'Suchergebnisse',
        recent: 'Häufig verwendet',
        smileys: 'Smileys & Emotionen',
        people: 'Menschen & Körper',
        nature: 'Tiere & Natur',
        foods: 'Essen & Trinken',
        activity: 'Aktivität',
        places: 'Reisen & Orte',
        objects: 'Objekte',
        symbols: 'Symbole',
        flags: 'Flaggen',
        custom: 'Benutzerdefiniert',
      },
      categorieslabel: 'Emoji-Kategorien',
      skintones: {
        1: 'Standard-Hautton',
        2: 'Heller Hautton',
        3: 'Mittelheller Hautton',
        4: 'Mittlerer Hautton',
        5: 'Mitteldunkler Hautton',
        6: 'Dunkler Hautton',
      },
    },
    blogPreviewModal: {
      title: 'Blog-Vorschau',
      notify: 'Abonnenten benachrichtigen',
    },
    standAloneModal: {
      title: 'Link-Vorschau',
      save: 'Speichern',
      chooseLayout: 'Wähle ein Layout für deinen Link',
      linkSettings: 'Link-Einstellungen',
      linkSettingsSubtitle: 'Weiterleitung, Erscheinungsbild',
      whenVisitorsClicks: 'Wenn ein Besucher auf diesen Link klickt:',
      redirect: 'Weiterleiten',
      redirectText: 'Besucher direkt zur URL weiterleiten',
      highlight: 'Hervorheben',
      highlightText: 'Besucher zu deinem UniLink schicken und hervorheben',
      standalone: 'Eigenständig',
      standaloneText: 'Hebe deinen YouTube-Link hervor und lass den Inhalt direkt auf deinem',
      cover: 'Cover',
      imageTab: 'Bild',
      videoTab: 'Video',
      uploadImage: 'Bild hochladen',
      whenVisitors: 'Wenn ein Besucher den geteilten Link auswählt:',
      compact: 'Kompaktansicht',
      fullView: 'Vollansicht',
      videoSound: 'Video mit Ton abspielen',
    },
    instagramModal: {
      title: 'Automatische Instagram-DMs senden',
      subtitle: 'Sende diesen Link per Direktnachricht, wenn jemand deinen IG-Beitrag oder Reel kommentiert',
      promo: 'Wähle, von welchem IG du senden möchtest',
      connect: 'Instagram-Konto verbinden',
      added: 'Instagram-Konto hinzugefügt',
      addNew: 'Neue Automatisierung hinzufügen',
      igContent: 'IG-Inhalt',
      trigger: 'Auslöser',
      dmContent: 'DM',
      linkDestination: 'Link-Ziel',
      buttonTitle: 'Button-Titel',
      buttonTitleTooltip: 'Button-Titel eingeben',
      directMessage: 'Direktnachricht',
      directMessageTooltip: 'Direktnachricht eingeben',
      selectPosts: 'Wähle den Beitrag oder Reel aus, der deine automatische DM auslöst.',
      onePost: 'Ein bestimmter Beitrag oder Reel',
      allPosts: 'Alle Beiträge oder Reels',
      triggerText: 'Wenn Kommentare dies enthalten, wird deine DM gesendet.',
      addMessage: 'Füge eine Nachricht hinzu, die automatisch mit deinem Link gesendet wird.',
      clickLink: 'Wenn jemand auf den Link in deiner DM klickt:',
      anyComment: 'Jeder Kommentar',
      storiesAndDms: 'Stories & DMs',
      anyMessage: 'Jede Nachricht',
      specificKeywords: 'Kommentare mit bestimmten Stichwörtern',
      sendLink: 'Sende sie zu deinem UniLink und hebe hervor ',
      skipLink: 'UniLink überspringen und sie direkt senden',
      keywordsTitle: 'Kommentare mit bestimmten Stichwörtern',
      keywordsText: 'Deine DMs werden gesendet, wenn Kommentare bestimmte\nStichwörter enthalten oder ausschließen (Groß-/Kleinschreibung wird nicht beachtet):',
      keywordsPlaceholder: 'Stichwort eingeben',
      keywordsExclude: 'Stichwörter ausschließen',
      keywordsExcludeText: 'Muss eines dieser ausschließen',
      replyComment: 'Antwortkommentar',
      replyCommentTooltip: 'Antwortkommentar eingeben',
    },
    blockEditProduct: {
      productPreview: 'Vorschaubild',
      productDetails: 'Details',
      settings: 'Einstellungen',
      design: 'Design',
    },
    editMenuItems: {
      overview: 'Übersicht',
      analytics: 'Analytics',
    },
    botToken: {
      bot: 'Bot',
      botTooltip: 'Token deines Bots eingeben',
      connect: 'Verbinden',
      token: 'Token',
    },
    rewards: {
      title: 'Titel',
      titleTooltip: 'Titel für Antwort eingeben',
      text: 'Text',
      textTooltip: 'Text für Antwort eingeben',
      link: 'Link',
      linkTooltip: 'Link für Antwort eingeben',
      code: 'Code',
      codeTooltip: 'Code für Antwort eingeben',
      files: 'Dateien',
      filesTooltip: 'Dateien für Antwort eingeben',
      removeReward: 'Möchtest du diese Antwort wirklich entfernen?',
    },
    addRewardModal: {
      addReward: 'Antwort hinzufügen',
      textTitle: 'Text',
      textText: 'Zugriff auf Anleitung oder beliebigen Text mit Rich Editor gewähren',
      fileTitle: 'Dateien',
      fileText: 'Zugriff auf Dateien gewähren und Kontaktdaten sammeln',
      linkTitle: 'Link',
      linkText: 'Zugriff auf exklusive Inhalte gewähren und Kontaktdaten sammeln',
      codeTitle: 'Code',
      codeText: 'Zugriff auf exklusive Aktionen gewähren und Kontaktdaten sammeln',
    },
    blockEmpty: {
      isNotAdded: 'ist nicht hinzugefügt',
      itSeems: 'Es scheint, dass dein',
      itemsNot: 'Elemente noch nicht hinzugefügt sind. Füge jetzt deine Videos hinzu',
      add: 'Hinzufügen',
    },
    blockList: {
      add: 'Hinzufügen',
      item: 'Element',
    },
    submitAction: {
      action: 'Aktion (nach dem Absenden)',
      actionTooltip: 'Aktion nach dem Absenden wählen',
      upload: 'Anhänge hochladen',
      none: 'Keine',
      page: 'Bestätigungsseite anzeigen',
      email: 'Bestätigungs-E-Mail senden',
      redirect: 'Zu URL weiterleiten',
    },
    blockEditItem: {
      content: 'Inhalt',
      preview: 'Vorschau',
      settings: 'Einstellungen',
    },
    domainButton: {
      customizeDomain: 'Passe deine Domain an.',
      upgradeToLink: 'Auf Link in Bio Pro upgraden und eigene Domain nutzen.',
    },
    coverText: {
      text: 'Text',
      textTooltip: 'Text für dein Cover eingeben',
      description: 'Beschreibung',
      descriptionTooltip: 'Beschreibung für dein Cover eingeben',
      textColor: 'Textfarbe',
    },
    itemModal: {
      edit: 'Bearbeiten',
      addNew: 'Neu hinzufügen',
      item: 'Element',
      update: 'Aktualisieren',
      add: 'Hinzufügen',
    },
    productSheet: {
      openFullEditor: 'Vollständigen Editor öffnen',
      copyLink: 'Link kopieren',
      active: 'Aktiv',
      notActive: 'Inaktiv',
      statistics: 'Statistik',
      clicks: 'Klicks',
      sales: 'Verkäufe',
      revenue: 'Umsatz',
      onlyName: 'Nur der Name ist erforderlich',
      name: 'Name',
      required: 'Erforderlich',
      price: 'Preis',
      optional: 'Optional',
      free: 'Kostenlos',
      appearance: 'Darstellung',
      cover: 'Titelbild',
      coverNote: 'Quadratisch, ab 600×600. Kann später hinzugefügt werden.',
      description: 'Beschreibung',
      descriptionPlaceholder: 'Eine Zeile darüber, was enthalten ist',
      remove: 'Entfernen',
      photo: 'Foto',
      enterName: 'Namen eingeben',
      adding: 'Wird hinzugefügt…',
    },
    viewDesign: {
      compact: 'Kompakt',
      card: 'Karte',
      button: 'Schaltfläche',
      list: 'Liste',
      hero: 'Hero',
      featured: 'Hervorgehoben',
    },
    moveItemModal: {
      title: 'Element auf andere Seite verschieben',
      cancel: 'Abbrechen',
      move: 'Verschieben',
      page: 'Seite',
      pageTooltip: 'Seite zum Verschieben des Elements wählen',
      blocks: 'Blöcke',
      blocksTooltip: 'Block zum Verschieben des Elements wählen',
      emptyBlocks: 'Auf dieser Seite gibt es keine passenden Blöcke.',
    },
    limitModal: {
      title: 'Limit erreicht',
      text1: 'Du hast das Limit deiner Website erreicht.',
      text2: 'Bitte kontaktiere uns, um deinen Tarif zu upgraden.',
      close: 'Schließen',
    },
    cropPicture: {
      title: 'Bild zuschneiden',
      cancel: 'Abbrechen',
      save: 'Speichern',
    },
    uploadFile: {
      uploadProductImage: 'Produktbild hochladen',
      coverImage: 'Titelbild',
      uploadImages: 'Hier kannst du nur Bilder hochladen',
    },
    userMediaLibrary: {
      addImage: 'Bild hinzufügen',
      uploadImage: 'Bild hochladen',
      orSelectFrom: 'oder hochladen',
      orSelectLink: 'oder Link einfügen',
      myMedia: 'Meine Medien',
      stockImages: 'Stockfotos',
      gifs: 'GIFs',
      icons: 'Symbole',
      noImagesYet: 'Noch keine Bilder',
      loadMore: 'Mehr laden',
    },
    itemMenu: {
      active: 'Aktiv',
      willBeAvailable: 'Das Element ist verfügbar unter:',
      save: 'Speichern',
      copied: 'Kopiert',
      copyLink: 'Link kopieren',
      delete: 'Löschen',
    },
    itemDesign: {
      linkColor: 'Linkfarbe',
      gradient: 'Verlauf',
      background: 'Hintergrund',
      backgroundOpacity: 'Hintergrund-Deckkraft',
      backgroundOpacityTooltip: 'Schieberegler ziehen, um die Hintergrund-Deckkraft einzustellen',
      backgroundDarkness: 'Hintergrund-Dunkelheit',
      backgroundDarknessTooltip: 'Schieberegler ziehen, um die Hintergrund-Dunkelheit einzustellen',
      text: 'Text',
      color1: 'Farbe 1',
      color2: 'Farbe 2',
      direction: 'Richtung',
      directionTooltip: 'Schieberegler ziehen, um die Richtung des Verlaufs einzustellen',
      offset: 'Versatz',
      offsetTooltip: 'Schieberegler ziehen, um den Versatz des Verlaufs einzustellen',
      linkHeight: 'Linkhöhe',
      linkHeightTooltip: 'Schieberegler ziehen, um die Höhe des Buttons zu ändern',
      icon: 'Symbol',
      iconTooltip: 'Symbol für deinen Button auswählen',
      imageShape: 'Bildform',
      imageShapeTooltip: 'Bildform für deinen Link auswählen',
    },
    menu: {
      linkInBio: 'Link in Bio',
      linkInBioApps: 'Link in Bio',
      posts: 'Beiträge',
      audience: 'Zielgruppe',
      orders: 'Bestellungen',
      marketing: 'Marketing',
      emailMarketing: 'E-Mail-Marketing',
      socialPlanner: 'Social Planner',
      shortLinks: 'Kurzlinks',
      businessCards: 'Visitenkarten',
      recentProfiles: 'Letzte Profile',
      standalonePage: 'Eigenständige Seite',
      soloApps: 'App in Bio',
      bots: 'Bots',
      smartReply: 'Instagram Reply',
      analytics: 'Analytics',
      settings: 'Einstellungen',
      shop: 'Verdienen',
      publish: 'Veröffentlichen',
      studio: 'Studio',
      blog: 'Blog',
      qrCodes: 'QR-Codes',
      singlePages: 'Apps',
      forms: 'Formulare',
      form: 'Formulare',
      automations: 'Automatisierungen',
      community: 'Community',
      messages: 'Posteingang',
      agents: 'Agenten',
      apps: 'Apps',
      emailSignatures: 'E-Mail-Signaturen',
      virtualBackgrounds: 'Virtuelle Hintergründe',
    },
    notificationsBlockSetting: {
      title: 'Benachrichtigungen',
      setUp: 'Einrichten',
      notifications: 'Benachrichtigungen',
      connect: 'Verbinden',
      telegramText: 'Telegram-Benachrichtigung erhalten, wenn jemand',
      change: 'Änderung',
      email: 'E-Mail',
      emailText: 'Eine E-Mail erhalten, wenn jemand',
      webhook: 'Webhook',
      webhookTooltip: 'Webhook hinzufügen',
      activate: 'Aktivieren',
      webhookText: 'Ereignis an Drittanbieter-Website senden, wenn jemand eine Aktion ausführt',
      webhookURL: 'Webhook-URL (POST-Anfrage)',
      error: 'Korrekten Link eingeben',
      save: 'Speichern',
    },
    navigation: {
      content: 'Inhalt',
      pages: 'Seiten',
      posts: 'Beiträge',
      shop: 'Shop',
      blog: 'Blog',
      design: 'Design',
      analytics: 'Analytics',
      settings: 'Einstellungen',
      apps: 'Apps',
      store: 'Shop',
    },
    headerSettings: {
      design: 'Design',
      analytics: 'Analytics',
      settings: 'Einstellungen',
      editTabs: 'Tabs bearbeiten',
    },
    unlockModal: {
      title: 'Pro-Funktionen freischalten',
      text: 'Hol mehr aus deinem Link-in-Bio heraus. Für nur 5 $/Monat – schalte alles frei, was Pro zu bieten hat:',
      checkBoxTitle1: 'Mehr Blöcke:',
      checkBoxText1: 'Formulare, Shops, Countdowns & Mediaplayer hinzufügen',
      checkBoxTitle2: 'Erweiterte Analytics:',
      checkBoxText2: 'Klicks, Aufrufe & Zielgruppen-Insights verfolgen',
      checkBoxTitle3: 'Eigene Domain:',
      checkBoxText3: 'Nutze deine eigene Domain für einen professionellen Auftritt',
      checkBoxTitle4: 'Integrierter Shop:',
      checkBoxText4: 'Produkte verkaufen und Bestellungen einfach verwalten',
      checkBoxTitle5: 'SEO-Tools:',
      checkBoxText5: 'Höher ranken mit Meta-Tags, UTM & individuellen Slugs',
      checkBoxTitle6: 'Integrationen:',
      checkBoxText6: 'Synchronisierung mit Mailchimp, Zapier & weiteren Tools',
      checkBoxTitle7: 'E-Mail-Marketing:',
      checkBoxText7: 'Leads sammeln & automatisierte Kampagnen senden',
      checkBoxTitle8: 'Priority-Support:',
      checkBoxText8: 'Schnellere Hilfe, wann immer du sie brauchst',
      upgradeToPro: 'Upgrade auf Pro',
      viewAllPlans: 'Alle Pläne ansehen',
    },
    profileSwitcher: {
      title: 'Alle Profile',
      button: 'Neues Profil hinzufügen',
    },
    account: {
      signOut: 'Abmelden',
      createNew: 'Neuen Link in Bio erstellen',
      tryPro: 'Jetzt Pro testen!',
      tryProText: 'Erhalte erweiterte Anpassungsmöglichkeiten und tiefere Einblicke in deine Zielgruppe, um mehr Besucher zu gewinnen!',
    },
    accountSettings: {
      title: 'Kontoeinstellungen',
    },
    billingHistory: {
      title: 'Rechnungsverlauf',
    },
    pages: {
      home: 'Startseite',
      newPage: 'Neue Seite',
      managePages: 'Seiten verwalten',
    },
    blockItem: {
      actionRequired: 'Aktion erforderlich',
      hidden: 'Verborgen · niemand sieht es',
    },
    blockContent: {
      untitled: 'Ohne Titel',
      clickToRename: 'Klicken, um Untertitel umzubenennen',
      saving: 'wird gespeichert',
      saved: 'gespeichert',
      deleteTitle: 'Möchtest du diesen Block wirklich löschen?',
      cancel: 'Abbrechen',
      yes: 'Ja',
    },
    addButtonModal: {
      title: 'Aktions-Button hinzufügen',
      close: 'Schließen',
      added: 'Hinzugefügt',
      add: 'Hinzufügen',
      messageTitle: 'Nachricht',
      messageText: 'Mit dem Nachrichten-Button können Nutzer dich per Messenger kontaktieren',
      subscribeTitle: 'Abonnieren',
      subscribeText: 'Mit dem Abonnieren-Button können sich Nutzer in deine E-Mail- oder Messenger-Liste eintragen',
      ctaTitle: 'CTA-Button',
      ctaText: 'Ein CTA ist eine Aufforderung auf einer Website, die den Nutzer zu einer bestimmten Aktion auffordert',
      cartTitle: 'Warenkorb',
      cartText: 'Zeige ein Warenkorb-Symbol an, um darauf hinzuweisen, dass Besucher auf deiner Website einkaufen können',
      contactTitle: 'Kontakt',
      contactText: 'Ermögliche Besuchern den schnellen Zugriff auf deine Kontaktinformationen',
      qrcodeTitle: 'QR-Code',
      qrcodeText: 'Zeige einen QR-Code an, damit Besucher deine Seite schnell scannen und teilen können',
      languageTitle: 'Sprache',
      languageText: 'Erlaube Besuchern, die Sprache deiner Seite zu wechseln',
      searchTitle: 'Suche',
      searchText: 'Lassen Sie Besucher Ihre Shop-Produkte direkt in der Kopfzeile durchsuchen',
    },
    inputMask: {
      copyLink: 'Link kopieren',
    },
    videoLibrary: {
      addVideo: 'Video hinzufügen',
      myVideos: 'Meine Videos',
      stockVideos: 'Stock-Videos',
      pasteUrl: 'URL einfügen',
      uploadVideo: 'Video hochladen',
    },
    createBlockModal: {
      searchTitle: 'Wähle einen Block für deine Seite',
      title: 'Zu UniLink hinzufügen',
      contentTitle: 'Inhalte',
      contentText: 'Erstelle und verwalte deine Seite',
      growTitle: 'Leads',
      growText: 'Sammle Leads und steigere die Interaktion',
      monetizeTitle: 'Monetarisieren',
      monetizeText: 'Verkaufe Produkte, Inhalte und Dienstleistungen',
      monetizationTitle: 'Geld verdienen und einnehmen',
      monetizationText: 'Verkaufe Produkte, Dienstleistungen und sammle Trinkgelder',
      socialTitle: 'Social-Media-Inhalte',
      socialText: 'Teile Social-Media-Inhalte auf deinem UniLink',
      toolsTitle: 'Wachstums-Tools',
      toolsText: 'Wachse, verwalte und verbinde dich mit deinem Publikum',
      search: 'Suchen',
      all: 'Alle',
      allCategories: 'Alle Kategorien',
      content: 'Inhalte',
      monetization: 'Monetarisierung',
      social: 'Social',
      tools: 'Tools',
      header: 'Header',
      headerText: 'Profilbild und Bio hinzufügen',
      link: 'Links',
      linkText: 'Link-Layout auswählen',
      text: 'Text',
      textText: 'Text-Layout auswählen',
      videos: 'Videos',
      videosText: 'Video-Typ auswählen',
      image: 'Bild',
      imageText: 'Bildblöcke hinzufügen',
      music: 'Musik',
      musicText: 'Musik-Typ auswählen',
      socialFeeds: 'Social Feeds',
      socialFeedsText: 'Social-Feed-Typ auswählen',
      moreContent: 'Mehr',
      moreContentText: 'Weitere Inhaltsblöcke hinzufügen',
      dataCollect: 'Datenerfassung',
      dataCollectText: 'Art der Datenerfassung wählen',
      form: 'Formular',
      formText: 'Formulartyp wählen',
      conversionTools: 'Engagement-Tools',
      conversionToolsText: 'Conversion-Blöcke hinzufügen',
      products: 'Produkte',
      productsText: 'Produktblöcke hinzufügen',
      donation: 'Trinkgeld & Spenden',
      tipsAndDonations: 'Trinkgeld & Spenden',
      tipsDonationsText: 'Blöcke für Trinkgeld und Spenden',
      event: 'Veranstaltung',
      eventText: 'Veranstaltungstyp wählen',
      quickAdd: 'Alle Blöcke',
      quickAddText: 'Beliebigen Block hinzufügen',
    },
    addBlockModal: {
      title: 'Zu UniLink hinzufügen',
      dragToAdd: 'Zum Hinzufügen ziehen',
      contentTitle: 'Grundlegende Inhalte teilen',
      contentText: 'Inhalte direkt auf deinem UniLink teilen',
      monetizationTitle: 'Geld verdienen und sammeln',
      monetizationText: 'Produkte und Services verkaufen sowie Trinkgeld sammeln',
      socialTitle: 'Social-Media-Inhalte',
      socialText: 'Social-Media-Inhalte auf deinem UniLink teilen',
      toolsTitle: 'Wachstumstools',
      toolsText: 'Wachse, verwalte und vernetze dich mit deinem Publikum',
      search: 'Suchen',
      searchPlaceholder: 'Inhalte suchen...',
      all: 'Alle',
      allCategories: 'Alle Kategorien',
      content: 'Inhalt',
      monetization: 'Monetarisierung',
      social: 'Social',
      tools: 'Tools',
      suggestTitle: 'Block vorschlagen',
      suggestText: 'Fehlt ein Block? Sag uns, was du dir wünschst',
      suggestModalTitle: 'Block vorschlagen',
      suggestModalSubtitle: 'Beschreibe den Block, den du dir bei UniLink wünschst. Wir lesen jede Idee.',
      suggestPlaceholder: 'z. B. Ein Buchungsblock mit Google-Kalender-Sync…',
      suggestSubmit: 'Vorschlag senden',
      suggestSending: 'Wird gesendet…',
      suggestSuccessTitle: 'Vorschlag gesendet!',
      suggestSuccess: 'Danke! Wir lesen jede Idee und nutzen sie für unsere Roadmap.',
      suggestError: 'Konnte nicht gesendet werden. Bitte versuche es erneut.',
    },
    tabNavigation: {
      tabView: 'Tab-Ansicht',
      tabViewTooltip: 'Tab-Ansicht für die Navigation auswählen',
      colors: 'Farben',
      colorsTooltip: 'Farben für Beiträge und Buttons wählen',
      tabs: 'Tabs',
      tabsTooltip: 'Tabs auswählen, die in der Website-Navigation angezeigt werden',
      content: 'Inhalt',
      posts: 'Beiträge',
      store: 'Shop',
      shop: 'Shop',
      tabsSettings: 'Einstellungen für Tab-Navigation',
    },
    hideLogo: {
      text: 'UniLink-Logo im Footer deiner Seite anzeigen.',
      text2: 'UniLink-Logo im Footer deiner Seite anzeigen.',
    },
    palettePreview: {
      custom: 'Benutzerdefinierte Hintergrundfarbe',
      hexColor: 'Hex-Farbe',
      hexColorTooltip: 'Hex-Farbe deiner Vorschau eingeben',
    },
    backgroundVideo: {
      insert: 'URL einfügen',
      upload: 'Video hochladen',
      search: 'Video suchen',
    },
    periodDropdown: {
      today: 'Heute',
      yesterday: 'Gestern',
      last7days: 'Letzte 7 Tage',
      last30days: 'Letzte 30 Tage',
      allTime: 'Gesamter Zeitraum',
      custom: 'Benutzerdefiniert',
    },
    subsections: {
      content: 'Inhalt',
      design: 'Design',
      settings: 'Einstellungen',
    },
    wrapperSettings: {
      lock: 'Auf PRO-Tarif upgraden',
    },
    shareModal: {
      addSocials: 'Zu Socials hinzufügen',
      shareTo: 'Teilen mit',
      qrCode: 'QR-Code',
      customizeUrl: 'URL anpassen',
      goToMy: 'Gehe zu meinem',
      print: 'Du kannst deinen einzigartigen QR-Code drucken auf',
      cards: 'Visitenkarten und Flyer',
      download: 'Herunterladen',
      copy: 'Kopieren',
      previewMobile: 'Auf Mobilgerät vorschauen',
      scanMobilePreview: 'Scanne den QR-Code mit deinem Mobilgerät, um deine Website in der Vorschau zu sehen',
      types: {
        socials: 'Socials',
        shareTo: 'Teilen',
        qrCode: 'QR',
        title: 'Teile deinen UniLink',
        titleSocials: 'Füge UniLink zu deinen Socials hinzu',
        titleShareTo: 'Teilen mit...',
        titleQRCode: 'QR-Code',
        titlePreviewMobile: 'Vorschau auf Mobilgerät',
      },
      socialList: {
        instagramText: 'Füge deinen UniLink zu deinem Instagram-Profil hinzu. Kopiere einfach deine UniLink-URL, gehe zu Profil bearbeiten und füge sie in das Feld Website ein.',
        facebookText:
          'Füge deinen UniLink zu deinem Facebook-Profil hinzu. Kopiere einfach deine UniLink-URL, gehe auf die Info-Seite deines Profils, klicke auf Kontakt- und grundlegende Infos, dann auf + Website hinzufügen, füge deine UniLink-URL in das Feld Webadresse ein und klicke auf Speichern.',
        tikTokText:
          'Füge deinen UniLink zu deinem Facebook-Profil hinzu. Kopiere einfach deine UniLink-URL, gehe auf die Info-Seite deines Profils, klicke auf Kontakt- und grundlegende Infos, dann auf + Website hinzufügen, füge deine UniLink-URL in das Feld Webadresse ein und klicke auf Speichern.',
        twitchText:
          'Füge deinen UniLink zu deinem Twitch-Kanal hinzu. Kopiere einfach deine UniLink-URL, gehe zu deinem Twitch-Kanal, klicke auf Info, dann auf Info- und Links-Einstellungen bearbeiten, scrolle nach unten zu Soziale Links, füge UniLink in das erste Textfeld ein und füge deine UniLink-URL in das zweite Textfeld ein, dann klicke auf Hinzufügen.',
        youTubeText:
          'Füge deinen UniLink zu deinem YouTube-Kanal hinzu. Kopiere einfach deine UniLink-URL, gehe zu deinem YouTube-Kanal, klicke auf Kanal anpassen, dann auf Grundlegende Infos, und füge unter Links einen Linktitel hinzu und deine UniLink-URL in das URL-Feld ein, dann klicke auf Veröffentlichen.',
        linkedInText:
          'Füge deinen UniLink zu deinem LinkedIn-Profil hinzu. Kopiere einfach deine UniLink-URL, gehe zu deinem LinkedIn-Profil, klicke auf das Stiftsymbol, scrolle nach unten zu Kontaktinfo, füge deine UniLink-URL in das Feld Website-URL ein, dann klicke auf Anwenden.',
        pinterestText:
          'Füge deinen UniLink zu deinem Pinterest-Profil hinzu. Kopiere einfach deine UniLink-URL, gehe zu deinen Pinterest-Einstellungen, füge deine UniLink-URL in das Feld Website-URL ein, dann klicke auf Speichern.',
        twitterText:
          'Füge deinen UniLink zu deinem Twitter-Profil hinzu. Kopiere einfach deine UniLink-URL, gehe zu deinem Profil, klicke auf Profil bearbeiten und füge deine UniLink-URL in das Feld Website ein.',
      },
      share: {
        shareFacebook: 'Auf Facebook teilen',
        shareLinkedIn: 'Auf LinkedIn teilen',
        shareTwitter: 'Auf Twitter teilen',
        shareWhatsApp: 'Über WhatsApp teilen',
        shareMessenger: 'Über Messenger teilen',
        shareEmail: 'Per E-Mail teilen',
      },
    },
  },
  popupMenu: {
    edit: 'Seite bearbeiten',
    openInNewTab: 'In neuem Tab öffnen',
    copyLink: 'URL kopieren',
    delete: 'Löschen',
    showThumbnail: 'Seitenvorschauen im Dashboard anzeigen',
    manageTabs: 'Tabs verwalten',
  },
  tabsDashboard: {
    labelAddNewTab: 'Neuer Tab',
  },
  blocks: {
    header: {
      blockTitle: 'Header',
      blockText: 'Passe dein Profilbild an, füge eine kurze Bio hinzu und aktualisiere deine Social-Icons',
      blockShortText: 'Profil anpassen',
      layout: 'Layout',
      layoutTooltip: 'Erstelle das gewünschte Header-Layout',
      layoutAlign: 'Layout-Ausrichtung',
      layoutAlignTooltip: 'Text ausrichten',
      profilePicture: 'Profilbild',
      profilePictureTooltip: 'Ändere dein Profilbild',
      pictureSize: 'Bildgröße',
      pictureSizeTooltip: 'Du kannst die Bildgröße ändern',
      pictureHeight: 'Bildhöhe',
      pictureHeightCaption: 'Du kannst die Bildhöhe ändern',
      preview: 'Vorschau',
      badge: 'Abzeichen',
      badgeTooltip: 'Verifiziertes Abzeichen zum Header hinzufügen',
      tags: 'Tags',
      tagsTooltip: 'Kategorie-Tags unter Ihrem Namen anzeigen (bis zu 5)',
      tagsAdd: 'Tags hinzufügen',
      addTags: '+ Tags hinzufügen',
      tagsEdit: 'Tags bearbeiten',
      tagsCustomPlaceholder: 'Eigenen Tag hinzufügen',
      tagsCustomAdd: 'Hinzufügen',
      tagsSuggested: 'Vorgeschlagene Kategorien',
      tagsSelected: 'Ausgewählt',
      tagsEmpty: 'Noch keine Tags — wählen Sie aus den Vorschlägen oder fügen Sie eigene hinzu',
      tagsLimit: 'Maximal 5 Tags',
      visibility: 'Sichtbarkeit',
      visibilityTooltip: 'Profilbild anzeigen oder ausblenden',
      cover: 'Cover',
      coverTooltip: 'Bild oder Video zum Header-Cover hinzufügen',
      addCover: 'Cover hinzufügen',
      image: 'Bild',
      video: 'Video',
      positionCover: 'Text- und Button-Position',
      positionCoverTooltip: 'Schieberegler ziehen, um die Position zu ändern',
      buttons: 'Buttons',
      block: 'Block',
      videoProcessing: 'Videoverarbeitung',
      vibe: 'Vibe',
      vibeTooltip: 'Vibe hinzufügen',
      stories: 'Stories',
      storiesTooltip: 'Stories hinzufügen',
      addStory: 'Story hinzufügen',
      storiesSubtitle: 'Bild oder Video zu deinen Stories hinzufügen',
      subscribeMethod: 'Abonnement-Methode',
      subscribeMethodTooltip: 'Wähle deine Abonnement-Methode',
      subscribeLink: 'Abonnement-Link',
      subscribeLinkTooltip: 'Abonnement-Link kopieren',
      minWidth: 'Mindestbreite',
      addVCard: 'vCard hinzufügen',
      vCard: 'vCard',
      vCardTooltip: 'Du kannst Infos über dich hinzufügen',
      buttonInline: 'Button im Header',
      buttonInsideContact: 'Button im Kontakt-Button',
      showSaveContact: 'Kontakt speichern anzeigen',
      options: 'Optionen',
      showBusinessCard: 'Visitenkarte anzeigen',
      showBusinessCardCaption: 'Fügt hier eine „Kontakt speichern“-Schaltfläche hinzu.',
      editBusinessCard: 'Karte bearbeiten',
      editContactDetails: 'Kontaktdaten auf Business cards bearbeiten',
      needAddContact: 'Du musst einen Kontakt-Button hinzufügen',
      socialGap: 'Abstand',
      socialGapCaption: 'Du kannst den Abstand ändern',
      socialSize: 'Größe',
      socialSizeCaption: 'Du kannst die Größe ändern',
      icons: 'Icons',
      iconsTooltip: 'Icon zum Button hinzufügen',
      bottomButtonsSettings: 'Untere Buttons',
      bottomButtonsLayout: 'Layout',
      bottomButtonsRow: 'Nebeneinander',
      bottomButtonsColumn: 'Gestapelt',
      cropMismatch: 'Dieses Foto ist für ein anderes Layout zugeschnitten.',
      adjustCrop: 'Zuschnitt anpassen',
      photoShapeLabel: 'Fotoform',
      photoShapeTooltip: 'Wähle, ob dieses Layout das quadratische Foto oder einen vertikalen Zuschnitt zeigt.',
      photoShapeSquare: 'Quadratisch',
      photoShapeVertical: 'Vertikal',
      coverShape: 'Coverform',
      coverShapeTooltip: 'Wähle die Unterkante des Covers — gerade, nach unten oder nach oben gebogen.',
      coverShapeStraight: 'Gerade',
      coverShapeArcDown: 'Bogen nach unten',
      coverShapeArcUp: 'Bogen nach oben',
      avatarOffsetLabel: 'Avatar-Position',
      avatarOffsetTooltip: 'Verschiebe den Avatar relativ zur Coverkante nach oben oder unten.',
      photoStyleProTitle: 'Erweiterte Fotostile freischalten',
      photoStyleProDesc: 'Kein Hintergrund und Text dahinter sind PRO-Funktionen.',
      photoShapeCustom: 'Benutzerdefiniert',
      sliderStyleLabel: 'Slider-Stil',
      sliderStyleTooltip: 'Wischen zeigt ein Foto nach dem anderen; Galerie zeigt eine Vorschaubild-Reihe — tippe auf ein Vorschaubild, um das Hauptfoto zu wechseln.',
      sliderStyleSwipe: 'Wischen',
      sliderStyleGallery: 'Galerie',
      photoPositionLabel: 'Fotoposition',
      photoPositionHint: 'Vertikale Ausrichtung',
      verticalCropHint: 'Dieses Layout zeigt ein Originalfoto. Wähle den vertikalen Bereich, den du anzeigen möchtest.',
      verticalCropReady: 'Feinjustiere den vertikalen Bereich, der in diesem Layout angezeigt wird.',
      pickVerticalArea: 'Vertikalen Bereich wählen',
      photoStyle: 'Fotostil',
      photoStyleTooltip: 'Zeige das Foto wie es ist, mit entferntem Hintergrund oder platziere Text hinter dem Motiv.',
      avatarModeOriginal: 'Original',
      avatarModeCutout: 'Kein Hintergrund',
      avatarModeLayered: 'Text dahinter',
      overlayText: 'Text',
      overlayTextPlaceholder: 'Dein Name (Standard)',
      overlayColor: 'Textfarbe',
      overlaySize: 'Größe',
      overlayY: 'Vertikale Position',
      overlayEffect: 'Animation',
      overlayEffectNone: 'Keine',
      overlayEffectShimmer: 'Schimmern',
      overlayEffectGlow: 'Leuchten',
      overlayEffectGradient: 'Farbverlauf',
      overlayEffectSparkle: 'Funkeln',
      overlayUsesName: 'In diesem Layout ist der Text dein Profilname — er erscheint hinter dir. Bearbeite ihn im Abschnitt „Name“.',
      cutoutGenerate: 'Freisteller erstellen',
      cutoutRegenerate: 'Neu erstellen',
      cutoutUpload: 'Hochladen',
      cutoutOr: 'oder',
      cutoutGenerating: 'Wird erstellt...',
      cutoutUploading: 'Wird hochgeladen...',
      cutoutVideoHint: 'Die Hintergrundentfernung funktioniert nur bei Bildfotos, nicht bei Videos.',
      cutoutTimeout: 'Die Hintergrundentfernung dauert zu lange. Bitte versuche es erneut.',
      profileBadges: 'Abzeichen',
      profileBadgesTooltip: 'Wähle bis zu 3 Abzeichen, die neben deinem Namen angezeigt werden',
      profileBadgesProLockHint: 'Upgrade auf PRO, um dieses Abzeichen zu nutzen',
      profileBadgesAdd: 'Abzeichen hinzufügen',
      profileBadgesManage: 'Abzeichen verwalten',
      profileBadgesModalTitle: 'Abzeichen zu deinem Profil hinzufügen',
      profileBadgesModalSubtitle: 'Präsentiere deine Erfolge und Auszeichnungen.',
      profileBadgesCustomCta: 'Eigenes Abzeichen hochladen',
      profileBadgesCustomDesc: 'Dein individuelles Abzeichen',
      profileBadgesCustomName: 'Abzeichenname',
      profileBadgesCustomChoose: 'Bild auswählen',
      profileBadgesCustomChange: 'Bild ändern',
      profileBadgesCustomUploading: 'Wird hochgeladen…',
      profileBadgesCustomAdd: 'Abzeichen hinzufügen',
      ribbonLabel: 'Dekorative Leiste',
      ribbonLabelTooltip: 'Füge unter dem Header-Hero eine Farbleiste hinzu',
      addTint: 'Leiste hinzufügen',
      ribbonTitle: 'Leiste',
      ribbonText: 'Leistentext',
      ribbonTextPlaceholder: 'z. B. 20 % Rabatt bis Monatsende',
      ribbonColor: 'Leistenfarbe',
      ribbonTheme: 'Stil',
      ribbonThemes: {
        none: 'Keine Deko',
        birthday: 'Geburtstag',
        newyear: 'Neujahr',
        valentine: 'Valentinstag',
        halloween: 'Halloween',
        summer: 'Sommer',
      },
      ribbonEffect: 'Effekt',
      ribbonEffects: {
        none: 'Keiner',
        gradient: 'Animierter Farbverlauf',
        shimmer: 'Schimmern',
        lights: 'Lichterkette',
      },
      ribbonPosition: 'Position',
      ribbonPositions: {
        bottom: 'Unter dem Header',
        underPhoto: 'Unter dem Foto',
      },
      ribbonRemove: 'Leiste entfernen',
      statusBadges: 'Aktivität',
      statusBadgesTooltip: 'Zeige Echtzeit-Aktivität auf deiner Seite',
      addStatus: 'Aktivität hinzufügen',
      statusDisabledHint: 'Verborgen · deaktiviert',
      followersTitle: 'Follower',
      followersCounter: 'Follower-Zähler',
      followersTooltip: 'Zeige die kombinierte Follower-Zahl deiner verbundenen Social-Accounts an',
    },
    text: {
      blockTitle: 'Text',
      blockText: 'Allgemeiner Textblock, um alles zu schreiben, was du möchtest. Du kannst deinen Text mit dem WYSIWYG-Editor formatieren',
      blockShortText: 'Allgemeiner Textblock',
      title: 'Titel',
      titleText: 'Titelgröße anpassen',
      orderOfElements: 'Reihenfolge der Elemente',
      orderOfElementsTooltip: 'Schieberegler ziehen, um die Reihenfolge der Elemente zu ändern',
      changeOrder: 'Reihenfolge ändern',
      text: 'Text',
      content: 'Inhalt',
      image: 'Bild',
      button: 'Button',
      addButtons: 'Weitere Buttons hinzufügen',
      displayedContent: 'Angezeigter Inhalt',
      displayedContentTooltip: 'Inhalt anzeigen oder ausblenden',
      buttonLayout: 'Button-Layout',
      buttonLayoutTooltip: 'Vertikale oder horizontale Button-Anordnung wählen',
    },
    timeline: {
      blockTitle: 'Zeitleiste',
      blockText: 'Zeige eine vertikale Zeitleiste mit Ereignissen an. Jedes Ereignis kann Datum/Uhrzeit, Titel, Beschreibung und ein optionales Bild enthalten',
      blockShortText: 'Ereignis-Zeitleiste anzeigen',
      editItem: 'Ereignis bearbeiten',
      title: 'Titel',
      titlePlaceholder: 'Ereignistitel',
      subtitle: 'Untertitel',
      subtitlePlaceholder: 'Rolle oder Zugehörigkeit (optional)',
      description: 'Beschreibung',
      descriptionPlaceholder: 'Veranstaltungsbeschreibung (optional)',
      startTime: 'Startzeit',
      endTime: 'Endzeit',
      startDate: 'Startdatum',
      endDate: 'Enddatum',
      showEndDate: 'Enddatum anzeigen',
      showEndDateTooltip: 'Für laufende Ereignisse deaktivieren (z. B. „arbeite hier seit 2023“)',
      includeTime: 'Uhrzeit einbeziehen',
      includeTimeTooltip: 'Wenn deaktiviert, wird nur das Datum ohne Uhrzeit angezeigt',
      image: 'Bild',
      imagePlaceholder: 'Avatar oder Icon hochladen',
      imageUploadFailed: 'Bild konnte nicht hochgeladen werden. Verwende „Meine Medien“ oder füge einen Link ein.',
      untitled: 'Ohne Titel',
      listLayout: 'Listenlayout',
      lineColor: 'Linienfarbe',
    },
    trust: {
      blockTitle: 'Vertrauen',
      blockShortText: 'Teile deine Partnerschaften',
      blockText: 'Bringe alle deine Verbindungen an einem Ort zusammen.',
      titleText: 'Passe deine Titelgröße an',
      orderOfElements: 'Reihenfolge der Elemente',
      orderOfElementsTooltip: 'Ziehe den Schieberegler, um die Reihenfolge der Elemente zu ändern',
      changeOrder: 'Reihenfolge ändern',
      text: 'Text',
      content: 'Inhalt',
      image: 'Bild',
      button: 'Schaltfläche',
      displayedContent: 'Angezeigter Inhalt',
      displayedContentTooltip: 'Inhalt anzeigen oder ausblenden',
      enterTrustLink: 'Partner-URL eingeben',
      enterTrustLinkTooltip: 'Partner-URL einfügen',
      enterPartnerName: 'Partnername eingeben',
      enterPartnerUrl: 'https://www.deinPartner.com/',
      enterDescription: 'Beschreibung eingeben (optional)',
      partnerLogo: 'Partner-Logo',
      uploadPartnerLogo: 'Lade das Logo deines Partners hoch',
    },
    link: {
      blockTitle: 'Links',
      blockText: 'Leite Besucher auf deine Website, deinen Blog, deinen Onlineshop oder andere Webseiten',
      blockShortText: 'Besucher auf Website leiten',
      addLink: 'Link hinzufügen',
      addNewLink: 'Neuen Link hinzufügen',
      restrictedTitle: '{platform}-Links sind eine PRO-Funktion',
      restrictedText: 'Das Hinzufügen von {platform}-Links ist im PRO-Tarif verfügbar. Führen Sie ein Upgrade durch, um diesen Link zu Ihrer Seite hinzuzufügen.',
      upgradeToPro: 'Auf PRO upgraden',
      showMore: 'Mehr anzeigen',
      showLess: 'Weniger anzeigen',
      viewArchive: 'Archiv ansehen',
      archivedLinks: 'Archivierte Links',
      noArchivedLinks: 'Halte deine Link-Verwaltung übersichtlich, indem du Links archivierst, die du derzeit nicht verwendest.',
      archiveAllUnpublished: 'Alle unveröffentlichten Links archivieren',
      addFormExisting: 'Aus vorhandenen Links hinzufügen',
      addYourLink: 'Füge deinen Link zur Gruppe hinzu',
      add: 'Hinzufügen',
      otherTypes: 'Aktionstyp',
      link: 'Link',
      navigate: 'Navigieren',
      navigateTo: 'Navigieren zu',
      scrollBlock: 'Scrollen zu',
      copyText: 'Text kopieren',
      navigatePage: 'Seite',
      navigateProduct: 'Produkt',
      navigateBlock: 'Block',
      modal: 'Modal',
      showModal: 'Modal anzeigen',
      modalBlock: 'Block anzeigen',
      modalItem: 'Element anzeigen',
      modalCustom: 'Benutzerdefiniert',
      document: 'Dokument',
      privat24: 'Privat24',
      phone: 'Anruf',
      viber: 'Viber öffnen',
      skype: 'Skype öffnen',
      email: 'E-Mail senden',
      discount: 'Rabatt',
      smartLink: 'Smart Link',
      mobileApp: 'Deep Link',
      enterURL: 'URL eingeben',
      enterPrivat: 'Karte der Privatbank eingeben',
      enterPhone: 'Telefonnummer eingeben',
      enterViber: 'Viber-Nummer eingeben',
      enterSkype: 'Skype eingeben',
      enterEmail: 'E-Mail eingeben',
      enterTitle: 'Titel eingeben',
      enterCopyText: 'Zu kopierenden Text eingeben',
      enterPromoCode: 'Promo-Code eingeben',
      group: 'Gruppe erstellen',
      content: 'Inhalt',
      links: 'Links',
      heading: 'Überschrift',
      settings: 'Einstellungen',
      thumbnail: 'Vorschaubild',
      typeTooltip: '  Klick öffnet diesen Link',
      title: 'Titel',
      titleTooltip: 'Name deines Links',
      description: 'Beschreibung',
      descriptionTooltip: 'Optionale Beschreibung der Link-Funktionen, Typen, Farbe, Größen usw.',
      label: 'Bezeichnung',
      labelTooltip: 'Bezeichnungsname hinzufügen',
      button: 'Schaltfläche',
      buttonTooltip: 'Schaltflächenname hinzufügen',
      buttonText: 'Schaltflächentext',
      buttonTextTooltip: 'Name deiner Schaltfläche',
      buttonUrl: 'Schaltflächen-URL',
      buttonUrlTooltip: 'Schaltflächen-URL eingeben',
      addLinkToGroup: 'Link zu Gruppe hinzufügen',
      removeFromGroup: 'Aus Gruppe entfernen',
      deletePermanently: 'Endgültig löschen',
      image: 'Bild',
      buttonBg: 'Schaltflächen-Hintergrund',
      postPreview: 'Beitragsvorschau',
      separatorType: 'Trennzeichen-Typ',
      separatorTypeTooltip: 'Trennzeichen-Typ zur Schaltfläche hinzufügen',
      section: 'Abschnitt',
      sectionTooltip: 'Linkabschnitt',
      descriptionSeparator: 'Beschreibung',
      descriptionSeparatorTooltip: 'Optionale Abschnittsbeschreibung',
      sectionText: 'Abschnittstext',
      linkInstant: 'Sofortige Link-Weiterleitung',
      spotlight: 'Link hervorheben',
      addEffect: 'Spezialeffekt hinzufügen',
      countdown: 'Countdown',
      countdownTimer: 'Countdown-Timer',
      countdownText: 'Live-Countdown hinzufügen, bis dein Link anklickbar wird',
      chooseDate: 'Datum wählen',
      chooseDateTooltip: 'Datum für deinen Link wählen',
      chooseAction: 'Aktion wählen',
      chooseActionTooltip: 'Aktion für deinen Link wählen',
      addCountdown: 'Countdown für Link hinzufügen',
      scheduler: 'Planer',
      schedule: 'Planen',
      scheduleText: 'Wähle ein zukünftiges Datum und eine Uhrzeit, zu der dein Link aktiviert wird',
      activateOn: 'Aktivieren am',
      activateOnTooltip: 'Datum wählen',
      deactivateOn: 'Deaktivieren am',
      deactivateOnTooltip: 'Datum wählen',
      addSchedule: 'Zeitplan hinzufügen für',
      scheduleError: 'Das Enddatum darf nicht vor dem Startdatum liegen und das Startdatum darf nicht in der Vergangenheit liegen.',
      scheduleErrorPast: 'Das Aktivierungsdatum darf nicht in der Vergangenheit liegen.',
      scheduleErrorPastDeactivate: 'Das Deaktivierungsdatum darf nicht in der Vergangenheit liegen.',
      scheduleErrorOrder: 'Das Deaktivierungsdatum muss nach dem Aktivierungsdatum liegen.',
      activatesIn: 'Aktiviert sich in',
      deactivatesIn: 'Deaktiviert sich in',
      lock: 'Sperren',
      lockText: 'Besucher können auf diesen Link nur zugreifen, wenn sie eines der Kriterien erfüllen.',
      lockCode: 'Code',
      lockCodeTitle: 'Code zum Entsperren dieses Links',
      lockCodeText: 'Besucher müssen einen 4-stelligen Code eingeben, um diesen Link zu entsperren',
      lockSubscribe: 'Abonnieren',
      lockSubscribeTitle: 'Besucher müssen deinen UniLink abonnieren, um den Link zu entsperren.',
      lockSubscribeText: 'Sperre wurde erfolgreich konfiguriert.',
      lockPayment: 'Zahlung',
      lockPaymentText: 'Sperre wurde erfolgreich konfiguriert.',
      price: 'Preis',
      priceTooltip: 'Preis deines Produkts hinzufügen',
      lockAge: 'Geburtsdatum (Alter)',
      lockAgeTitle: 'Mindestalter festlegen',
      lockAgeText: 'Besucher müssen ein bestimmtes Alter überschritten haben, um den Link mit ihrem Geburtsdatum zu entsperren',
      lockAgeAlert: 'Sperre wurde erfolgreich konfiguriert.',
      lockSensitive: 'Sensible Inhalte',
      lockSensitiveText: 'Besucher müssen bestätigen, dass dieser Link Inhalte enthalten kann, die nicht für alle Zielgruppen geeignet sind.',
      makeLink: 'Link kostenpflichtig machen',
      addLock: 'Sperre für Link hinzufügen',
      save: 'Speichern',
      clear: 'Zurücksetzen',
      buttonColor: 'Schaltflächenfarbe',
      labelColor: 'Beschriftungsfarbe',
      background: 'Hintergrund',
      imageHeight: 'Bildhöhe',
      imageHeightTooltip: 'Schieberegler ziehen, um die Bildhöhe zu ändern',
      buttonMinimum: 'Mindesthöhe',
      buttonMinimumTooltip: 'Schieberegler ziehen, um die Höhe der Schaltfläche zu ändern',
      textPosition: 'Textposition',
      textPositionTooltip: 'Vertikale Position des Textes wählen',
      preview: 'Vorschau',
      defaultDesign: 'Standarddesign',
      defaultDesignTooltip: 'Standarddesign für Links einrichten',
      defaultDesignTitle: 'Bitte beachte, dass dieses Design auf alle Links angewendet wird.',
      defaultDesignText: 'Du kannst das Standard-Linkdesign ändern',
      changeDefault: 'Standard ändern',
      applyDefault: 'Standard anwenden',
      scheduled: 'Geplant',
      scheduledVisible: 'Geplanter Link ist jetzt sichtbar',
      scheduledHidden: 'Geplanter Link ist jetzt ausgeblendet',
      linkClickable: 'Link anklickbar in',
      linkDisable: 'Link deaktiviert in',
      lockedBy: 'Gesperrt von',
      items: 'Elemente',
      doNotAnyLinks: 'Du hast noch keine Links',
      sublinks: 'Sublinks',
      layout: 'Layout',
      layoutTooltip: 'Wähle das gewünschte Sublink-Layout',
      hideGroupLink: 'Gruppenlink ausblenden',
      rules: 'Regeln',
      rulesText: 'Ändere die Sichtbarkeit dieses Links abhängig davon, wer deine Seite besucht.',
      rulesEmpty: 'Noch keine Bedingungen. Füge eine Bedingung hinzu, um zu steuern, wer diesen Link sieht.',
      rulesAddCondition: 'Bedingung hinzufügen',
      rulesActive: 'Sichtbarkeitsregeln',
      rulesIf: 'Wenn',
      rulesThen: 'Dann',
      ruleTypeLocation: 'Standort',
      ruleTypeDevice: 'Gerät',
      ruleTypeTime: 'Tag & Uhrzeit',
      ruleOperatorIs: 'ist',
      ruleOperatorIsNot: 'ist nicht',
      ruleActionHide: 'Link ausblenden',
      ruleActionShow: 'Link anzeigen',
      ruleSelectLocations: 'Standorte auswählen',
      ruleSearchLocations: 'Länder suchen…',
      ruleFrom: 'Von',
      ruleTo: 'Bis',
      ruleAnyTime: 'Beliebig',
    },
    'data-collect': {
      blockTitle: 'Datenerfassung',
      blockText: 'Sammle E-Mails oder Telefonnummern von deinen Besuchern',
      blockShortText: 'E-Mails sammeln',
      maxSize: 'Du kannst maximal 3 Kanäle hinzufügen',
      customTerms: 'Eigene AGB',
      customTermsTooltip: 'Füge eigene AGB zu deinem Formular hinzu',
      termsConditions: 'Allgemeine Geschäftsbedingungen',
      text: 'Text',
      subscribe: 'Abonnieren',
      title: 'Titel',
      titleTooltip: 'Titel für die AGB eingeben',
      titleResultTooltip: 'Titel für deine Übermittlung eingeben',
      url: 'URL',
      urlTooltip: 'URL eingeben',
      editItem: 'Element bearbeiten',
      placeholder: 'Platzhalter',
      placeholderTooltip: 'Platzhaltertext eingeben',
      button: 'Button',
      buttonTooltip: 'Text, der Besucher motiviert, ihre E-Mail einzugeben (10% Rabatt, jetzt abonnieren, Datei herunterladen usw.)',
      successMessage: 'Erfolgsmeldung',
      successMessageTooltip: 'Erfolgsmeldung für deine Abonnements',
      botURL: 'Bot-URL (optional)',
      botURLTooltip: 'URL deines Bots eingeben',
      botToken: 'Bot-Token',
      botTokenTooltip: 'Token deines Bots eingeben',
      rewards: 'Antworten',
      rewardsTooltip: 'Antworten für deine Abonnenten hinzufügen',
      addReward: 'Antwort hinzufügen',
      thankYou: 'Dankesnachricht',
      email: {
        none: 'Keine',
        display: 'Antwort sofort anzeigen',
        send: 'Antwort an E-Mail senden',
        redirect: 'Auf URL weiterleiten',
      },
      phone: {
        none: 'Keine',
        display: 'Antwort sofort anzeigen',
        send: 'Antwort an Telefon senden',
        redirect: 'Auf URL weiterleiten',
      },
      telegram: {
        none: 'Keine',
        display: 'Antwort sofort anzeigen',
        send: 'Antwort im Telegram-Bot senden',
        redirect: 'Auf URL weiterleiten',
      },
      whatsapp: {
        none: 'Keine',
        display: 'Antwort sofort anzeigen',
        send: 'Antwort im WhatsApp-Bot senden',
        redirect: 'Auf URL weiterleiten',
      },
      instagram: {
        none: 'Keine',
        display: 'Antwort sofort anzeigen',
        send: 'Antwort im Instagram-Bot senden',
        redirect: 'Auf URL weiterleiten',
      },
      messenger: {
        none: 'Keine',
        display: 'Antwort sofort anzeigen',
        send: 'Antwort im Messenger-Bot senden',
        redirect: 'Auf URL weiterleiten',
      },
      viber: {
        none: 'Keine',
        display: 'Antwort sofort anzeigen',
        send: 'Antwort im Viber-Bot senden',
        redirect: 'Zu URL weiterleiten',
      },
      connect: 'Verbinden',
      toChangeReward: 'Um den Antworttyp zu ändern, müssen Sie den aktuellen entfernen',
      remove: 'Entfernen',
      viewTypes: 'Typen anzeigen',
    },
    form: {
      blockTitle: 'Formular',
      blockText: 'Ermöglicht das Erfassen von Informationen und Daten Ihrer Zielgruppe',
      blockShortText: 'Informationen erfassen',
      fields: 'Felder',
      fieldsTooltip: 'Felder zum Formular hinzufügen',
      addCustomField: 'Benutzerdefiniertes Feld hinzufügen',
      addItem: 'Element hinzufügen',
      editItem: 'Element bearbeiten',
      type: 'Typ',
      typeTooltip: 'Feldtyp wählen',
      string: 'Kurze Antwort',
      textarea: 'Lange Antwort',
      dropdown: 'Dropdown',
      radio: 'Radio',
      checkbox: 'Checkbox',
      date: 'Datum',
      time: 'Uhrzeit',
      country: 'Land',
      fieldName: 'Feldname',
      fieldNameTooltip: 'Feldnamen eingeben',
      name: 'Name',
      placeholder: 'Platzhalter',
      placeholderTooltip: 'Platzhaltertext eingeben',
      required: 'Pflichtfeld',
      requiredTooltip: 'Aktivieren, wenn das Feld erforderlich ist',
      value: 'Wert',
      enterTitle: 'Titel eingeben',
      addValue: 'Wert hinzufügen',
      delete: 'Löschen',
      update: 'Aktualisieren',
      add: 'Hinzufügen',
      confirmationPage: 'Bestätigungsaktion',
      confirmationPageSubtitle: 'Ergebnisaktion nach dem Absenden des Formulars wählen',
      successMessage: 'Erfolgsmeldung',
      successMessageTooltip: 'Erfolgsmeldung nach dem Absenden des Formulars',
      thankYou: 'Dankesnachricht',
      submit: 'Absenden',
    },
    contact: {
      blockTitle: 'Kontakte',
      blockText: 'Kontakte ermöglichen es Nutzern, direkt mit Ihnen zu kommunizieren. Fügen Sie Ihr Telefon, Ihre E-Mail, Ihren Messenger oder Ihren Standort hinzu',
      blockShortText: 'Mit Nutzern kommunizieren',
      addNewContact: 'Neuen Kontakt hinzufügen',
      newContact: 'Neuer Kontakt',
      friendlyName: 'Anzeigename',
    },
    faq: {
      blockTitle: 'FAQ',
      blockText: 'Häufig gestellte Fragen – eine Liste mit Antworten auf typische Fragen, die Nutzer stellen könnten',
      blockShortText: 'Häufige Fragen',
      addNewItem: 'Neues Element hinzufügen',
      editItem: 'Element bearbeiten',
      title: 'Titel',
      titleTooltip: 'Titel eingeben',
      description: 'Beschreibung',
      descriptionTooltip: 'Beschreibung eingeben',
      update: 'Aktualisieren',
      add: 'Hinzufügen',
      howToFind: 'So findest du uns',
      view: 'Ansicht',
      viewTooltip: 'Wähle, wie die FAQ-Einträge angezeigt werden',
      feed: 'Feed',
      slider: 'Slider',
      emptyTitle: 'Du hast noch keine Einträge',
      emptyText: 'Füge deine erste Frage hinzu, um diesen Block zu füllen.',
    },
    ama: {
      blockTitle: 'Frag mich alles',
      blockShortText: 'Fragen von Fans beantworten',
      blockText: 'Lass dein Publikum Fragen stellen und beantworte sie direkt auf deiner Seite',
    },
    feature: {
      blockTitle: 'Funktionen',
      blockText: 'Textabschnitt mit Bild, um deinen Nutzern zu zeigen, warum dein Unternehmen das Beste ist',
      blockShortText: 'Sag deinen Nutzern warum',
      title: 'Titel',
      titleTooltip: 'Titel des Elements ändern',
      description: 'Beschreibung',
      descriptionTooltip: 'Beschreibung des Elements ändern',
    },
    highlight: {
      blockTitle: 'Highlights',
      blockText: 'Hebe die wichtigsten Links mit Vorschaubildern hervor (bis zu 3)',
      blockShortText: 'Wichtigste hervorheben',
      title: 'Titel',
      titleTooltip: 'Titel des Elements ändern',
      url: 'URL',
      urlTooltip: 'URL des Elements ändern',
    },
    banner: {
      blockTitle: 'Banner',
      blockText: 'Hebe ein Bild, Video oder dein neuestes Produkt hervor. Du kannst einen CTA-Button hinzufügen, um Nutzer zu deinem Conversion-Ziel zu führen',
      blockShortText: 'Bild, Video hervorheben',
      height: 'Höhe',
      heightTooltip: 'Höhe des Banners ändern',
    },
    slider: {
      blockTitle: 'Slider',
      blockText: 'Bild-Karussell, mit dem du deine Bildinhalte präsentieren und verschiedene Funktionen hinzufügen kannst',
      blockShortText: 'Bild-Karussell',
      image: 'Bild',
      imageTooltip: 'Bild deiner Galerie',
      addText: 'Text hinzufügen',
      title: 'Titel',
      titleTooltip: 'Titel deines Slides',
      titleSize: 'Titelgröße',
      titleSizeTooltip: 'Wähle die Größe für bessere Lesbarkeit',
      description: 'Beschreibung',
      descriptionTooltip: 'Beschreibung deines Slides',
      textColor: 'Textfarbe',
      addButton: 'Button hinzufügen',
      url: 'URL',
      urlTooltip: 'URL deines Bildes',
      button: 'Button',
      buttonTooltip: 'Titel deines Buttons',
      buttonText: 'Button-Text',
      buttonColor: 'Button-Farbe',
      height: 'Höhe',
      heightTooltip: 'Höhe der Slides ändern',
      view: 'Ansicht',
      viewTooltip: 'Ansicht für den Slider wählen',
      auto: 'Auto',
      square: 'Quadrat',
      rectangle: 'Rechteck',
      single: 'Einzeln',
      multi: 'Mehrfach',
    },
    gallery: {
      blockTitle: 'Galerie',
      blockText: 'Bild-Karussell, mit dem du deine Bildinhalte präsentieren kannst',
      blockShortText: 'Bild-Karussell',
      image: 'Bild',
      imageTooltip: 'Bild deines Galerie-Elements',
      layout: 'Layout',
      layoutTooltip: 'Layout für die Galerie wählen',
      feed: 'Feed',
      slider: 'Slider',
    },
    blog: {
      blockTitle: 'Blog',
      blockText: 'Erstelle einen Blog aus deinen Beiträgen',
      blockShortText: 'Blog erstellen',
      writeYourStory: 'Schreibe deine Geschichte',
      shortDescription: 'Kurzbeschreibung',
      shortDescriptionTooltip: 'Optionale Beschreibung für deinen Blog',
      description: 'Beschreibung',
    },
    map: {
      blockTitle: 'Karte',
      blockText: 'Füge eine Google Map hinzu, damit Nutzer dein lokales Geschäft finden',
      blockShortText: 'Google Map hinzufügen',
      buttonText: 'Button-Text',
      buttonTextTooltip: 'Der Button erscheint, wenn die zweite Ansicht ausgewählt ist',
      text: 'Text',
      addAddress: 'Weitere Adresse hinzufügen',
      address: 'Adresse',
      addressTooltip: 'Füge zum Beispiel die Adresse aus Google Maps ein',
      googleMap: 'Google Map (Embed-Code)',
      googleMapTooltip: 'Füge den Embed-Code aus Google Maps ein',
      howToFind: 'So findest du den Embed-Code',
      incorrectCode: 'Ungültiger Embed-Code.',
      moreInfo: 'Weitere Informationen',
      code: 'Code',
      addressSettings: 'Adresseinstellungen',
      addressContent: 'Füge URL, Titel und Button-Text oder Icon hinzu',
      title: 'Titel',
      titleTooltip: 'Der Name deiner Adresse',
      url: 'URL',
      urlTooltip: 'Füge zum Beispiel die Adress-URL aus Google Maps ein',
      directionText: 'Wegbeschreibungstext',
      directionTextTooltip: 'Call-to-Action-Text für deine Nutzer',
    },
    footer: {
      blockTitle: 'Footer',
      blockText: 'Inhaltsbereich ganz am Ende einer Seite. Du kannst Kontaktinformationen, Social-Media-Icons und ein E-Mail-Anmeldeformular hinzufügen',
      blockShortText: 'Bereich für untere Inhalte',
      addBlock: 'Block hinzufügen',
      blockType: 'Blocktyp',
      blockTypeTooltip: 'Blocktyp auswählen',
      addBlockTitle: 'Blocktitel',
      addBlockTitleTooltip: 'Titel des Blocks auswählen',
      faq: 'FAQ',
      'data-collect': 'Datenerfassung',
      contact: 'Kontakt',
      pages: 'Seiten',
      payments: 'Zahlungen',
      social: 'Social',
      cancel: 'Abbrechen',
      add: 'Hinzufügen',
      None: 'Keine',
      link: 'Link',
      faqText: 'Du kannst häufig gestellte Fragen im FAQ-Block bearbeiten. Du gelangst dorthin, indem du hier klickst',
      socialText: 'Du kannst Social-Icons im Header-Block bearbeiten. Du gelangst dorthin, indem du hier klickst',
      dataCollectText: 'Du kannst die Datenerfassung im Datenerfassungs-Block bearbeiten. Du gelangst dorthin, indem du hier klickst',
      contactText: 'Du kannst den Kontakt im Kontakt-Block bearbeiten. Du gelangst dorthin, indem du hier klickst',
      pagesText: 'Du kannst neue Seiten auf der Website hinzufügen',
      paymentsText: 'Zahlungsmethoden werden angezeigt',
      showOnAllpages: 'Auf allen Seiten anzeigen',
      footerText: 'Der Footer der Startseite ist derzeit aktiviert.',
      editSocialIcons: 'Du kannst Social-Icons im Header-Bereich bearbeiten. Du gelangst dorthin, indem du hier klickst',
      editSubscribe: 'Du kannst das Abonnieren im Abonnieren-Bereich bearbeiten. Du gelangst dorthin, indem du hier klickst',
      editContacts: 'Du kannst die Kontakte im Kontakte-Bereich bearbeiten. Du gelangst dorthin, indem du hier klickst',
      editFrequently: 'Du kannst häufig gestellte Fragen im FAQ-Bereich bearbeiten. Du gelangst dorthin, indem du hier klickst',
      text: 'Text',
      image: 'Bild',
      divider: 'Trennlinie',
      linkViewLabel: 'Layout',
      linkViewTooltip: 'Wie die Links angeordnet sind',
      linkViewSingle: 'Gestapelt',
      linkViewRow: 'In einer Reihe',
      linkItemsLabel: 'Links',
      linkItemsTooltip: 'Füge bis zu 5 Links hinzu (z. B. Datenschutz, AGB)',
      linkLabelPlaceholder: 'Bezeichnung',
      linkUrlPlaceholder: 'URL',
      linkAddMore: '+ Link hinzufügen',
      alignLabel: 'Ausrichtung',
      alignTooltip: 'Horizontale Ausrichtung',
      alignLeft: 'Links',
      alignCenter: 'Zentriert',
      alignRight: 'Rechts',
      imageLabel: 'Bild',
      imageTooltip: 'Lade ein Logo oder Bild hoch',
      imageLinkLabel: 'Link (optional)',
      imageLinkTooltip: 'Mache das Bild anklickbar',
      dividerLabel: 'Trennlinien-Typ',
      dividerTooltip: 'Eine Linie oder ein Leerraum',
      dividerLine: 'Linie',
      dividerSpace: 'Leerraum',
      picker: {
        subtitle: 'Wähle ein Element für deine Fußzeile',
        configureSubtitle: 'Konfiguriere es und füge es deiner Fußzeile hinzu',
        back: 'Zurück',
        saveButton: 'Speichern',
        availableTitle: 'Zum Hinzufügen verfügbar',
        addedTitle: 'Bereits hinzugefügt',
        addedLabel: 'Hinzugefügt',
        addButton: 'Block hinzufügen',
        linkTitle: 'Links',
        linkSub: 'Buttons zu beliebigen URLs',
        socialTitle: 'Social',
        socialSub: 'Icons für deine Social-Profile',
        textTitle: 'Text',
        textSub: 'Eine Überschrift oder ein Absatz',
        pagesTitle: 'Seiten',
        pagesSub: 'Link zu verschachtelten Unterseiten',
        paymentsTitle: 'Zahlungen',
        paymentsSub: 'Akzeptierte Zahlungsmethoden',
        imageTitle: 'Bild',
        imageSub: 'Ein Logo oder Bild',
        dividerTitle: 'Trennlinie',
        dividerSub: 'Eine Linie oder ein Abstand',
        faqTitle: 'FAQ',
        faqSub: 'Häufig gestellte Fragen',
        dataCollectTitle: 'Datenerfassung',
        dataCollectSub: 'E-Mail-Anmeldeformular',
        contactTitle: 'Kontakt',
        contactSub: 'Kontaktdaten',
        importMode: 'Aus Block importieren',
        manualMode: 'Manuell hinzufügen',
        noContactsToImport: 'Keine Kontakte zum Importieren — füge sie manuell hinzu.',
        noSocialsToImport: 'Keine Social-Icons zum Importieren — füge sie manuell hinzu.',
        manualItemsLabel: 'Elemente',
        manualItemsTooltip: 'Wähle einen Typ und gib seinen Wert ein.',
        contactValuePlaceholder: '@nutzername / E-Mail / Telefon',
        socialUrlPlaceholder: 'https://...',
        addMore: '+ Mehr hinzufügen',
      },
      contactDesign: {
        editSource: 'Bearbeite die Kontakte selbst im Kontakt-Block —',
        variantLabel: 'Stil',
        variantList: 'Liste',
        variantButton: 'Button',
        shapeLabel: 'Form',
        shape_square: 'Quadratisch',
        shape_rounded: 'Abgerundet',
        shape_pill: 'Pille',
        widthLabel: 'Breite',
        widthFull: 'Voll',
        widthHalf: 'Halb',
        widthHalfStacked: 'Halbe Spalte',
        borderLabel: 'Rahmen',
        borderOn: 'An',
        borderOff: 'Aus',
        borderColorLabel: 'Rahmenfarbe',
      },
      layout: 'Layout',
      splitImage: 'Seitliches Bild',
    },
    'chat-ai': {
      blockTitle: 'KI-Chat',
      blockShortText: 'Mit KI chatten',
      blockText: 'Mit KI chatten',
      suggestionsTitle: 'Vorschläge',
      suggestionsSubtitle: 'Schnell-Prompts',
    },
    custom: {
      blockTitle: 'Benutzerdefiniert',
      blockShortText: 'KI-gestützte Mikro-App',
      blockText: 'Beschreibe eine kleine interaktive App und die KI erstellt sie für dich',
    },
    shop: {
      blockTitle: 'Shop',
      blockText: 'Füge deine Produktliste hinzu',
      blockShortText: 'Füge deine Produkte hinzu',
      view: 'Ansehen',
      products: 'Produkte',
      categories: 'Kategorien',
      cardLayout: 'Karten-Layout',
      cardLayoutTooltip: 'Im Showcase wird jedes Produkt als detaillierte Verkaufskarte dargestellt, eine pro Reihe',
      standardCards: 'Standard',
      showcaseCards: 'Showcase',
      featured: 'Hervorgehoben',
    },
    digital: {
      blockTitle: 'Digitale Produkte',
      blockText: 'Verkaufe digitale Downloads: PDFs, Tabellen, Vorlagen, Exklusives',
      blockShortText: 'Digitales verkaufen',
    },
    podcast: {
      blockTitle: 'Podcasts',
      blockText: 'Bewirb deine Podcasts',
      blockShortText: 'Bewirb deine Podcasts',
    },
    'page-list': {
      blockTitle: 'Seitenliste',
      blockText: 'Zeige eine Liste deiner Seiten mit Titeln und Beschreibungen für eine einfache Navigation an.',
      blockShortText: 'Liste deine Seiten auf.',
      description: 'Beschreibung',
      addNewPageItem: 'Seitenlink hinzufügen',
    },
    appointment: {
      blockTitle: 'Termine',
      blockText: 'Lass Besucher Zeit in deinem Kalender buchen',
      blockShortText: 'Lass Besucher buchen',
    },
    service: {
      blockTitle: 'Dienstleistungen',
      blockText: 'Du erhältst eine E-Mail-Benachrichtigung, wenn dir eine Anfrage gesendet wird',
      blockShortText: 'E-Mail erhalten',
    },
    requests: {
      blockTitle: 'Dienstleistungen',
      blockText: 'Du erhältst eine E-Mail-Benachrichtigung, wenn dir eine Anfrage gesendet wird',
      blockShortText: 'E-Mail erhalten',
    },
    tips: {
      blockTitle: 'Trinkgeld',
      blockText: 'UniLink macht Unterstützen einfach und unterhaltsam. Mit nur wenigen Taps können deine Fans bezahlen und eine Nachricht hinterlassen',
      blockShortText: 'Macht Unterstützen unterhaltsam',
    },
    tip: {
      blockTitle: 'Trinkgeld',
      blockText: 'UniLink macht Unterstützen einfach und unterhaltsam. Mit nur wenigen Taps können deine Fans bezahlen und eine Nachricht hinterlassen',
      blockShortText: 'Macht Unterstützen unterhaltsam',
    },
    donation: {
      blockTitle: 'Spenden',
      blockText: 'UniLink macht Unterstützen einfach und unterhaltsam. Mit nur wenigen Taps können deine Fans bezahlen und eine Nachricht hinterlassen',
      blockShortText: 'Macht Unterstützen unterhaltsam',
    },
    course: {
      blockTitle: 'Kurs oder Tutorial',
      blockText: 'Lass Besucher Zeit in deinem Kalender buchen',
      blockShortText: 'Lass Besucher buchen',
    },
    event: {
      blockTitle: 'Events oder Tickets',
      blockText: 'Lass dein Publikum deine Events besuchen',
      blockShortText: 'Lass dein Publikum kommen',
    },
    menu: {
      blockTitle: 'Menü',
      blockText: 'Erstelle ein einzigartiges Menü mit Preisen',
      blockShortText: 'Einzigartiges Menü erstellen',
    },
    recipe: {
      blockTitle: 'Rezept',
      blockText: 'Teile ein Rezept mit Zutaten, Schritten und Fotos',
      blockShortText: 'Rezept teilen',
    },
    booking: {
      blockTitle: 'Buchung',
      blockText: 'Lass Besucher deine Räume buchen',
      blockShortText: 'Lass Besucher buchen',
      name: 'Name',
      nameCaption: 'Gib den Namen des Raums ein',
      description: 'Beschreibung',
      descriptionCaption: 'Kurze Beschreibung für diesen Raum',
      rentalType: 'Mietart',
      rentalTypeCaption: 'Zum Beispiel: Wohnung, Auto, Büro',
      duration: 'Dauer',
      durationCaption: 'Zum Beispiel: pro Tag, pro Woche, pro Monat',
      price: 'Preis',
      priceCaption: 'Grundpreis für diesen Bereich',
      oldPrice: 'Alter Preis',
      oldPriceCaption: 'Optionaler vorheriger Preis',
      rating: 'Bewertung',
      ratingCaption: 'Durchschnittliche Bewertung (optional)',
      label: 'Label',
      labelCaption: 'Kurzes Badge wie HOT oder NEU',
      image: 'Bild',
      imageCaption: 'Lade ein Titelbild für diesen Bereich hoch',
      location: 'Standort',
      locationCaption: 'Stadt, Gegend oder Adresse',
      capacity: 'Kapazität (Gäste)',
      capacityCaption: 'Maximale Anzahl an Gästen',
      rooms: 'Zimmer & Fläche',
      roomsCaption: 'Schlafzimmer, Badezimmer und Fläche',
      bedrooms: 'Schlafzimmer',
      bathrooms: 'Badezimmer',
      areaSqM: 'Fläche (m²)',
      minStay: 'Mindestaufenthalt (Tage)',
      minStayCaption: 'Mindestanzahl an Tagen für die Buchung',
      requiresDeposit: 'Kaution erforderlich',
      depositAmount: 'Kautionsbetrag',
      depositAmountCaption: 'Vorauszahlung zur Bestätigung der Buchung',
      noSmoking: 'Rauchen verboten',
      noPets: 'Keine Haustiere',
      amenitiesWifi: 'Wi‑Fi',
      amenitiesParking: 'Parkplatz',
      amenitiesKitchen: 'Küche',
      amenitiesHeating: 'Heizung',
      amenitiesAC: 'Klimaanlage',
      amenitiesPool: 'Pool',
      amenitiesSauna: 'Sauna',
      amenitiesRestrooms: 'Toiletten',
      validationNameRequired: 'Name ist erforderlich',
      validationPriceRequired: 'Preis muss eine nicht‑negative Zahl sein',
      validationDepositRequired: 'Kautionsbetrag ist erforderlich, wenn Kaution aktiviert ist',
      validationCapacityNumber: 'Kapazität muss eine nicht‑negative Zahl sein',
      validationOldPriceNumber: 'Alter Preis muss eine nicht‑negative Zahl sein',
      brand: 'Marke',
      brandCaption: 'Automarke, z. B. Tesla',
      model: 'Modell',
      modelCaption: 'Automodell, z. B. Model 3',
      year: 'Jahr',
      yearCaption: 'Baujahr',
      color: 'Farbe',
      colorCaption: 'Außenfarbe, z. B. schwarz',
      fuelType: 'Kraftstoffart',
      fuelTypeCaption: 'Benzin, Diesel, Elektro, Hybrid usw.',
      transmission: 'Getriebe',
      transmissionCaption: 'Automatik oder Schaltgetriebe',
      seatCount: 'Sitzanzahl',
      seatCountCaption: 'Anzahl der Sitze im Auto',
      edit: 'Element bearbeiten',
      add: 'Element hinzufügen',
    },
    membership: {
      blockTitle: 'Mitgliedschaft',
      blockText: 'Erstelle ein kostenloses oder kostenpflichtiges Abonnement für deine Inhalte',
      blockShortText: 'Abonnement erstellen',
    },
    pricing: {
      blockTitle: 'Preisgestaltung',
      blockText: 'Erstelle ein einzigartiges Menü mit Preisen',
      blockShortText: 'Erstelle ein einzigartiges Menü',
      name: 'Name',
      nameTooltip: 'Gib den Namen deines Produkts ein',
      pricingPlanName: 'Name des Preisplans',
      pricingPlanNameTooltip: 'Gib den Namen deines Preisplans ein',
      description: 'Beschreibung',
      descriptionTooltip: 'Gib eine Beschreibung deines Produkts ein',
      pricingPlanDescriptionTooltip: 'Gib eine Beschreibung deines Preisplans ein',
      priceValue: 'Preiswert',
      priceUnit: 'Preiseinheit',
      label: 'Bezeichnung',
      labelTooltip: 'Gib die Bezeichnung deines Preisplans ein',
      orderButtonText: 'Text der Bestellschaltfläche',
      orderButtonTextDescriptionTooltip: 'Gib den Text der Bestellschaltfläche deines Preisplans ein',
      orderButtonLink: 'Link der Bestellschaltfläche',
      orderButtonLinkDescriptionTooltip: 'Gib den Link der Bestellschaltfläche deines Preisplans ein',
      subtitle: 'Untertitel',
      subtitleTooltip: 'Gib den Untertitel deines Produkts ein',
      price: 'Preis',
      priceTooltip: 'Gib den Preis deines Produkts ein',
      pricingTiers: 'Preisstufen',
      pricingTiersTooltip: 'Gib die Preisstufen deines Produkts ein',
      addPriceValue: 'Weiteren Preis hinzufügen',
      group: 'Gruppe',
      groupTooltip: 'Wähle die Gruppe deines Produkts',
      image: 'Bild',
      imageTooltip: 'Lade ein Bild für dein Produkt hoch',
      unit: 'Preiseinheit',
      unitTooltip: 'Gib die Einheit deines Preises ein',
      addUnitTitle: 'Preiseinheiten',
      addPriceUnitValue: 'Weitere Preiseinheit hinzufügen',
      addUnitButtonText: 'Speichern',
      button: 'Schaltfläche',
      buttonTooltip: 'Schaltfläche für dein Produkt hinzufügen',
      buttonAddText: '+ Schaltfläche hinzufügen',
      buttonModalTextField: 'Schaltflächentext',
      buttonModalTextFieldTooltip: 'Schaltflächentext eingeben',
      buttonModalURLField: 'Schaltflächen-URL',
      buttonModalURLFieldTooltip: 'Schaltflächen-URL eingeben',
      buttonModalTitle: 'Schaltfläche hinzufügen',
      groups: {
        title: 'Gruppen',
        subtitle: 'Gruppen hinzufügen, bearbeiten und löschen',
        groups: 'Gruppen',
        groupsTooltip: 'Gruppen hinzufügen, bearbeiten und löschen',
        addNewGroup: 'Neue Gruppe hinzufügen',
        newGroup: 'Neue Gruppe',
        titleGroup: 'Titel',
        titleGroupTooltip: 'Gib den Titel deiner Gruppe ein',
        descriptionGroup: 'Beschreibung',
        descriptionGroupTooltip: 'Gib eine Beschreibung deiner Gruppe ein',
      },
    },
    menuBlock: {
      title: 'Menü',
      subtitle: 'Erstelle ein Menü mit Artikeln und Preisen',
      add: 'Neuen Artikel hinzufügen',
      edit: 'Artikel bearbeiten',
      name: 'Name',
      nameCaption: 'Gib den Namen des Artikels ein',
      description: 'Beschreibung',
      descriptionCaption: 'Gib eine kurze Beschreibung ein',
      ingredients: 'Zutaten',
      ingredientsCaption: 'Zutaten oder Zusammensetzung auflisten',
      price: 'Preis',
      priceCaption: 'Preis eingeben',
      weight: 'Gewicht (g)',
      weightCaption: 'Gewicht in Gramm eingeben',
      calories: 'Kalorien (kcal)',
      caloriesCaption: 'Kalorien in kcal eingeben',
      label: 'Label',
      labelCaption: 'Label-Text eingeben',
      labelColor: 'Label-Farbe',
      labelColorCaption: 'Hintergrundfarbe für das Label wählen',
      image: 'Bild',
      imageCaption: 'Bild für deinen Artikel hochladen',
      available: 'Zur Bestellung verfügbar',
      visible: 'Auf Seite sichtbar',
    },
    nft: {
      blockTitle: 'NFT',
      blockText: 'NFT von OpenSea oder aus deiner persönlichen Wallet anzeigen',
      blockShortText: 'NFT anzeigen',
    },
    wallet: {
      wallet: 'Wallet',
      blockTitle: 'Bank-/Krypto-Wallet',
      blockText: 'Zeige deine Kreditkarte oder Bitcoin-Wallet an, damit deine Nutzer sie leicht kopieren und Geld überweisen können',
      blockShortText: 'Wallets anzeigen',
      title: 'Titel',
      titleTooltip: 'Titel deiner Wallet',
      walletNumber: 'Wallet-Nummer',
      walletNumberTooltip: 'Wallet-Nummer einfügen',
      icon: 'Symbol',
      iconTooltip: 'Symbol für deine Wallet festlegen',
      card: 'Karte',
      bank: 'Bank',
      crypto: 'Krypto',
      transfer: 'Überweisung',
      paymentLink: 'Zahlungslink',
      cardNumber: 'Kartennummer',
      cardNumberTooltip: 'Kartennummer einfügen',
      cardHolder: 'Karteninhaber',
      cardHolderTooltip: 'Karteninhaber eingeben',
      bankAccountDetails: 'Bankverbindung',
      bankAccountDetailsTooltip: 'Bankverbindung eingeben',
      walletAddress: 'Wallet-Adresse',
      walletAddressTooltip: 'Wallet-Adresse eingeben',
      network: 'Netzwerk',
      networkTooltip: 'Netzwerk eingeben',
      publicKey: 'Öffentlicher Schlüssel',
      publicKeyTooltip: 'Öffentlichen Schlüssel eingeben',
      providerName: 'Anbietername',
      providerNameTooltip: 'Anbietername eingeben',
      link: 'Link',
      linkTooltip: 'Link eingeben',
      serviceName: 'Dienstname',
      serviceNameTooltip: 'Dienstname eingeben',
      email: 'E-Mail',
      emailTooltip: 'E-Mail eingeben',
      phone: 'Telefon',
      phoneTooltip: 'Telefonnummer eingeben',
      username: 'Benutzername',
      usernameTooltip: 'Benutzernamen eingeben',
      fullName: 'Vollständiger Name',
      fullNameTooltip: 'Vollständigen Namen eingeben',
      referenceNumber: 'Referenznummer',
      referenceNumberTooltip: 'Gib deine Referenznummer ein',
      country: 'Land',
      countryTooltip: 'Gib dein Land ein',
      transferProvider: 'Überweisungsanbieter',
      transferProviderTooltip: 'Gib deinen Überweisungsanbieter ein',
      cryptoCurrency: 'Kryptowährung',
      cryptoCurrencyTooltip: 'Gib deine Kryptowährung ein',
    },
    instagram: {
      blockTitle: 'Instagram',
      blockText: 'Präsentiere deine besten Instagram-Medien und -Videos oder verkaufe deine Produkte mit einem shoppable Instagram-Feed',
      blockShortText: 'Deine besten Instagram-Medien',
      blockConnectTitle: 'Instagram ist nicht verbunden',
      blockConnectText: 'Es scheint, dass deine Instagram-Produkte noch nicht importiert wurden. Verbinde jetzt dein Konto',
      blockConnectButton: 'Instagram hinzufügen',
      emptyList: 'Du hast noch keine Instagram-Medien.',
      addInstagramUsername: 'Instagram-Benutzernamen hinzufügen',
      username: 'Benutzername',
      downloadTakes: 'Der Download dauert bis zu 2 Minuten',
      displayPost: 'Beitrag auf deiner Website anzeigen',
      view: 'Ansehen',
      redirect: 'URL-Weiterleitung',
      text: 'Text & Schaltfläche',
      actionType: 'Aktionstyp',
      url: 'URL',
      openInNewTab: 'In neuem Tab öffnen',
      delete: 'Löschen',
      cancel: 'Abbrechen',
      save: 'Speichern',
      editMedia: 'Medien bearbeiten',
      title: 'Titel',
      automation: 'Automatisierung',
      automationText: 'Automatisiere dein Konto mit Autopilot-Funktionen',
      autopilot: 'Autopilot',
      autopilotTooltip: 'Lade einen Beitrag mit der Beispielbeschriftung hoch und deine Produkt-Tags/Links werden automatisch generiert',
      switchTitle: 'Titel, Preis und Links automatisch erkennen',
      sampleCaption: 'Beispielbeschriftung: #49.99 #NiceDress https://google.com',
      integrations: 'Integrationen',
      integrationsText: 'Instagram zu deiner Website hinzufügen',
      connectInstagram: 'Instagram verbinden',
      connectInstagramText: 'Verbinde dein Instagram-Konto, um die Beiträge oder Reels deiner Wahl anzuzeigen.',
      selectAccount: 'Konto auswählen',
      connectNewInstagram: 'Neues Instagram-Konto verbinden',
      continue: 'Weiter',
      disconnectInstagram: 'Instagram trennen',
      addTag: 'Tag hinzufügen',
      tagClickHint: 'Klicke auf das Bild, um den Tag zu platzieren',
      tagPositionSet: 'Position festgelegt. Fülle die Details unten aus.',
      tagTypeLink: 'Link',
      tagTypeProduct: 'Produkt',
      tagLabel: 'Beschriftung',
      tagSelectProduct: 'Produkt auswählen',
    },
    tiktok: {
      blockTitle: 'TikTok',
      blockText: 'Präsentiere deine besten TikTok-Videos oder verkaufe deine Produkte mit einem shoppable TikTok-Feed',
      blockShortText: 'Deine besten TikTok-Videos',
      addTikTok: 'TikTok-Konto hinzufügen',
      individualVideo: 'Einzelnes Video',
      videoCollection: 'Videosammlung',
      add: 'Hinzufügen',
      blockConnectTitle: 'TikTok ist nicht verbunden',
      blockConnectText: 'Es scheint, dass deine TikTok-Produkte noch nicht importiert wurden. Verbinde jetzt dein Konto',
      blockConnectButton: 'TikTok verbinden',
      enterUsername: 'Benutzernamen eingeben',
      enterVideo: 'TikTok-Video-URL eingeben',
      emptyList: 'Du hast noch keine TikTok-Medien.',
      editMedia: 'Medien bearbeiten',
      addTikTokVideo: 'TikTok-Video hinzufügen',
      displayPost: 'Beitrag auf deiner Website anzeigen',
      delete: 'Löschen',
      cancel: 'Abbrechen',
      save: 'Speichern',
      integrations: 'Integrationen',
      integrationsText: 'TikTok zu deiner Website hinzufügen',
      connectTikTok: 'TikTok verbinden',
      disconnectTikTok: 'TikTok trennen',
      individualText: `Du kannst kein TikTok-Konto mit diesem Blocktyp ('individual') verbinden.`,
      individualText2: 'Bitte füge stattdessen ein einzelnes TikTok-Video hinzu.',
    },
    youtube: {
      blockTitle: 'YouTube',
      blockText: 'Zeige ein YouTube-Video oder einen Stream auf deiner Seite. Markiere Produkte im YouTube-Video',
      blockShortText: 'YouTube-Video hervorheben',
      enterYouTubeLink: 'YouTube-URL eingeben',
      enterYouTubeLinkTooltip: 'YouTube-URL einfügen',
    },
    overview: {
      blockTitle: 'Übersicht',
      blockText: 'Zeige ein Video oder einen Stream auf deiner Seite. Markiere Produkte im Video',
      blockShortText: 'Produkte im Video markieren',
    },
    video: {
      blockTitle: 'Video',
      blockText: 'Zeige ein Video oder einen Stream auf deiner Seite. Markiere Produkte im Video',
      blockShortText: 'Video hervorheben',
    },
    twitter: {
      blockTitle: 'X (Twitter)',
      blockText: 'Zeige deine Tweets auf deiner UniLink-Seite, um das Engagement zu steigern',
      blockShortText: 'Deine Tweets anzeigen',
      twitterURL: 'Twitter-URL',
      twitterURLTooltip: 'URL von Twitter hinzufügen, um eingebetteten Code zu generieren',
      enterTwitterURL: 'Twitter-URL eingeben',
    },
    music: {
      blockTitle: 'Musik',
      blockText: 'Spotify- oder SoundCloud-Song, Playlist einbetten oder eigene Audiodatei hochladen',
      blockShortText: 'Deine Musik hinzufügen',
      brand: 'Marke',
      brandTooltip: 'Typ zum Hinzufügen deiner Musik auswählen',
      url: 'URL',
      embed: 'Embed-Code',
      custom: 'Benutzerdefiniert',
      musicUrl: 'Musik-URL',
      musicUrlTooltip: 'Musik-URL eingeben',
      embedCodeTitle: 'Embed-Code',
      embedCodeTooltip: 'Embed-Code deines Songs von der gewählten Musikplattform einfügen',
      audioFile: 'Audiodatei',
      uploadAudios: 'Hier kannst du nur Audio hochladen',
      title: 'Titel',
      titleTooltip: 'Titel deiner Musik eingeben',
      artist: 'Künstler',
      artistTooltip: 'Künstler deiner Musik eingeben',
      audioFileTitle: 'Audiodatei',
      audioFileTooltip: 'Name deiner Audiodatei',
      coverImage: 'Coverbild',
      coverImageTooltip: 'Bild für deine Musik hochladen',
    },
    twitch: {
      blockTitle: 'Twitch',
      blockText: 'Twitch-Video oder -Stream auf deiner Seite einbetten',
      blockShortText: 'Twitch-Video einbetten',
      twitchURL: 'Twitch-URL',
      twitchURLTooltip: 'Kanal-URL oder Kanalnamen einfügen',
      twitchTV: 'twitch.tv/...',
      displayTwitch: 'Meinen Twitch-Kanal anzeigen',
      displayChat: 'Sowohl meinen Twitch-Kanal als auch den Chat anzeigen',
    },
    splash: {
      blockTitle: 'Splash-Screen',
      blockText: 'Vollbild-Banner mit Text und Button, das vor dem Laden der Seite erscheint, um ein Produkt oder Event zu bewerben',
      blockShortText: 'Vollbild-Banner',
    },
    promo: {
      blockTitle: 'Promo-Leiste',
      blockText: 'Highlight, mit dem du Aktionen anzeigen kannst',
      blockShortText: 'Hebe deine Aktionen hervor',
    },
    welcome: {
      blockTitle: 'Willkommensnachricht',
      blockText: 'Schreibe Willkommensnachrichten, die Besucher zum Chatten anregen. Sie erscheint am unteren Seitenrand, um Besucher zu begrüßen und Hilfe anzubieten',
      blockShortText: 'Willkommensnachrichten schreiben',
    },
    review: {
      blockTitle: 'Bewertungen',
      blockText: 'Bewertungen helfen Kunden, mehr über das Produkt zu erfahren und zu entscheiden, ob es das richtige Produkt für sie ist',
      blockShortText: 'Bewertungen helfen Kunden',
      name: 'Name',
      nameTooltip: 'Name des Rezensenten eingeben',
      comment: 'Kommentar',
      commentTooltip: 'Kommentar des Rezensenten eingeben',
      date: 'Datum',
      dateTooltip: 'Datum des Rezensenten eingeben',
      rate: 'Bewertung',
      rateTooltip: 'Bewertung festlegen',
      image: 'Bild',
      imageTooltip: 'Bild des Rezensenten hochladen',
    },
    coupon: {
      blockTitle: 'Gutscheine',
      blockText: 'Ein Online-Gutschein ist ein Rabattcode oder eine Nummer, die auf einer Website eingelöst werden kann',
      blockShortText: 'Online-Gutschein',
    },
    timer: {
      blockTitle: 'Timer',
      blockText:
        'Ein Countdown-Timer ist eine virtuelle Uhr auf einer Seite, die von einer bestimmten Zahl oder einem Datum herunterzählt, um den Beginn oder das Ende eines Events oder Angebots anzuzeigen',
      blockShortText: 'Ein Countdown-Timer',
    },
    outfit: {
      blockTitle: 'Outfits',
      blockText: 'Erstelle deine eigene Produktliste',
      blockShortText: 'Produktliste erstellen',
    },
    spacer: {
      blockTitle: 'Abstandhalter',
      blockText: 'Füge deiner Seite etwas leeren vertikalen Raum hinzu',
      blockShortText: 'Etwas Leerraum hinzufügen',
    },
    html: {
      blockTitle: 'HTML-Code',
      blockText:
        'Du kannst deinen eigenen HTML-Code in die UniLink-Seite einfügen. HTML ist eine Standard-Markup-Sprache zur Erstellung von Webseiten. Sie erlaubt iframes, Sections, Absätze und Links.',
      blockShortText: 'Eigenen HTML-Code einfügen',
      markupCode: 'Markup-Code',
      markupCodeTooltip: 'Markup-Code deines HTML einfügen',
      strippedWarning: 'Aus Sicherheitsgründen bei der Anzeige entfernt:',
    },
    unlock: {
      blockTitle: 'Freischalten',
      blockText: 'Sperre Inhalte hinter einem Passwort, einer E-Mail, Zahlung oder benutzerdefinierten Regeln. Perfekt für exklusive Inhalte und kostenpflichtigen Zugang.',
      blockShortText: 'Inhalte sperren.',
    },
    file: {
      blockTitle: 'Datei',
      blockText:
        'Dieser Block ermöglicht es dir, Dateien wie Dokumente, Bilder oder Audio hochzuladen und zu teilen. Besucher können sie direkt von deiner Seite aus einfach ansehen oder herunterladen.',
      blockShortText: 'Lade deine Dateien hoch und teile sie.',
      addNewItem: 'Neue Datei hinzufügen',
      editFile: 'Datei bearbeiten',
      fileName: 'Dateinamen eingeben',
    },
    stat: {
      blockTitle: 'Statistiken',
      blockText:
        'Dieser Block ermöglicht es dir, wichtige Einblicke zu deiner Seite anzuzeigen, wie Aufrufe, Besucher oder Engagement. Er hilft dir, dein Publikum zu beobachten und zu verstehen, wie deine Seite performt.',
      blockShortText: 'Statistiken zu deiner Seite hinzufügen.',
      addNewItem: 'Neue Statistik hinzufügen',
      editItem: 'Statistik bearbeiten',
      statName: 'Namen der Statistik eingeben',
      statValue: 'Wert der Statistik eingeben',
      statDescription: 'Beschreibung der Statistik eingeben',
      statItemFields: 'Wähle die anzuzeigenden Felder aus.',
      feed: 'Feed',
      slider: 'Slider',
      titleSize: 'Titelgröße',
      subtitleTitleSize: 'Du kannst die Titelgröße ändern',
    },
    listing: {
      blockTitle: 'Auflistung',
      blockText: 'Zeige Immobilien- oder Artikelangebote mit Bildern, Details und Preisen.',
      blockShortText: 'Füge Angebote zu deiner Seite hinzu.',
    },
    rental: {
      blockTitle: 'Vermietung',
      blockText: 'Liste Mietobjekte oder Artikel mit Verfügbarkeit und Preisen pro Zeitraum auf.',
      blockShortText: 'Füge Vermietungen zu deiner Seite hinzu.',
    },
    'single-product': {
      blockTitle: 'Einzelprodukt',
      blockText: 'Präsentiere ein einzelnes Produkt mit Bild, Beschreibung und Kauf-Button.',
      blockShortText: 'Präsentiere ein Produkt.',
    },
    team: {
      blockTitle: 'Team',
      blockText: 'Stelle deine Teammitglieder mit Fotos, Namen, Rollen und Social Links vor.',
      blockShortText: 'Zeige dein Team.',
    },
    timetable: {
      blockTitle: 'Stundenplan',
      blockText: 'Zeige einen Wochenplan mit Kursen, Veranstaltungen oder Sitzungen.',
      blockShortText: 'Füge einen Wochenplan hinzu.',
    },
    wall: {
      blockTitle: 'Wall',
      blockShortText: 'Nachrichten von Besuchern sammeln',
      blockText: 'Zeige eine öffentliche Wall, auf der Besucher Nachrichten hinterlassen und mit deinen Inhalten interagieren können',
    },
    'live-stream': {
      blockTitle: 'Live-Stream',
      blockShortText: 'Gehe auf deiner Seite live',
      blockText: 'Streame live an dein Publikum — nativ über unsere Plattform oder bette YouTube / Twitch ein',
    },
    workout: {
      blockTitle: 'Workout',
      blockShortText: 'Workouts teilen & verkaufen',
      blockText: 'Poste ein strukturiertes Workout — Übungen mit Sätzen, Wiederholungen und Demovideos. Verkaufe es oder teile es kostenlos',
    },
    videoFeedback: {
      blockTitle: 'Video-Feedback',
      blockShortText: 'Video-Testimonials sammeln',
      blockText: 'Sammle kurze Video-Testimonials und Feedback von deinem Publikum',
    },
    'premium-inbox': {
      blockTitle: 'Premium-Posteingang',
      blockShortText: 'Bezahlte Nachrichten von Fans',
      blockText: 'Lass Fans dir bezahlte Nachrichten und Anfragen direkt an deinen Premium-Posteingang senden',
    },
    'order-form': {
      blockTitle: 'Bestellformular',
      blockShortText: 'Bestellungen über deine Seite sammeln',
      blockText: 'Sammle Bestellungen direkt über deine Seite mit einem anpassbaren Bestellformular',
    },
  },
  pinnedDock: {
    title: 'Angepinnte Blöcke',
    label: 'ANGEPINNT',
    expand: 'Angepinnte Blöcke ausklappen',
    collapse: 'Angepinnte Blöcke einklappen',
  },
  reviewButton: {
    title: 'Bewertungs-Button',
    desc: 'Zeige unter den Bewertungen einen Button, der Besucher dorthin führt, wo sie eine Bewertung abgeben können.',
    buttonText: 'Button-Text',
    link: 'Link',
    leaveReview: 'Bewertung abgeben',
    googleHint: 'Leer lassen, um deine Google-Bewertungsseite zu verwenden.',
    design: 'Button-Design',
    background: 'Hintergrund',
    textColor: 'Text',
  },
  themeTokens: {
    title: 'Theme-Stil',
    subtitle: 'Typografie, Ecken und Abstände',
    typography: 'Typografie',
    corners: 'Ecken',
    density: 'Dichte',
  },
  advancedDesign: {
    title: 'Erweitert',
    subtitle: 'Jeden Teil fein abstimmen',
    slot_title: 'Titel',
    slot_description: 'Beschreibung',
    slot_label: 'Kurzlabel',
    fontSize: 'Schriftgröße',
    fontWeight: 'Stärke',
    textTransform: 'Groß-/Kleinschreibung',
    textAlign: 'Ausrichtung',
    color: 'Farbe',
  },
  layoutPicker: {
    title: 'Layout',
    tooltip: 'Wähle, wie Elemente angeordnet werden',
    layout_list: 'Liste',
    layout_grid: 'Raster',
    layout_cards: 'Karten',
  },
  importDesign: {
    title: 'Design importieren',
    subtitle: 'Ein Design aus einem Screenshot nachbauen',
    upload: 'Screenshot hochladen',
    extracting: 'Wird analysiert…',
    apply: 'Auf Seite anwenden',
    applying: 'Wird angewendet…',
    blocksCount: '+{n} Blöcke',
    applied: 'Design angewendet – {n} Blöcke hinzugefügt',
  },
  adminUi: {
    podcastEnterShowTitle: 'Titel der Show eingeben',
    podcastMaximum: 'Maximal',
    podcastCharacters: 'Zeichen',
    podcastShowTitleExists: 'Eine Show mit diesem Titel existiert bereits',
    podcastEditShow: 'Show bearbeiten',
    podcastNewShow: 'Neue Show',
    podcastCover: 'Cover',
    podcastTitle: 'Titel',
    podcastShowTitlePlaceholder: 'Titel der Show',
    podcastCategory: 'Kategorie',
    podcastCategoryPlaceholder: 'z. B. True Crime',
    podcastDescription: 'Beschreibung',
    podcastDescriptionPlaceholder: 'Worum geht es in dieser Show…',
    podcastSubscribeButtons: '„Abonnieren“-Buttons',
    podcastAddPlatform: 'Plattform hinzufügen',
    podcastSave: 'Speichern',
    podcastCreate: 'Erstellen',
    episodeOne: 'Folge',
    episodeFew: 'Folgen',
    episodeMany: 'Folgen',
    edit: 'Bearbeiten',
    delete: 'löschen',
    addShow: 'Show hinzufügen',
    importFromRss: 'Aus RSS importieren',
    importFromRssFeed: 'Aus RSS-Feed importieren',
    importFromRssHint: 'Füge einen Podcast-RSS-Link ein — die Folgen werden automatisch in eine neue Show übernommen.',
    import: 'Importieren',
    trackWordOne: 'Track',
    trackWordFew: 'Tracks',
    trackWordMany: 'Tracks',
    albumLabel: 'Album',
    pause: 'Pause',
    play: 'Abspielen',
    emptyTracks: 'Noch keine Tracks in diesem Album',
    untitled: 'Ohne Titel',
    show: 'Show',
    audioFileNotAttached: 'Audiodatei nicht angehängt',
    paypalConnectionTitle: 'PayPal-Verbindungsmethode wählen',
    paypalConnectionSubtitle: 'Wähle die für dich passendste Verbindungsmethode',
    paypalRecommendedBadge: 'Empfohlen',
    paypalPartnerTitle: 'Über PayPal Partner',
    paypalPartnerFeatureQuickConnect: 'Schnelle Verbindung mit 1 Klick',
    paypalPartnerFeatureAutoTokens: 'Automatische Token-Aktualisierung',
    paypalPartnerFeatureMostSecure: 'Sicherste Methode',
    paypalPartnerFeatureNoApiKeys: 'Kein Kopieren von API-Schlüsseln nötig',
    paypalPartnerButton: 'Über Partner verbinden',
    paypalDirectTitle: 'Direkt (API-Zugangsdaten)',
    paypalDirectFeatureClientIdSecret: 'Erfordert Client ID und Secret',
    paypalDirectFeatureManualSetup: 'Manuelle Einrichtung',
    paypalDirectFeatureFullControl: 'Volle Kontrolle über die API',
    paypalDirectFeatureAdvancedUsers: 'Für fortgeschrittene Nutzer',
    paypalDirectButton: 'Direkt verbinden',
    clientIdRequired: 'Client ID ist ein Pflichtfeld',
    clientSecretRequired: 'Client Secret ist ein Pflichtfeld',
    invalidPaypalCredentials: 'Ungültige PayPal-Zugangsdaten',
    connectPaypalDirectly: 'PayPal direkt verbinden',
    paypalConnectedSuccessfully: 'PayPal erfolgreich verbunden!',
    yourPaypalClientId: 'Deine PayPal Client ID aus dem Dashboard',
    yourPaypalClientSecret: 'Dein PayPal Client Secret aus dem Dashboard',
    chooseOperatingMode: 'Betriebsmodus wählen',
    sandboxTest: 'Sandbox (Test)',
    liveProduction: 'Live (Produktion)',
    whereToFindCredentials: '💡 Wo finde ich die Zugangsdaten?',
    goTo: 'Gehe zu',
    createOrSelectApp: 'Erstelle eine neue App oder wähle eine vorhandene',
    copyClientIdAndSecret: 'Kopiere die Client ID und das Secret',
    cancel: 'Abbrechen',
    connected: 'Verbunden!',
    connect: 'Verbinden',
    monobankTokenTooltip: 'Token aus Monobank Business Acquiring',
    monobankTokenPlaceholder: 'Monobank-Token eingeben',
    whereToGetToken: 'Wo bekomme ich den Token?',
    statusChangedTo: 'Status geändert zu',
    all: 'Alle',
    loading: 'Wird geladen...',
    noBookingsYet: 'Noch keine Buchungen',
    noBookingsWithStatus: 'Keine Buchungen mit diesem Status',
    nightsAbbr: 'Nächte',
    uah: 'UAH',
    oneNightDeposit: 'Anzahlung für eine Nacht',
    fullPrepayment: 'Vollständige Vorauszahlung',
    online: 'Online',
    confirm: 'Bestätigen',
    complete: 'Abschließen',
    restore: 'Wiederherstellen',
    bookingCalendarBooked: 'Gebucht',
    bookingCalendarBlockedManually: 'Manuell blockiert',
    bookingCalendarAvailable: 'Verfügbar',
    bookingCalendarNoSettings: 'Keine Einstellungen',
    bookingCalendarSaveItemFirst: 'Zuerst Element speichern',
    bookingCalendarLoading: 'Wird geladen...',
    bookingCalendarBlocked: 'Blockiert',
    bookingCalendarSelected: 'Ausgewählt',
    bookingCalendarSelectedDates: 'Ausgewählte Daten',
    bookingCalendarPricePerDay: 'Preis/Tag',
    bookingCalendarOpen: 'Öffnen',
    bookingCalendarBlock: 'Blockieren',
    bookingCalendarCancel: 'Abbrechen',
    responseDeleted: 'Antwort gelöscht',
    deleteAllConfirm: 'Alle Antworten löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
    allResponsesDeleted: 'Alle Antworten gelöscht',
    responseOne: 'Antwort',
    responseFew: 'Antworten',
    responseMany: 'Antworten',
    deleteAll: 'Alle löschen',
    allForms: 'Alle Formulare',
    noResponsesYet: 'Noch keine Antworten',
    fieldName: 'Name',
    fieldPhone: 'Telefon',
    fieldAddress: 'Adresse',
    fieldComment: 'Kommentar',
    customFields: 'Zusätzliche Felder',
    more: 'Mehr',
    view: 'Ansehen',
    track: 'Verfolgen',
    showing: 'Angezeigt',
    of: 'von',
    ordersLower: 'Bestellungen',
    ordersEmpty: 'Noch keine Einträge',
    ordersCountLabel: 'Einträge',
    ordersName: 'Name',
    ordersPhone: 'Telefon',
    ordersLoading: 'Wird geladen...',
    ordersComment: 'Kommentar',
    ordersPayment: 'Zahlung',
    ordersPrev: 'Zurück',
    ordersNext: 'Weiter',
    revokeAccessConfirm: 'Zugriff widerrufen?',
    accessRevoked: 'Zugriff widerrufen',
    activeGrants: 'aktive Berechtigungen',
    noActiveGrants: 'Keine aktiven Berechtigungen',
    type: 'Typ',
    grantedBy: 'Erteilt von',
    started: 'Gestartet',
    until: 'Bis',
    revoke: 'Widerrufen',
    deleted: 'Gelöscht',
    subscribers: 'Abonnenten',
    noSubscribersYet: 'Noch keine Abonnenten',
    phone: 'Telefon',
    name: 'Name',
    step: 'Schritt',
    done: 'fertig',
    stepFailedSingular: 'Schritt fehlgeschlagen',
    stepFailedPlural: 'Schritte fehlgeschlagen',
    done2: 'Fertig.',
    actionFailed: 'Aktion konnte nicht ausgeführt werden.',
    starterCoffeeSite: 'Erstelle eine Website für ein Café',
    starterFaq: 'Füge einen FAQ-Block mit 5 Fragen hinzu',
    starterTranslate: 'Übersetze die ganze Website ins Englische',
    starterBrandColors: 'Wähle passende Farben für meine Marke',
    stopped: 'Gestoppt.',
    scopeSite: 'Website',
    scopePage: 'Seite',
    followUpAddPhoto: 'Ein weiteres Foto hinzufügen',
    followUpAddQuestion: 'Weitere Frage hinzufügen',
    followUpAddPlan: 'Weiteren Tarif hinzufügen',
    followUpAddService: 'Weiteren Dienst hinzufügen',
    followUpAddBlock: 'Einen weiteren Block hinzufügen',
    followUpMakeBetter: 'Mach es noch besser',
    followUpTweakColors: 'Passe die Farben an meine Marke an',
    followUpChangeColors: 'Farben ändern',
    followUpTranslateEnglish: 'Ins Englische übersetzen',
    undoneDeletedPrefix: 'Rückgängig gemacht — entfernt',
    undoneOf: 'von',
    undoneCreatedBlocks: 'erstellte Blöcke',
    planAnalyzing: 'Anfrage wird analysiert',
    planCheckingSite: 'Website-Status wird geprüft',
    planChoosingBlocks: 'Blöcke werden ausgewählt',
    planPreparing: 'Plan wird vorbereitet',
    hideDetails: 'Details ausblenden',
    details: 'Details',
    emptyStateTitle: 'Wie kann ich helfen?',
    emptyStateSubtitle: 'Beschreibe, was zu tun ist — oder wähle ein Beispiel unten',
    undoing: 'Wird rückgängig gemacht…',
    undo: 'Rückgängig',
    blockSingular: 'Block',
    blockPlural: 'Blöcke',
    usageCostTitle: 'Kosten dieser Anfrage',
    tokens: 'Tokens',
    stop: 'Stopp',
    scopeSiteTitle: 'Änderungen an der gesamten Website',
    scopePageTitle: 'Änderungen nur auf der aktuellen Seite',
    customDesign: 'Individuelles Design',
    appointmentEmbedTitle: 'Embed-URL',
    appointmentEmbedSubtitle: 'Calendly als eingebettetes iframe anzeigen',
    appointmentEmbedCaption: 'Calendly-URL',
    appointmentEmbedTooltip: 'Füge deine Calendly-Event-URL ein (z. B. https://calendly.com/you/30min)',
    appointmentEmbedInvalid: 'Gib eine gültige Calendly-URL ein (z. B. https://calendly.com/you/30min)',
  },
  ama: {
    questions: 'Fragen',
    all: 'Alle',
    unanswered: 'Unbeantwortet',
    answered: 'Beantwortet',
    loading: 'Wird geladen...',
    noQuestions: 'Noch keine Fragen',
    anonymous: 'Anonym',
    noName: 'Kein Name',
    yourAnswer: 'Deine Antwort',
    edit: 'Bearbeiten',
    delete: 'Löschen',
    cancel: 'Abbrechen',
    enterAnswer: 'Gib deine Antwort ein...',
    saveAnswer: 'Antwort speichern',
    confirmDelete: 'Diese Frage löschen?',
    answerSaved: 'Antwort gespeichert',
    deleted: 'Gelöscht',
  },
  adsManager: {
    estimatedAudience: 'Geschätzte Zielgruppengröße',
    audienceTooLarge: 'Deine Zielgruppe ist sehr breit — grenze sie besser ein.',
    audienceTooNarrow: 'Deine Zielgruppe ist sehr klein — erweitere sie besser.',
    audience: 'Zielgruppe',
    suggestedAudience: 'Vorgeschlagene Zielgruppe verwenden',
    suggestedAudienceHint: 'Breites Targeting, ideal für Reichweite',
    buildYourOwn: 'Eigene erstellen',
    buildYourOwnHint: 'Alter, Geschlecht und Länder festlegen',
    expectedViewers: 'Erwartete Anzeigen-Betrachter',
    totalBudget: 'Gesamtbudget der Kampagne',
    duration: 'Dauer',
    days: 'Tage',
    advancedSchedule: 'Erweiterter Zeitplan',
    hideAdvanced: 'Erweiterten Zeitplan ausblenden',
    adPreview: 'Anzeigenvorschau',
    sponsored: 'Gesponsert',
    seeMore: 'Mehr anzeigen',
    learnMore: 'Mehr erfahren',
    yourPage: 'Deine Seite',
  },
  virtualBackgrounds: {
    title: 'Virtuelle Hintergründe',
    canvasSize: 'Canvas-Größe',
    fmtCall: 'Zoom · Teams · Meet',
    fmtStories: 'Stories · Reels',
    fmtSquare: 'Quadratisch',
    fmtClassic: 'Klassisch',
    background: 'Hintergrund',
    bg_color: 'Farbe',
    bg_gradient: 'Farbverlauf',
    bg_photo: 'Foto',
    bg_pattern: 'Muster',
    from: 'Von',
    to: 'Bis',
    angle: 'Winkel',
    ink: 'Tinte',
    paper: 'Papier',
    blur: 'Weichzeichnen',
    darken: 'Abdunkeln',
    presets: 'Vorlagen',
    uploadImage: 'Bild hochladen',
    removeImage: 'Bild entfernen',
    replace: 'Ersetzen',
    remove: 'Entfernen',
    photoPlaceholder: 'Lade ein Bild über das Panel hoch',
    overlay: 'Overlay',
    showName: 'Namen anzeigen',
    namePlaceholder: 'Dein Name',
    subtitlePlaceholder: 'Untertitel / Handle',
    typeface: 'Schriftart',
    textColour: 'Textfarbe',
    nameSizeLabel: 'Namensgröße',
    position: 'Position',
    showQr: 'QR-Code anzeigen',
    qrPlaceholder: 'https://link',
    style: 'Stil',
    qrCard: 'Karte',
    qrBrand: 'Marke',
    qrLight: 'Hell',
    qrSolid: 'Vollflächig',
    qrSizeLabel: 'QR-Größe',
    logo: 'Logo / Avatar',
    uploadLogo: 'Logo hochladen (PNG)',
    logoSizeLabel: 'Logo-Größe',
    finishing: 'Feinschliff',
    vignette: 'Vignette',
    vignetteHint: 'Weiche dunkle Ränder für mehr Tiefe',
    shuffle: 'Mischen',
    reset: 'Zurücksetzen',
    dragHint: 'Ziehe Name, QR oder Logo auf dem Canvas, um sie neu zu positionieren',
    preparing: 'Wird vorbereitet…',
    download: 'Herunterladen',
    sizeHint: 'Gespeichert als 1920 × 1080 JPG',
  },
  emailSignatures: {
    title: 'E-Mail-Signaturen',
    details: 'Details',
    name: 'Name',
    jobTitle: 'Position',
    company: 'Unternehmen',
    email: 'E-Mail',
    phone: 'Telefon',
    website: 'Website',
    style: 'Stil',
    styleModern: 'Modern',
    styleClassic: 'Klassisch',
    styleMinimal: 'Minimal',
    styleBold: 'Fett',
    styleCard: 'Karte',
    accent: 'Akzentfarbe',
    showAvatar: 'Foto anzeigen',
    showQr: 'QR-Code anzeigen',
    preview: 'Vorschau',
    copySignature: 'Signatur kopieren',
    copyHtml: 'HTML kopieren',
    copied: 'Signatur kopiert',
    copiedHtml: 'HTML kopiert',
    instructions: {
      gmail: 'Gmail: Einstellungen → Alle Einstellungen anzeigen → Allgemein → Signatur → Neu erstellen, dann einfügen (Strg/Cmd+V) und Änderungen speichern.',
      outlook:
        'Outlook: Datei → Optionen → E-Mail → Signaturen → Neu, dann einfügen. Neues Outlook / Web: Einstellungen → E-Mail → Verfassen und Antworten → in das Signaturfeld einfügen.',
      apple: 'Apple Mail: Mail → Einstellungen → Signaturen → Signatur hinzufügen, dann einfügen. Deaktiviere „Immer meine Standard-Nachrichtenschrift verwenden“.',
    },
  },
};
